/* ════════════════════════════════════════════════════════════════
   ISODASH MINI-CART  (v10.6.46-dev)
   ────────────────────────────────────────────────────────────────
   Slide-in-Sidebar rechts mit dem aktuellen Shopify-Warenkorb.
   – Fetch via Shopify Ajax Cart API (/cart.js, /cart/change.js)
   – Read-only Mengen (Flaschenzahl folgt dem berechneten Bohrplan)
   – "Zeile entfernen" via POST /cart/change.js { line, quantity:0 }
   – "Sanierung neu berechnen" entfernt nur Sanierungspakete; separate
     Einzelflaschen bleiben im Warenkorb.
   – Dev-Fallback (localhost): synthetisiert einen Demo-Cart aus
     IsoDash.Calculations.getFinalAnalysis(), damit UI lokal testbar
     bleibt. Im Demo-Mode wirken Remove-Aktionen nur auf den Panel-
     State, nicht auf Shopify.

   Public API:
     window.IsoDashMiniCart.open()
     window.IsoDashMiniCart.close()
     window.IsoDashMiniCart.refresh()
   ════════════════════════════════════════════════════════════════ */
(function (w) {
  'use strict';

    var _heroBlurbAktiv = false;   /* v496.6: Banner traegt die Berechnung bereits */
  var PANEL_ID = 'isodash-mini-cart';

  /* ═══════════════════════════════════════════════════════════════════
     v528 — ZWEI LAYOUTS IN EINER DATEI

     Björn (11.09.): „kann man dann beide behalten? dass ich hin und her
     schalten kann im Notfall und wir den alten nicht einfach ersetzen?"

     Bewusst KEINE zweite Datei. Der Drawer hat 79 Funktionen und rund
     2.300 Zeilen, davon ist nur ein knappes Viertel Markup — Gutscheine,
     Gratis-Handbuch-Abgleich, Wand-Nummerierung, Versand-Stichzeit,
     Mengenrabatt und fünf Ereignisse sind Logik. Zwei Dateien hieße:
     jeden künftigen Fehler zweimal beheben und irgendwann übersieht man
     einen. Deshalb teilt sich alles die Logik; verzweigt wird nur dort,
     wo tatsächlich HTML entsteht (zwei Stellen) plus eigenes CSS.

     Umschalten, von schnell nach dauerhaft:
       1. ?drawer=v2 an jede URL hängen — merkt sich die Wahl
       2. In der Konsole: __ISO_DRAWER__.set('v1')
       3. window.ISO_DRAWER_LAYOUT = 'v2' im Theme (theme.liquid)
       4. Voreinstellung unten
     ═══════════════════════════════════════════════════════════════════ */
  var LAYOUT_KEY = '__ISO_DRAWER_LAYOUT__';
  var LAYOUT_STD = 'v2';                 /* Voreinstellung seit v554 (25.09.2026, Freigabe Nutzer): v2 für alle.
                                            Zurück zu v1: hier 'v1' eintragen oder ?drawer=v1 */
  var _layout = null;

  function layoutLesen() {
    if (_layout) return _layout;
    var v = null;
    /* 1 · URL gewinnt und wird gemerkt — so kann Björn einen Link verschicken */
    try {
      var m = (w.location.search || '').match(/[?&]drawer=(v1|v2)\b/);
      if (m) { v = m[1]; try { w.localStorage.setItem(LAYOUT_KEY, v); } catch (e1) {} }
    } catch (e2) {}
    /* 2 · gemerkte Wahl */
    if (!v) { try { var g = w.localStorage.getItem(LAYOUT_KEY); if (g === 'v1' || g === 'v2') v = g; } catch (e3) {} }
    /* 3 · Theme-Vorgabe */
    if (!v && (w.ISO_DRAWER_LAYOUT === 'v1' || w.ISO_DRAWER_LAYOUT === 'v2')) v = w.ISO_DRAWER_LAYOUT;
    /* ── 3b · Zuteilung für den Test (v532, Prüfung 17.09.) ──────────────────
       BEFUND: Ohne diesen Block gibt es keinen Test, sondern eine
       Selbstauswahl. Jeder Besucher bekam v1; v2 nur, wer von Hand
       ?drawer=v2 anhängte. Damit war _lay_v1 kein Testarm, sondern der
       Auffangtopf für alle — und jede Auswertung wertlos.

       AUS im Auslieferungszustand. Björn schaltet den Test scharf, indem er
       in layout/theme.liquid VOR dem Drawer-Script setzt:
           window.ISO_DRAWER_TEST = true;
       Erst dann wird gewürfelt. Solange der Schalter fehlt, verhält sich
       alles exakt wie bisher.

       Einmal gewürfelt, dann fest: das Ergebnis landet im selben
       localStorage-Schlüssel wie eine manuelle Wahl. Ein Gerät bleibt
       dadurch in seinem Arm — sonst landete dieselbe Sitzung mit dem Nenner
       im einen und dem Zähler im anderen Arm. */
    if (!v && w.ISO_DRAWER_TEST === true) {
      try {
        v = (Math.random() < 0.5) ? 'v1' : 'v2';
        w.localStorage.setItem(LAYOUT_KEY, v);
      } catch (e4) { v = null; }
    }
    _layout = v || LAYOUT_STD;
    return _layout;
  }
  function istV2() { return layoutLesen() === 'v2'; }

  var CSS_ID   = 'isodash-mini-cart-css';
  var ISOFIN_VARIANT = '55049427616117';
  /* v611 (Adrian 15.10.): Wert des Gratis-Messgeräts (durchgestrichen in der Schublade) –
     gleich dem Vergleichspreis des Produkts „Feuchtigkeitsmessgerät – Gratis“ (79,00 €).
     Bei einer Preisänderung zusammen mit dem Admin pflegen. */
  var MG_WERT_CENT = 7900;
  /* v612 (Adrian 15.10.): Garantie-Siegel – dasselbe Bild wie bisher in den Zusicherungen
     unter dem Kaufknopf; steht jetzt an der Sanierungspaket- und Einzelflaschen-Zeile.
     &width=60: das Original ist 500 × 363 px / 14,3 KB; für 20 px Anzeige reicht die dreifache
     Breite (scharf auch auf 3×-Bildschirmen), 0,7 KB statt 14,3 KB je Abruf (gemessen). */
  var GARANTIE_BILD = 'https://cdn.shopify.com/s/files/1/0846/5550/5691/files/gempages_549688892727493681-ed944d56-1955-4f21-afc0-3833bb9b7397.gif?v=1752759375&width=60';

  /* v488 (Björn 16.07.): Express-/Wallet-Buttons im MiniCart AUS.
     Das vollzieht die v451-Entscheidung (nur 6 von 274 Checkout-Starts = 2 %
     liefen ueber Express) endlich auch hier: v451 hat damals nur
     sections/cart-drawer.liquid auf include_express:false gesetzt — der
     MiniCart holt sich die Buttons aber SELBST per fetch('?sections=cart-drawer')
     und greift #CartDrawer-DynamicCheckout heraus, komplett am Schalter vorbei.
     Shop Pay + Google Pay standen dadurch bis heute unbemerkt live im Warenkorb.
     Ersatz ist die unklickbare Zahlungslogo-Zeile (mountPayLogos) — die zeigt
     auch Zahlarten ohne Wallet-Button (PayPal, Kreditkarte).
     Die Wallets erscheinen ohnehin oben auf der ersten Checkout-Seite wieder.
     ROLLBACK = hier auf true. */
  var MC_EXPRESS = false;

  var _panel    = null;
  var _open     = false;
  var _cartData = null;
  var _busy     = false;
  /* v341: Rabattcode NUR noch aus Shopify-Aktivierung (discount_code-Cookie, z. B. Hendrik-Links
     via /discount/CODE). KEIN Eingabefeld mehr im Drawer (senkte die Cart→Checkout-Quote).
     _coupon = {code} — reine Anzeige + Gesamtrabatt-Integration. */
  var _coupon   = null;
  var _couponEntfernt = false;   /* v501: Nutzer hat den Code bewusst entfernt */
  var MC_COUPONS = { 'hendrik5': { t: 'p', v: 5, m: 0 }, 'hendrik!10': { t: 'p', v: 10, m: 0 }, 'hendrik!100': { t: 'f', v: 10000, m: 100000 }, 'neuewand5': { t: 'p', v: 5, m: 0 } };
  function mcCouponSaved(code, baseCents) {
    if (!code) return 0;
    var c = MC_COUPONS[code] || MC_COUPONS[String(code).toLowerCase()];
    if (!c) return -1;
    if (baseCents < (c.m || 0)) return 0;
    if (c.t === 'p') return Math.round(baseCents * c.v / 100);
    return Math.min(c.v, baseCents);
  }

  /* ── Tracking (v503, Dev-Auftrag 14.08.) ───────────────────────
     Der Drawer feuerte bisher kein Oeffnen-Ereignis — dadurch fehlte die Basis,
     um den Absturz "Warenkorb -> Kasse" von 22,6 % auf 16,4 % einzuordnen.
     Bewusst logr3Track zuerst: das ist der einzige global sichere Weg. isoTrack
     und die data-iso-track-Delegation kommen aus snippets/iso-track.liquid und
     werden nur auf einzelnen Templates gerendert — der Drawer laeuft aber auf
     JEDER Seite.
     Logr3 liefert Payload-Parameter nicht aus, also steckt alles im Namen.
     ACHTUNG: In dieser IIFE gibt es kein d — immer document. schreiben. */
  var _autoOeffnung = false;
  var _oeffnungsQuelle = '';

  /* ── v531 (Lücke 1+2 vor dem Test) ──────────────────────────────
     Bisher trugen ALTE und NEUE Schublade dieselben Ereignisnamen. Ein Test
     zwischen beiden wäre damit nicht auswertbar gewesen — man hätte gesehen,
     dass geklickt wird, aber nicht in welcher Fassung.
     Jedes Drawer-Ereignis feuert deshalb zusätzlich mit Layout-Endung.
     Logr3 liefert Payload-Parameter nicht aus, also muss es in den NAMEN.
     Doppelzählung ist gewollt: der Basisname bleibt für die Zeitreihe
     unverändert, die Endung ist die Aufschlüsselung. */
  function mcSend(n) {
    if (typeof w.logr3Track === 'function') { w.logr3Track(n, { step: true }); return; }
    if (typeof w.isoTrack === 'function') { w.isoTrack(n, { step: true }); }
  }
  function mcLayout() { try { return istV2() ? 'v2' : 'v1'; } catch (_e) { return 'v1'; } }
  function mcTrack(name) {
    try {
      mcSend(name);
      mcSend(name + '_lay_' + mcLayout());
    } catch (_eT) {}
  }
  /* Auf welcher Seite steht der Kunde, wenn er den Warenkorb öffnet?
     Grob gebündelt — einzelne Produkt- und Seiten-Handles würden die
     Ereignisliste sprengen, ohne etwas zu beantworten. */
  function mcSeite() {
    try {
      var pf = String(w.location.pathname || '').toLowerCase();
      if (pf === '' || pf === '/') return 'start';
      if (pf.indexOf('/pages/kalkulator') === 0) return 'kalkulator';
      if (pf.indexOf('/products/') === 0) return 'produkt';
      if (pf.indexOf('/collections/') === 0) return 'kategorie';
      if (pf.indexOf('/pages/') === 0) return 'seite';
      return 'sonst';
    } catch (_e) { return 'sonst'; }
  }

  /* ── Utils ────────────────────────────────────────────────── */
  /* v277: Versandzeit (kompakt repliziert aus iso-shipping-box.js — der Drawer ist global,
     das Original-Script ist nur auf Startseite/Produkt geladen). Cutoff 10:00 Berlin, WE-aware.
     02.10.2026 (Paket 0, Gegenprüfung): Do–Sa ab 22/23 Uhr stand „Versand So" —
     tzNow() liefert Berliner Uhrzeit schon als UTC-Felder, isWe() rechnete ein
     zweites Mal nach Berlin um, und cutUTC() hing am Browser-Offset (Schluss
     effektiv 12/11/10 Uhr je nach Sommerzeit/Browser). Jetzt nur noch
     getUTC-/setUTC-Aufrufe, fester Schluss 12 Uhr Berlin (wie page.horizontalsperre
     „bis 12 Uhr"), Feiertage Niedersachsen. Gleiche Rechnung in
     26-isowiz-step-4-sec-02.js — nur gemeinsam ändern. */
  function mcShipETA() {
    try {
      var TZ = 'Europe/Berlin', CUT = 12;
      /* hour % 24: manche Chrome-Fassungen melden Mitternacht als „24". */
      function tzNow() {
        var f = new Intl.DateTimeFormat('de-DE', { timeZone: TZ, hour12: false, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' });
        var pp = f.formatToParts(new Date());
        function g(t) { return Number(pp.find(function (x) { return x.type === t; }).value); }
        return new Date(Date.UTC(g('year'), g('month') - 1, g('day'), g('hour') % 24, g('minute'), g('second')));
      }
      function cutUTC(base) { var d = new Date(base); d.setUTCHours(CUT, 0, 0, 0); return d; }
      /* Ostersonntag (Gauß/Meeus) für die beweglichen Feiertage. */
      function ostern(y) {
        var a = y % 19, b = Math.floor(y / 100), c = y % 100, e = (19 * a + b - Math.floor(b / 4) - Math.floor((b - Math.floor((b + 8) / 25) + 1) / 3) + 15) % 30;
        var l = (32 + 2 * (b % 4) + 2 * Math.floor(c / 4) - e - (c % 4)) % 7, m = Math.floor((a + 11 * e + 22 * l) / 451), n = e + l - 7 * m + 114;
        return Date.UTC(y, Math.floor(n / 31) - 1, (n % 31) + 1);
      }
      /* Kein Versand: Wochenende und gesetzliche Feiertage Niedersachsen
         (Versand ab Bad Salzdetfurth) – 1.1., Karfreitag, Ostermontag, 1.5.,
         Himmelfahrt, Pfingstmontag, 3.10., 31.10., 25./26.12. */
      function frei(d) {
        var x = d.getUTCDay(); if (x === 0 || x === 6) return true;
        var y = d.getUTCFullYear(), md = (d.getUTCMonth() + 1) * 100 + d.getUTCDate();
        if (md === 101 || md === 501 || md === 1003 || md === 1031 || md === 1225 || md === 1226) return true;
        var t = Math.round((Date.UTC(y, d.getUTCMonth(), d.getUTCDate()) - ostern(y)) / 864e5);
        return t === -2 || t === 1 || t === 39 || t === 50;
      }
      var now = tzNow(), ship = new Date(now), todayCut = cutUTC(now);
      if (!frei(now) && now < todayCut) { ship = todayCut; }
      else { ship.setUTCDate(ship.getUTCDate() + 1); while (frei(ship)) { ship.setUTCDate(ship.getUTCDate() + 1); } ship = cutUTC(ship); }
      var ms = Math.max(0, ship - now), mins = Math.floor(ms / 60000), h = Math.floor(mins / 60), m = mins % 60;
      /* v528 (Björn 15.09.): Die Zeile soll einzeilig bleiben — bei vollem
         Monatsnamen plus „18 Std. 49 Min." braucht sie gemessen 280 px, es
         stehen aber nur 271 zur Verfügung, also brach sie um. Ab einer vollen
         Stunde entfallen deshalb die Minuten: „noch 18 Std." misst 235 px und
         passt im schlechtesten Fall (Montag, September, 23 Std.) mit Reserve.
         Die Minuten stehen weiter da, wo sie etwas bedeuten — in der letzten
         Stunde vor dem Annahmeschluss. Abgerundet, nie aufgerundet. */
      var left = h > 0 ? (h + ' Std.') : (m + ' Min.');
      var wdL = new Intl.DateTimeFormat('de-DE', { weekday: 'short', timeZone: 'UTC' }).format(ship);
      var day = ship.getUTCDate();
      /* v528: Monat abgekürzt. Bei vollem Namen brach die Zeile auf 360 px um —
         Datum und Restzeit sind fett (700), und Fettschrift baut breiter als eine
         Messung im Normalschnitt vermuten lässt.
         NICHT über Intl month:'short': Chrome liefert für de-DE „Sep" ohne Punkt,
         das ist die ICU-Kurzform, nicht die deutsche. Deutsche Kurzformen setzen
         den Punkt und lassen die kurzen Monate ausgeschrieben. Deshalb eigene
         Tabelle, angesteuert über den Monatsindex in der Zeitzone Berlin. */
      var MON_KURZ = ['Jan.', 'Feb.', 'M\u00e4rz', 'Apr.', 'Mai', 'Juni', 'Juli', 'Aug.', 'Sept.', 'Okt.', 'Nov.', 'Dez.'];
      var mon = MON_KURZ[ship.getUTCMonth()];
      /* v528 (Björn): Wortlaut aus dem Entwurf — „Versand Fr, 11. September bei
         Bestellung in 2 Minuten". Kürzer als „· Bestellung innerhalb …" und
         es liest sich als Bedingung statt als Countdown. Der Trennpunkt fällt
         weg, der Satz läuft durch. Nur v2; v1 behält seinen Wortlaut. */
      var datumH = '<b>' + wdL + ', ' + day + '. ' + mon + '</b>';
      var restH  = '<span class="mc-ship-in">' + left + '</span>';
      /* v528 (Björn 15.09.): kürzer. Seine Fassung „bestellen in 1 Std. 47 Min."
         spart nur 4 Zeichen und liest sich als Aufforderung („bestellen Sie in
         …") statt als Frist. „· noch" spart 11 Zeichen und sagt eindeutig, wie
         viel Zeit bleibt: 58 → 47 Zeichen. */
      /* Aktion Paket 2, Nachbesserung 04.10. (Prüfung Ansicht S4): In der Aktion steht über dem
         Kassenknopf schon die Angebotsfrist. Eine zweite Frist „noch 50 Std.“ läse sich leicht als
         Angebotsende. Ab 24 Std. (Wochenende) deshalb nur das Datum, wie sec-02 auf der
         Ergebnisseite. Außerhalb der Aktion unverändert. */
      if (h >= 24 && _akAktiv()) return '🚚 Versand ' + datumH;
      return istV2()
        ? '🚚 Versand ' + datumH + ' \u00b7 noch ' + restH
        : '🚚 Versand ' + datumH + ' · Bestellung innerhalb ' + restH;
    } catch (_) { return ''; }
  }

  function formatEuro(cents) {
    var v = Number(cents || 0) / 100;
    return v.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '\u00A0€';
  }

  /* v236.2: HTML-Escape für Cart-Properties (User-Input könnte enthalten sein) */
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function isLocalDev() {
    try {
      var h = location.hostname || '';
      return location.protocol === 'file:' ||
             h === 'localhost' || h === '127.0.0.1' || h.indexOf('.local') !== -1;
    } catch (_) { return false; }
  }

  /* ── Shopify Ajax Cart API ────────────────────────────────── */
  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r && r.ok ? r.json() : null; })
      .catch(function () { return null; })
      .then(function (cart) {
        if (cart && cart.items) return cart;
        /* Dev-Fallback */
        if (isLocalDev()) return buildDemoCart();
        return { items: [], total_price: 0, item_count: 0 };
      });
  }

  function postRemove(lineIdx) {
    if (_cartData && _cartData._demo) {
      /* Dev: lokale Mutation */
      var items = (_cartData.items || []).slice();
      items.splice(lineIdx - 1, 1);
      var total = items.reduce(function (s, it) { return s + (it.final_line_price || it.line_price || 0); }, 0);
      var cnt   = items.reduce(function (s, it) { return s + (it.quantity || 0); }, 0);
      return Promise.resolve({ items: items, total_price: total, item_count: cnt, _demo: true });
    }
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ line: lineIdx, quantity: 0 })
    }).then(function (r) { return r && r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  /* ── Wall-Blurb (personalisierte Zeile über dem Item) ──────
     Liefert z.B. "8 m Horizontalsperre" oder "6,5 m² Flächensperre".
     Liest aus dem Shell-Derivat, das bereits lengthM/isSide/surfaceAreaM2 liefert. */
  function getWallBlurb() {
    /* Weg 1: Dashboard-Huelle (nur auf dem Dashboard vorhanden). */
    try {
      var d = null;
      if (w.IsoDashShell && typeof w.IsoDashShell.tbDerived === 'function') {
        var p = (w.IsoDashShell.moduleStore && typeof w.IsoDashShell.moduleStore.get === 'function')
                ? w.IsoDashShell.moduleStore.get() : {};
        d = w.IsoDashShell.tbDerived(p);
      }
      if (d && d.hasAnalysis) {
        var isSide = !!d.isSide;
        var label  = isSide ? 'Fl\u00e4chensperre' : 'Horizontalsperre';
        var num, unit;
        if (isSide && d.surfaceAreaM2 && isFinite(d.surfaceAreaM2)) {
          num = d.surfaceAreaM2; unit = 'm\u00B2';
        } else if (d.lengthM && isFinite(d.lengthM)) {
          num = d.lengthM; unit = 'm';
        } else {
          return label;
        }
        var str = (num % 1 === 0) ? num.toFixed(0) : num.toFixed(1).replace('.', ',');
        return str + '\u00A0' + unit + ' ' + label;
      }
    } catch (_e1) {}

    /* Weg 2 (v496.4, Björn 28.07.): Warenkorb-Eigenschaft.
       Weg 1 haengt allein an IsoDashShell — die existiert auf normalen
       Shop-Seiten nicht, weshalb der Banner "Exakt berechnet fuer Ihre Wand"
       dort NIE erschien. Der Kalkulator legt die Angaben aber ohnehin als
       Line-Item-Property ab (26-isowiz-cart.js:288), z.B.
       "4,5 Meter Horizontalsperre \u00b7 2 Ecken \u00b7 36 cm Wandstaerke". */
    try {
      var items = (_cartData && _cartData.items) || [];
      for (var bi = 0; bi < items.length; bi++) {
        var pr = items[bi] && items[bi].properties;
        if (!pr) continue;
        for (var k in pr) {
          if (!Object.prototype.hasOwnProperty.call(pr, k)) continue;
          if (String(k).toLowerCase().indexOf('berechnung') === -1) continue;
          var v = String(pr[k] || '').replace(/^\s*Berechnung\s*:\s*/i, '').trim();
          if (v) return v;
        }
      }
    } catch (_e2) {}
    return null;
  }

  function buildDemoCart() {
    try {
      if (w.IsoDash && w.IsoDash.Calculations && typeof w.IsoDash.Calculations.getFinalAnalysis === 'function') {
        var a = w.IsoDash.Calculations.getFinalAnalysis();
        if (a && Number(a.calculatedBottles) > 0) {
          var bottles = Math.max(1, Math.round(a.calculatedBottles));
          var totalC  = Math.round((a.totalPriceIsofin || 0) * 100);
          var unitC   = Math.round(totalC / bottles);
          /* Original-Preis (ohne Staffel) f\u00fcr strike-through */
          var origUnitC = Math.round((w.IsoDash.Calculations.getOriginalPrice
            ? w.IsoDash.Calculations.getOriginalPrice()
            : 19.90) * 100);
          var origTotalC = origUnitC * bottles;
          return {
            items: [{
              key: 'demo-line-1',
              variant_id: ISOFIN_VARIANT,
              product_title: 'Isofin\u00ae Trockene W\u00e4nde',
              title: 'Isofin\u00ae Trockene W\u00e4nde',
              quantity: bottles,
              price: unitC,
              original_line_price: origTotalC,
              line_price: origTotalC,
              final_line_price: totalC,
              image: 'https://cdn.shopify.com/s/files/1/0846/5550/5691/files/sanierungspaket-isofin-500px-1x1.jpg?v=1768280218'
            }],
            total_price: totalC,
            original_total_price: origTotalC,
            item_count: bottles,
            _demo: true
          };
        }
      }
    } catch (_) {}
    return { items: [], total_price: 0, item_count: 0, _demo: true };
  }

  /* \u2500\u2500 Mengenrabatt-Helper \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
     Berechnet pro Item Original-Preis vs. Staffel-Preis und gibt zur\u00fcck,
     ob ein Rabatt aktiv ist. Funktioniert mit Shopify-Cart-Items UND
     mit unserem internen Calculations-Engine. */
  function getItemDiscount(item) {
    var qty = item.quantity || 0;
    var finalPrc = item.final_line_price != null ? item.final_line_price : (item.line_price || 0);
    var origPrc  = item.original_line_price != null ? item.original_line_price : item.line_price;
    /* Wenn Shopify keinen original_line_price liefert ODER kein Rabatt erkennbar \u2192
       eigene Staffel-Berechnung als Backup (nur f\u00fcr Isofin-Variant). */
    var calc = w.IsoDash && w.IsoDash.Calculations;
    var isIsofin = String(item.variant_id) === ISOFIN_VARIANT;
    /* Aktion Paket 2 (04.10.2026): in der Aktion nur Shopify-Zahlen — die eigene Staffel könnte
       sonst bei fehlendem Shopify-Rabatt 18,90 € zeigen, während die Kasse 19,90 € verlangt. */
    if (!_akAktiv() && calc && typeof calc.getDiscountInfo === 'function' && isIsofin && qty > 0) {
      var info = calc.getDiscountInfo(qty);
      var origCents  = Math.round(info.originalTotal * 100);
      var finalCents = Math.round(info.finalTotal * 100);
      /* Wenn Shopify den Brutto-Preis hat (origPrc \u2248 originalTotal), aber wir
         laut Staffel rabattieren \u2192 finalPrc auf Staffel-Wert korrigieren. */
      if (info.hasDiscount && Math.abs(finalPrc - origCents) < 50) {
        finalPrc = finalCents;
      }
      /* Original-Preis ggf. erg\u00e4nzen, falls Shopify ihn nicht liefert. */
      if (origPrc == null || origPrc < finalPrc) {
        origPrc = origCents;
      }
    }
    if (origPrc == null) origPrc = finalPrc;
    var hasDiscount = origPrc > finalPrc;
    return {
      qty: qty,
      finalPrc: finalPrc,
      origPrc: origPrc,
      saved: hasDiscount ? (origPrc - finalPrc) : 0,
      hasDiscount: hasDiscount
    };
  }

  /* ── Aktion Paket 2 (04.10.2026, BAULISTE Abschnitt 6) ─────────────────────
     Aktionszustand allein aus window.ISO_AKTION (layout/theme.liquid). In der Aktion gilt im
     Warenkorb als Vergleichswert die Summe der Staffelpreise (Menge × normalpreisCent), nicht
     der Listenpreis 19,90 € — bei 50 Fl. also 945,00 / −150,00 statt 995,00 / −200,00
     (Gegenprüfung Nr. 3). Das nur, wenn Shopify den Aktionsrabatt (Titel = rabattTitel) wirklich
     zugeteilt hat; fehlt er, bleibt die Anzeige wie bisher (keine Aktionsersparnis), Logr3
     aktion_rabatt_fehlt einmal je Sitzung, in der Vorschau ein roter Hinweis.
     Außerhalb der Aktion ändert sich nichts. Hier IIFE 1: nur document., nie d. */
  function _akAktiv() {
    try {
      var a = w.ISO_AKTION;
      return (a && typeof a.istAktiv === 'function' && typeof a.normalpreisCent === 'function' && a.istAktiv()) ? a : null;
    } catch (_eAk) { return null; }
  }
  function _akIsofinZeile(it) {
    var v = String(it && it.variant_id);
    return v === ISOFIN_VARIANT || v === '55868037857653';
  }
  function _akZuteilung(cart, ak) {
    try {
      var t = String((ak && ak.rabattTitel) || '').replace(/^\s+|\s+$/g, '').toLowerCase();
      if (!t || !cart) return false;
      var gleich = function (x) { return String(x || '').replace(/^\s+|\s+$/g, '').toLowerCase() === t; };
      var items = cart.items || [];
      for (var i = 0; i < items.length; i++) {
        var al = (items[i] && items[i].line_level_discount_allocations) || [];
        for (var j = 0; j < al.length; j++) {
          var da = al[j] && al[j].discount_application;
          if (da && gleich(da.title) && (al[j].amount || 0) > 0) return true;
        }
        var ds = (items[i] && items[i].discounts) || [];
        for (var k = 0; k < ds.length; k++) if (ds[k] && gleich(ds[k].title) && (ds[k].amount || 0) > 0) return true;
      }
      var ca = cart.cart_level_discount_applications || [];
      for (var m = 0; m < ca.length; m++) if (ca[m] && gleich(ca[m].title)) return true;
    } catch (_eZ) {}
    return false;
  }
  var _akFehltGemeldet = false;
  function _akRabattFehlt(cart, ak) {
    if (_akFehltGemeldet) return;
    _akFehltGemeldet = true;
    try {
      if (typeof ak.messenErlaubt === 'function' && !ak.messenErlaubt()) return;
      if (w.sessionStorage.getItem('__ISO_AKTION_RABATT_FEHLT__')) return;
      w.sessionStorage.setItem('__ISO_AKTION_RABATT_FEHLT__', '1');
    } catch (_eS) {}
    try { if (typeof w.logr3Track === 'function') w.logr3Track('aktion_rabatt_fehlt', { step: true, summe_cent: (cart && cart.total_price) || 0 }); } catch (_eL) {}
  }

  function getCartTotals(cart) {
    if (!cart || !cart.items || !cart.items.length) {
      return { final: 0, original: 0, saved: 0, hasDiscount: false };
    }
    var _ak = _akAktiv();
    if (_ak) {
      var _hatIsofin = false;
      for (var _zi = 0; _zi < cart.items.length; _zi++) if (_akIsofinZeile(cart.items[_zi]) && (cart.items[_zi].quantity || 0) > 0) _hatIsofin = true;
      if (_hatIsofin && _akZuteilung(cart, _ak)) {
        /* Nachbesserung 04.10. (Prüfung Technik M1): Die Shopify-Mengenrabatte zählen die
           Gesamtmenge über ALLE Isofin-Zeilen (Sanierungspaket + Einzelflaschen, mehrere Wände).
           Der Staffelpreis als Vergleichswert kommt deshalb aus der Gesamtmenge Q, nicht aus der
           Menge der einzelnen Zeile (Wand 1: 30 + Wand 2: 30 Fl. = 18,90 €, nicht 19,90 €). */
        var _akQ = 0;
        cart.items.forEach(function (it) { if (_akIsofinZeile(it) && (it.quantity || 0) > 0) _akQ += it.quantity; });
        var vgl = 0;
        cart.items.forEach(function (it) {
          var q = it.quantity || 0;
          if (_akIsofinZeile(it) && q > 0) vgl += _ak.normalpreisCent(_akQ) * q;
          else vgl += getItemDiscount(it).origPrc;
        });
        var fin = cart.total_price != null ? cart.total_price : 0;
        if (cart.total_price == null) cart.items.forEach(function (it) { fin += getItemDiscount(it).finalPrc; });
        return { final: fin, original: Math.max(vgl, fin), saved: Math.max(0, vgl - fin), hasDiscount: vgl > fin, aktion: true };
      }
      if (_hatIsofin && !cart._demo) _akRabattFehlt(cart, _ak);
    }
    var fSum = 0, oSum = 0;
    cart.items.forEach(function (it) {
      var d = getItemDiscount(it);
      fSum += d.finalPrc;
      oSum += d.origPrc;
    });
    /* Bevorzugt Shopify's gemeldete Werte, wenn verf\u00fcgbar */
    if (cart.total_price != null) fSum = cart.total_price;
    if (cart.original_total_price != null && cart.original_total_price > fSum) {
      oSum = cart.original_total_price;
    }
    return {
      final: fSum,
      original: Math.max(oSum, fSum),
      saved: Math.max(0, oSum - fSum),
      hasDiscount: oSum > fSum
    };
  }

  /* ── CSS ─────────────────────────────────────────────────── */
  function injectCSS() {
    if (document.getElementById(CSS_ID)) return;
    var p = '#' + PANEL_ID;
    var st = document.createElement('style');
    st.id = CSS_ID;
    /* Alle Layout-Props mit !important gegen GemPages/Shopify-Theme-Resets.
       Das Mini-Cart muss themeunabhängig konsistent rendern. */
    var I = ' !important';
    st.textContent = [
      /* ─── Shell ─────────────────────────────────────────── */
      p + '{position:fixed'+I+';inset:0'+I+';z-index:99999'+I+';pointer-events:none'+I+';font-family:inherit'+I+';font-variant-numeric:tabular-nums'+I+'}',
      p + ' *{box-sizing:border-box'+I+'}',
      p + ' .mc-backdrop{position:absolute'+I+';inset:0'+I+';background:radial-gradient(ellipse at top right,rgba(10,10,12,.30) 0%,rgba(10,10,12,.16) 80%)'+I+';opacity:0'+I+';transition:opacity .3s ease'+I+';pointer-events:none'+I+'}',
      p + ' .mc-panel{position:absolute'+I+';top:0'+I+';right:0'+I+';bottom:0'+I+';width:440px'+I+';max-width:92vw'+I+';background:var(--ds-surface,#fff)'+I+';color:var(--ds-text,#111)'+I+';box-shadow:-16px 0 48px rgba(0,0,0,.18),-2px 0 8px rgba(0,0,0,.08)'+I+';transform:translateX(105%)'+I+';transition:transform .35s cubic-bezier(.4,0,.2,1)'+I+';display:flex'+I+';flex-direction:column'+I+';pointer-events:auto'+I+';border-left:1px solid var(--ds-border,rgba(0,0,0,.08))'+I+';margin:0'+I+'}',
      p + '.mc-open .mc-backdrop{opacity:1'+I+';pointer-events:none'+I+'}',
      /* Desktop: Backdrop nicht abdunkeln & nicht abfangen → Hauptseite bleibt scroll- & klickbar (Seitenpanel). Schließen via X. */
      '@media (min-width:521px){' + p + '.mc-open .mc-backdrop{background:none'+I+';backdrop-filter:none;-webkit-backdrop-filter:none;pointer-events:none'+I+'}}',
      p + '.mc-open .mc-panel{transform:translateX(0)'+I+'}',

      /* ─── Header ────────────────────────────────────────── */
      /* v291: Header in Brand-Rot abgesetzt; bewusst feste Farben (kein --ds-*), damit Dark-Mode ihn nicht kippt */
      p + ' .mc-head{display:flex'+I+';align-items:center'+I+';justify-content:space-between'+I+';gap:14px'+I+';padding:11px 20px 10px'+I+';border:none'+I+';border-bottom:1px solid rgba(0,0,0,.10)'+I+';flex-shrink:0'+I+';background:linear-gradient(180deg,#D6001C 0%,#B8001A 100%)'+I+';margin:0'+I+'}',
      p + ' .mc-head-title{display:flex'+I+';flex-direction:row'+I+';align-items:baseline'+I+';flex-wrap:wrap'+I+';gap:3px 9px'+I+';min-width:0'+I+';padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-head-title h3{margin:0'+I+';padding:0'+I+';font-size:18px'+I+';font-weight:700'+I+';color:#fff'+I+';line-height:1.2'+I+';letter-spacing:-.01em'+I+';border:none'+I+'}',
      p + ' .mc-head-sub{font-size:12px'+I+';color:rgba(255,255,255,.85)'+I+';font-weight:500'+I+';line-height:1.2'+I+';white-space:nowrap'+I+';padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-close{display:inline-flex'+I+';align-items:center'+I+';justify-content:center'+I+';width:44px'+I+';height:44px'+I+';background:#fff'+I+';border:1px solid #e4e0d9'+I+';border-radius:50%'+I+';color:#1a1a1a'+I+';cursor:pointer'+I+';transition:background .18s,color .18s'+I+';flex-shrink:0'+I+';padding:0'+I+';margin:0'+I+';font-family:inherit'+I+'}',
      p + ' .mc-close svg{width:18px'+I+';height:18px'+I+';display:block'+I+'}',
      p + ' .mc-close:hover{background:#f2f1ef'+I+';color:#1a1a1a'+I+'}',

      /* ─── Body ──────────────────────────────────────────── */
      p + ' .mc-body{flex:1'+I+';overflow-y:auto'+I+';overflow-x:hidden'+I+';padding:20px 20px 12px'+I+';display:flex'+I+';flex-direction:column'+I+';gap:12px'+I+';-webkit-overflow-scrolling:touch;background:transparent'+I+';margin:0'+I+'}',
      p + ' .mc-body::-webkit-scrollbar{width:6px}',
      p + ' .mc-body::-webkit-scrollbar-thumb{background:var(--ds-border,rgba(0,0,0,.12));border-radius:3px}',
      /* ── Scroll-Affordanz: Fade-Maske + animierter Pfeil (nur wenn mehr unten) ── */
      p + ' .mc-fade{position:sticky'+I+';bottom:0'+I+';left:0;right:0;height:40px'+I+';margin-top:-40px'+I+';pointer-events:none'+I+';display:flex'+I+';align-items:flex-end'+I+';justify-content:center'+I+';background:none'+I+';opacity:0'+I+';transition:opacity .22s ease'+I+';z-index:2'+I+'}',
      p + ' .mc-scrolldown{pointer-events:auto'+I+';width:32px'+I+';height:32px'+I+';margin-bottom:2px'+I+';border-radius:50%'+I+';border:1px solid var(--ds-border,rgba(0,0,0,.14))'+I+';background:var(--ds-surface,#fff)'+I+';box-shadow:0 3px 10px rgba(0,0,0,.18)'+I+';display:flex'+I+';align-items:center'+I+';justify-content:center'+I+';color:var(--ds-text,#111)'+I+';cursor:pointer'+I+';padding:0'+I+';animation:isf-scrollcue 1.5s ease-in-out infinite'+I+'}',
      p + '.mc-can-scroll .mc-fade{opacity:1'+I+'}',
      '@keyframes isf-scrollcue{0%,100%{transform:translateY(0)}50%{transform:translateY(3px)}}',

      /* ─── Item-Card (enth\u00e4lt Ware + USPs in einer Umrandung) ── */
      p + ' .mc-item{position:relative'+I+';display:flex'+I+';flex-direction:column'+I+';gap:0'+I+';padding:16px'+I+';background:var(--ds-surface-el,#fafafa)'+I+';border:1px solid var(--ds-border,rgba(0,0,0,.08))'+I+';border-radius:14px'+I+';transition:border-color .18s,transform .2s,box-shadow .2s'+I+';margin:0'+I+'}',
      p + ' .mc-item-main{display:grid'+I+';grid-template-columns:84px 1fr'+I+';gap:16px'+I+';padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-item:hover{border-color:var(--ds-border-hover,rgba(0,0,0,.14))'+I+'}',
      p + ' .mc-item.mc-item-leaving{opacity:0'+I+';transform:translateX(20px)'+I+';transition:opacity .25s,transform .25s'+I+'}',
      /* X-Button: entfernt nur die jeweilige Warenkorb-Zeile. */
      p + ' .mc-item-x{position:absolute'+I+';top:8px'+I+';right:8px'+I+';width:28px'+I+';height:28px'+I+';min-width:28px'+I+';max-width:28px'+I+';min-height:28px'+I+';max-height:28px'+I+';box-sizing:border-box'+I+';aspect-ratio:1'+I+';background:rgba(0,0,0,.04)'+I+';border:1px solid rgba(0,0,0,.08)'+I+';border-radius:50%'+I+';color:var(--ds-text-muted,#666)'+I+';cursor:pointer'+I+';display:inline-flex'+I+';align-items:center'+I+';justify-content:center'+I+';padding:0'+I+';margin:0'+I+';transition:background .15s,color .15s,border-color .15s'+I+';font-family:inherit'+I+';z-index:2'+I+'}',
      p + ' .mc-item-x svg{width:14px'+I+';height:14px'+I+';display:block'+I+'}',
      p + ' .mc-item-x:hover{background:rgba(208,16,48,.08)'+I+';color:#D6001C'+I+';border-color:rgba(208,16,48,.25)'+I+'}',
      p + ' .mc-item-x:active{transform:scale(.92)'+I+'}',
      p + ' .mc-item-recalc{display:inline-flex'+I+';align-items:center'+I+';justify-content:center'+I+';gap:8px'+I+';width:100%'+I+';margin:12px 0 0'+I+';padding:10px 12px'+I+';background:#fff'+I+';color:var(--ds-text,#111)'+I+';border:1px solid var(--ds-border,rgba(0,0,0,.12))'+I+';border-radius:10px'+I+';font-size:12px'+I+';font-weight:700'+I+';line-height:1.2'+I+';cursor:pointer'+I+';font-family:inherit'+I+';box-shadow:none'+I+';transition:border-color .18s,color .18s,background .18s'+I+'}',
      p + ' .mc-item-recalc svg{width:14px'+I+';height:14px'+I+';display:block'+I+'}',
      /* v525: „Weitere Wand berechnen" — gleiche Form, kleinerer Abstand, damit die
         beiden Knöpfe als Paar lesbar sind. */
      p + ' .mc-item-addwall{margin-top:8px'+I+'}',
      p + ' .mc-item-addwall:hover{border-color:var(--ds-accent,#D6001C)'+I+';color:var(--ds-accent,#D6001C)'+I+'}',
      p + ' .mc-item-recalc:hover{border-color:var(--ds-accent,#D6001C)'+I+';color:var(--ds-accent,#D6001C)'+I+';background:var(--ds-accent-soft,rgba(214,0,28,.04))'+I+'}',
      /* Trust-Bar im Footer (zwischen Zwischensumme & Checkout) — Bewertung + Customer-Count */
      p + ' .mc-trust{display:flex'+I+';flex-direction:column'+I+';align-items:center'+I+';gap:3px'+I+';padding:10px 12px'+I+';margin:10px 0 0'+I+';background:linear-gradient(180deg,rgba(255,184,28,.08) 0%,rgba(255,184,28,.02) 100%)'+I+';border:1px solid rgba(255,184,28,.22)'+I+';border-radius:10px'+I+';line-height:1.2'+I+'}',
      p + ' .mc-trust-rating{display:inline-flex'+I+';align-items:center'+I+';gap:8px'+I+';flex-wrap:wrap'+I+';justify-content:center'+I+'}',
      p + ' .mc-trust-stars{display:inline-block'+I+';color:#FFAB00'+I+';font-size:15px'+I+';letter-spacing:1px'+I+';line-height:1'+I+'}',
      p + ' .mc-trust-text{font-size:13px'+I+';color:var(--ds-text,#111)'+I+';font-weight:500'+I+';line-height:1.2'+I+'}',
      p + ' .mc-trust-text strong{font-weight:700'+I+';color:var(--ds-text,#111)'+I+'}',
      p + ' .mc-trust-sub{font-size:11px'+I+';color:var(--ds-text-muted,#666)'+I+';font-weight:500'+I+';letter-spacing:.01em'+I+'}',
      p + ' .mc-thumb{width:84px'+I+';height:84px'+I+';object-fit:cover'+I+';border-radius:10px'+I+';background:var(--ds-surface,#fff)'+I+';border:1px solid var(--ds-border,rgba(0,0,0,.06))'+I+';flex-shrink:0'+I+';display:block'+I+';padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-info{display:flex'+I+';flex-direction:column'+I+';gap:8px'+I+';min-width:0'+I+';padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-name{font-size:15px'+I+';font-weight:700'+I+';color:var(--ds-text,#111)'+I+';line-height:1.2'+I+';letter-spacing:-.005em'+I+';margin:0'+I+';padding:0 36px 0 0'+I+';overflow:hidden'+I+';text-overflow:ellipsis;display:-webkit-box'+I+';-webkit-line-clamp:2;-webkit-box-orient:vertical;border:none'+I+'}',
      p + ' .mc-qty-text{font-size:13px'+I+';color:var(--ds-text-muted,#666)'+I+';font-weight:500'+I+';padding:0'+I+';margin:0'+I+';line-height:1.3'+I+'}',
      p + ' .mc-stepper{display:inline-flex'+I+';align-items:center'+I+';border:1px solid var(--ds-border,rgba(0,0,0,.16))'+I+';border-radius:9px'+I+';overflow:hidden'+I+';background:#fff'+I+'}',
      /* v492 (45+ Mobil-UX P2): Tap-Ziele 44px. Mengen-Knoepfe von 30 -> 44 (haeufig genutzt, ungefaehrlich). */
      p + ' .mc-step{width:44px'+I+';height:44px'+I+';border:0'+I+';background:#fff'+I+';color:var(--ds-text,#111)'+I+';font-size:20px'+I+';line-height:1'+I+';font-weight:600'+I+';cursor:pointer'+I+';padding:0'+I+';display:flex'+I+';align-items:center'+I+';justify-content:center'+I+'}',
      p + ' .mc-step:hover{background:#F5F5F5'+I+'}',
      p + ' .mc-step-val{width:48px'+I+';min-width:48px'+I+';height:44px'+I+';text-align:center'+I+';font-size:17px'+I+';font-weight:700'+I+';color:var(--ds-text,#111)'+I+';border:0'+I+';background:transparent'+I+';padding:0'+I+';margin:0'+I+';font-family:inherit'+I+';-moz-appearance:textfield'+I+';touch-action:manipulation'+I+'}',
      p + ' .mc-step-val:focus{outline:none'+I+';background:rgba(0,0,0,.05)'+I+';border-radius:5px'+I+'}',
      p + ' .mc-step-val::-webkit-outer-spin-button,'+p+' .mc-step-val::-webkit-inner-spin-button{-webkit-appearance:none'+I+';margin:0'+I+'}',
      p + ' .mc-calc-hint{font-size:12px'+I+';color:var(--ds-text-muted,#666)'+I+';line-height:1.4'+I+';margin-top:6px'+I+'}',
      p + ' .mc-calc-hint a{color:#D6001C'+I+';text-decoration:underline'+I+';font-weight:600'+I+'}',
      /* v236.2: Cart-Properties (z.B. "Berechnung: 8 Meter Horizontalsperre · 2 Ecken · 36 cm Wandstärke") */
      p + ' .mc-props{display:flex'+I+';flex-direction:column'+I+';gap:2px'+I+';padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-prop-row{font-size:12px'+I+';line-height:1.35'+I+';color:var(--ds-text-muted,#666)'+I+';padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-prop-key{font-weight:600'+I+';color:var(--ds-text,#111)'+I+'}',
        p + ' .mc-prop-row--wand .mc-prop-key{font-size:13.5px'+I+';font-weight:800'+I+';color:#D6001C'+I+'}',
        p + ' .mc-hero-banner--summe{background:#f7f5f2'+I+';border-color:#e4e0d9'+I+'}',
      p + ' .mc-prop-val{font-weight:500'+I+'}',
      /* v236.3: Tax/Shipping Note + Free-Shipping Highlight */
      p + ' .mc-tax-note{display:block'+I+';font-size:12px'+I+';color:var(--ds-text-muted,#666)'+I+';line-height:1.2'+I+';margin:2px 0 0'+I+'}',
      p + ' .mc-tax-note--free{color:var(--ds-green,#0A7D56)'+I+';font-weight:600'+I+'}',
      p + ' .mc-tax-note--free strong{font-weight:800'+I+'}',
      p + ' .mc-price{display:block'+I+';text-align:right'+I+';font-size:18px'+I+';font-weight:800'+I+';color:var(--ds-text,#111)'+I+';letter-spacing:-.01em'+I+';line-height:1'+I+';padding:0'+I+';margin:6px 0 0'+I+'}',

      /* ─── Mengenrabatt: Strike-Through + Saved + Tier-Badge ── */
      p + ' .mc-price-wrap{display:flex'+I+';flex-direction:column'+I+';align-items:flex-end'+I+';gap:2px'+I+';margin:6px 0 0'+I+';padding:0'+I+'}',
      p + ' .mc-price-orig{display:block'+I+';text-align:right'+I+';font-size:13px'+I+';font-weight:500'+I+';color:var(--ds-text-dim,#999)'+I+';text-decoration:line-through'+I+';line-height:1'+I+';padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-price-wrap .mc-price{margin:0'+I+';color:var(--ds-green,#0A7D56)'+I+'}',
      p + ' .mc-price-saved{display:inline-flex'+I+';align-items:center'+I+';font-size:11px'+I+';font-weight:600'+I+';color:var(--ds-green,#0A7D56)'+I+';background:rgba(45,212,160,.10)'+I+';border-radius:6px'+I+';padding:3px 7px'+I+';margin:4px 0 0'+I+';line-height:1.2'+I+';letter-spacing:.01em'+I+'}',
      p + ' .mc-tier-badge{display:flex'+I+';align-items:center'+I+';gap:8px'+I+';padding:8px 12px'+I+';margin:0 0 12px'+I+';background:linear-gradient(180deg,rgba(45,212,160,.10) 0%,rgba(45,212,160,.04) 100%)'+I+';border:1px solid rgba(45,212,160,.28)'+I+';border-radius:10px'+I+';font-size:12px'+I+';color:var(--ds-text,#111)'+I+';line-height:1.35'+I+'}',
      p + ' .mc-tier-ico{display:inline-flex'+I+';align-items:center'+I+';justify-content:center'+I+';width:22px'+I+';height:22px'+I+';color:var(--ds-green,#0A7D56)'+I+';flex-shrink:0'+I+'}',
      p + ' .mc-tier-ico svg{width:14px'+I+';height:14px'+I+'}',
      p + ' .mc-tier-txt{flex:1'+I+';min-width:0'+I+';font-weight:500'+I+'}',
      p + ' .mc-tier-txt strong{font-weight:700'+I+';color:var(--ds-green,#0A7D56)'+I+'}',
      /* Footer-Aufschlüsselung (Listenpreis / Mengenrabatt) */
      p + ' .mc-total-detail{display:flex'+I+';flex-direction:column'+I+';gap:4px'+I+';padding:10px 12px'+I+';margin:0'+I+';background:var(--ds-surface-el,#fafafa)'+I+';border:1px solid var(--ds-border,rgba(0,0,0,.06))'+I+';border-radius:10px'+I+'}',
      p + ' .mc-total-row{display:flex'+I+';justify-content:space-between'+I+';align-items:baseline'+I+';gap:12px'+I+';font-size:13px'+I+';line-height:1.3'+I+';padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-total-row span{padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-total-row-orig{color:var(--ds-text-muted,#666)'+I+'}',
      p + ' .mc-total-orig-val{text-decoration:line-through'+I+';font-weight:500'+I+'}',
      p + ' .mc-total-row-saved{color:var(--ds-green,#0A7D56)'+I+';font-weight:600'+I+'}',
      p + ' .mc-total-saved-val{font-weight:700'+I+'}',
      /* Aktion Paket 2, Nachbesserung (Prüfung Technik M2): Zeilen „Normalpreis“ / Aktionsname 15 px */
      p + ' .mc-total-detail.is-aktion .mc-total-row{font-size:15px'+I+'}',
      /* Aktion Paket 2: Pflichtangabe unter der Aktionsersparnis, Vorschau-Hinweis bei fehlendem Rabatt */
      p + ' .mc-ak-ref{font-size:15px'+I+';line-height:1.4'+I+';color:#5f5b56'+I+';margin:2px 0 0'+I+';padding:0'+I+'}',
      p + ' .mc-ak-warn{font-size:15px'+I+';line-height:1.4'+I+';color:#fff'+I+';background:#c00018'+I+';border-radius:8px'+I+';padding:8px 10px'+I+';margin:8px 0 0'+I+';font-weight:600'+I+'}',

      /* ─── Sekundärer Reset-Button (im Footer) ────────────── */
      p + ' .mc-reset{display:inline-flex'+I+';align-items:center'+I+';justify-content:center'+I+';gap:8px'+I+';width:100%'+I+';padding:11px 18px'+I+';background:transparent'+I+';color:var(--ds-text-muted,#666)'+I+';border:1px solid var(--ds-border,rgba(0,0,0,.12))'+I+';border-radius:10px'+I+';font-size:13px'+I+';font-weight:600'+I+';letter-spacing:.01em'+I+';cursor:pointer'+I+';font-family:inherit'+I+';transition:border-color .18s,color .18s,background .18s'+I+';box-shadow:none'+I+';margin:0'+I+'}',
      p + ' .mc-reset svg{width:15px'+I+';height:15px'+I+'}',
      p + ' .mc-reset:hover{border-color:var(--ds-text-muted,#666)'+I+';color:var(--ds-text,#111)'+I+';background:var(--ds-surface-hover,rgba(0,0,0,.03))'+I+'}',
      p + ' .mc-reset:active{background:var(--ds-surface-el,#f6f6f6)'+I+'}',

      /* ─── Empty-State ───────────────────────────────────── */
      p + ' .mc-empty{display:flex'+I+';flex-direction:column'+I+';align-items:center'+I+';justify-content:center'+I+';text-align:center'+I+';gap:14px'+I+';padding:60px 24px 40px'+I+';color:var(--ds-text-muted,#666)'+I+';min-height:320px'+I+';margin:0'+I+'}',
      p + ' .mc-empty-icon{width:72px'+I+';height:72px'+I+';border-radius:50%'+I+';background:var(--ds-surface-el,#f6f6f6)'+I+';display:inline-flex'+I+';align-items:center'+I+';justify-content:center'+I+';color:var(--ds-text-dim,#aaa)'+I+';border:1px dashed var(--ds-border-strong,rgba(0,0,0,.12))'+I+';padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-empty-icon svg{width:32px'+I+';height:32px'+I+'}',
      p + ' .mc-empty-title{font-size:17px'+I+';font-weight:700'+I+';color:var(--ds-text,#111)'+I+';margin:4px 0 0'+I+';letter-spacing:-.005em'+I+';padding:0'+I+';border:none'+I+'}',
      p + ' .mc-empty-text{font-size:13px'+I+';line-height:1.55'+I+';color:var(--ds-text-muted,#666)'+I+';max-width:260px'+I+';margin:0'+I+';padding:0'+I+'}',
      p + ' .mc-empty-cta{display:inline-flex'+I+';align-items:center'+I+';justify-content:center'+I+';gap:6px'+I+';padding:11px 20px'+I+';background:transparent'+I+';border:1.5px solid var(--ds-border-strong,rgba(0,0,0,.16))'+I+';border-radius:10px'+I+';color:var(--ds-text,#111)'+I+';font-size:13px'+I+';font-weight:600'+I+';cursor:pointer'+I+';font-family:inherit'+I+';text-decoration:none'+I+';margin:8px 0 0'+I+';transition:border-color .2s,background .2s'+I+'}',
      p + ' .mc-empty-cta:hover{border-color:var(--ds-accent,#D6001C)'+I+';color:var(--ds-accent,#D6001C)'+I+';background:var(--ds-accent-soft,rgba(214,0,28,.04))'+I+'}',
      /* v349: Zwei-Wege-Optionen im leeren Warenkorb */
      p + ' .mc-empty-opt{display:flex'+I+';flex-direction:column'+I+';gap:3px'+I+';width:100%'+I+';max-width:300px'+I+';box-sizing:border-box'+I+';text-align:center'+I+';padding:13px 16px'+I+';border:1.5px solid var(--ds-border-strong,rgba(0,0,0,.16))'+I+';border-radius:12px'+I+';background:#fff'+I+';text-decoration:none'+I+';margin:0'+I+';transition:border-color .15s,box-shadow .15s'+I+'}',
      p + ' .mc-empty-opt:hover{border-color:var(--ds-accent,#D6001C)'+I+';box-shadow:0 4px 14px rgba(0,0,0,.08)'+I+'}',
      p + ' .mc-empty-opt-t{font-size:15px'+I+';font-weight:700'+I+';color:var(--ds-text,#111)'+I+';line-height:1.3'+I+'}',
      p + ' .mc-empty-opt-s{font-size:12.5px'+I+';color:var(--ds-text-muted,#666)'+I+';line-height:1.4'+I+'}',
      p + ' .mc-empty-opt--primary{background:var(--ds-accent,#D6001C)'+I+';border-color:var(--ds-accent,#D6001C)'+I+';box-shadow:0 4px 14px rgba(214,0,28,.28)'+I+'}',
      p + ' .mc-empty-opt--primary:hover{background:#B8001A'+I+';border-color:#B8001A'+I+'}',
      p + ' .mc-empty-opt--primary .mc-empty-opt-t{color:#fff'+I+'}',
      p + ' .mc-empty-opt--primary .mc-empty-opt-s{color:rgba(255,255,255,.88)'+I+'}',
      p + ' .mc-empty-note{font-size:12px'+I+';color:var(--ds-text-dim,#999)'+I+';line-height:1.45'+I+';max-width:280px'+I+';margin:2px 0 0'+I+';padding:0'+I+'}',

      /* ─── Footer ────────────────────────────────────────── */
      p + ' .mc-foot{border:none'+I+';border-top:1px solid var(--ds-border,rgba(0,0,0,.08))'+I+';padding:20px 24px calc(20px + env(safe-area-inset-bottom,0px))'+I+';background:var(--ds-surface,#fff)'+I+';flex-shrink:0'+I+';display:flex'+I+';flex-direction:column'+I+';gap:14px'+I+';margin:0'+I+'}',
      p + ' .mc-total{display:flex'+I+';justify-content:space-between'+I+';align-items:baseline'+I+';gap:16px'+I+';padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-total-lbl{display:flex'+I+';flex-direction:column'+I+';gap:2px'+I+';padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-total-lbl span{font-size:14px'+I+';font-weight:600'+I+';color:var(--ds-text,#111)'+I+';line-height:1.2'+I+';padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-total-lbl small{font-size:11px'+I+';color:var(--ds-text-dim,#888)'+I+';font-weight:500'+I+';padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-total-val{font-size:24px'+I+';font-weight:700'+I+';color:var(--ds-text,#111)'+I+';line-height:1'+I+';letter-spacing:0'+I+';padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-checkout{display:flex'+I+';align-items:center'+I+';justify-content:center'+I+';gap:10px'+I+';width:100%'+I+';padding:15px 24px'+I+';background:linear-gradient(180deg,#D6001C 0%,#A80016 100%)'+I+';color:#fff'+I+';border:none'+I+';border-radius:12px'+I+';font-size:16px'+I+';font-weight:700'+I+';letter-spacing:.01em'+I+';cursor:pointer'+I+';font-family:inherit'+I+';box-shadow:0 6px 16px rgba(214,0,28,.30),0 2px 4px rgba(214,0,28,.20),inset 0 -2px 0 rgba(0,0,0,.12)'+I+';transition:transform .15s,box-shadow .2s'+I+';position:relative'+I+';margin:0'+I+'}',
      p + ' .mc-checkout:hover{transform:translateY(-1px)'+I+';box-shadow:0 8px 24px rgba(214,0,28,.40),0 2px 6px rgba(214,0,28,.24),inset 0 -2px 0 rgba(0,0,0,.12)'+I+'}',
      p + ' .mc-checkout:active{transform:translateY(0)'+I+';box-shadow:0 4px 12px rgba(214,0,28,.28),inset 0 -1px 0 rgba(0,0,0,.12)'+I+'}',
      p + ' .mc-checkout svg{width:16px'+I+';height:16px'+I+'}',
      p + ' .mc-dynamic-slot{display:block'+I+';width:100%'+I+';min-height:0'+I+';margin:-4px 0 0'+I+';padding:0'+I+'}',
      p + ' .mc-dynamic-slot[hidden]{display:none'+I+'}',
      /* v488: Zahlungsarten-Leiste unter dem Kasse-Button. Masse 1:1 von der
         Ergebnisseite (.isocal-s6v2-paylogos): 34x22, gap 5, zentriert. */
      p + ' .mc-paylogos{display:flex'+I+';flex-wrap:wrap'+I+';justify-content:center'+I+';align-items:center'+I+';gap:5px'+I+';width:100%'+I+';margin:-4px 0 0'+I+';padding:0'+I+';border:none'+I+';background:none'+I+'}',
      p + ' .mc-paylogo{width:34px'+I+';height:22px'+I+';display:inline-block'+I+';margin:0'+I+';padding:0'+I+';flex:0 0 auto'+I+';opacity:.9'+I+'}',
      p + ' .mc-dynamic-checkout,.mc-dynamic-checkout .additional-checkout-buttons{display:block'+I+';width:100%'+I+';margin:0'+I+';padding:0'+I+'}',
      p + ' .mc-dynamic-checkout [data-shopify-buttoncontainer],'+p+' .mc-dynamic-checkout .shopify-cleanslate{width:100%'+I+'}',
      /* v291: max-height deckelt den Lade-Skeleton (gestapelte Wallet-Platzhalter) auf 1 Button-Zeile */
      p + ' .mc-dynamic-checkout shopify-accelerated-checkout-cart{display:block'+I+';width:100%'+I+';max-height:56px'+I+';overflow:hidden'+I+'}',
      p + ' .mc-dynamic-checkout #dynamic-checkout-cart{display:block'+I+';width:100%'+I+'}',
      /* ─── Personalisierter Hero-Banner (gr\u00fcn = positives Signal) ── */
      p + ' .mc-hero-banner{display:flex'+I+';align-items:center'+I+';gap:12px'+I+';padding:14px 16px'+I+';background:#eef5ef'+I+';border:1.5px solid #0f6e56'+I+';border-radius:12px'+I+';margin:0'+I+'}',
      p + ' .mc-hero-icon{display:inline-flex'+I+';align-items:center'+I+';justify-content:center'+I+';width:34px'+I+';height:34px'+I+';border-radius:10px'+I+';background:var(--ds-green,#2DD4A0)'+I+';color:#fff'+I+';flex-shrink:0'+I+'}',
      p + ' .mc-hero-icon svg{width:16px'+I+';height:16px'+I+';display:block'+I+'}',
      p + ' .mc-hero-text{display:flex'+I+';flex-direction:column'+I+';gap:2px'+I+';min-width:0'+I+';padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-hero-eyebrow{font-size:13px'+I+';font-weight:700'+I+';letter-spacing:0'+I+';color:#0f6e56'+I+';line-height:1.3'+I+';margin:0'+I+'}',
      p + ' .mc-hero-detail{font-size:15px'+I+';font-weight:700'+I+';color:var(--ds-text,#111)'+I+';line-height:1.25'+I+';letter-spacing:-.005em'+I+';margin:0'+I+'}',

      /* ─── Produkt-USPs (eingebettet in die Item-Card, durch Separator getrennt) ─ */
      p + ' .mc-usp{list-style:none'+I+';padding:14px 0 0'+I+';margin:14px 0 0'+I+';background:transparent'+I+';border:none'+I+';border-top:1px solid var(--ds-border,rgba(0,0,0,.08))'+I+';border-radius:0'+I+';display:flex'+I+';flex-direction:column'+I+';gap:10px'+I+'}',
      p + ' .mc-usp-row{display:flex'+I+';align-items:flex-start'+I+';gap:10px'+I+';font-size:13px'+I+';color:var(--ds-text,#111)'+I+';font-weight:500'+I+';line-height:1.4'+I+';padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-usp-ico{display:inline-flex'+I+';align-items:center'+I+';justify-content:center'+I+';width:18px'+I+';height:18px'+I+';border-radius:50%'+I+';background:var(--ds-green,#2DD4A0)'+I+';color:#fff'+I+';flex-shrink:0'+I+';margin-top:1px'+I+'}',
      p + ' .mc-usp-ico svg{width:11px'+I+';height:11px'+I+';display:block'+I+';stroke-width:3'+I+'}',
      p + ' .mc-usp-txt{flex:1'+I+';min-width:0'+I+'}',

      /* ─── Dev-Hint ──────────────────────────────────────── */
      p + ' .mc-dev-hint{display:block'+I+';padding:8px 12px'+I+';border:1px dashed var(--ds-border-strong,rgba(0,0,0,.14))'+I+';border-radius:8px'+I+';font-size:11px'+I+';color:var(--ds-text-dim,#888)'+I+';text-align:center'+I+';background:var(--ds-surface-el,#fafafa)'+I+';line-height:1.4'+I+';letter-spacing:.01em'+I+';margin:0'+I+'}',

      /* ─── Mobile ────────────────────────────────────────── */
      /* ─── v277: schlanker Drawer (Sterne, USP-Box, Versandzeile, Pfeil-im-Kreis, Minus-Ecke) ── */
      p + ' .mc-info{gap:4px'+I+'}',
      p + ' .mc-foot{box-shadow:0 -8px 22px -8px rgba(0,0,0,.22)'+I+';border-top:2px solid var(--ds-border-strong,rgba(0,0,0,.16))'+I+';background:var(--ds-surface-el,#fafafa)'+I+'}',
      /* v277: Dynamic-/Express-Checkout immer unter dem CTA + zentriert */
      p + ' .mc-dynamic-slot{display:flex'+I+';flex-direction:column'+I+';align-items:center'+I+';justify-content:center'+I+'}',
      p + ' .mc-dynamic-checkout{text-align:center'+I+'}',
      p + ' .mc-dynamic-checkout [data-shopify-buttoncontainer]{justify-content:center'+I+';margin-left:auto'+I+';margin-right:auto'+I+'}',
      p + ' .mc-name{font-size:14px'+I+';-webkit-line-clamp:1'+I+';padding:0 6px 0 0'+I+'}',
      p + ' .mc-item-rating{display:flex'+I+';align-items:center'+I+';gap:6px'+I+';font-size:11px'+I+';color:var(--ds-text-muted,#666)'+I+';line-height:1'+I+';margin:0'+I+'}',
      p + ' .mc-item-stars{color:#FFAB00'+I+';font-size:11px'+I+';letter-spacing:.5px'+I+'}',
      p + ' .mc-item-rtxt strong{font-weight:700'+I+';color:var(--ds-text,#111)'+I+'}',
      p + ' .mc-qtyprice{display:flex'+I+';align-items:baseline'+I+';justify-content:space-between'+I+';gap:10px'+I+';margin:3px 0 0'+I+'}',
      p + ' .mc-qtyprice .mc-qty-text{margin:0'+I+'}',
      p + ' .mc-qtyprice .mc-price{margin:0'+I+';font-size:15px'+I+';font-weight:700'+I+';color:#555'+I+'}',
      /* v492 (45+ P2): Entfernen-X von 26 -> 40px. BEWUSST nicht 44: der Loeschen-Klick
         hat keine Rueckfrage; ein XL-Ziel lud zu versehentlichem Loeschen ein. 40 ist
         klar besser tappbar, bleibt aber zurueckhaltender als die +/- Knoepfe. */
      p + ' .mc-item-x{top:-11px'+I+';right:-11px'+I+';width:40px'+I+';height:40px'+I+';min-width:40px'+I+';max-width:40px'+I+';min-height:40px'+I+';max-height:40px'+I+';background:#fff'+I+';box-shadow:0 1px 4px rgba(0,0,0,.10)'+I+'}',
      p + ' .mc-item-x svg{width:16px'+I+';height:16px'+I+'}',
      p + ' .mc-usp-box{margin:0'+I+';padding:14px'+I+';background:var(--ds-surface-el,#fafafa)'+I+';border:1px solid var(--ds-border,rgba(0,0,0,.08))'+I+';border-radius:14px'+I+'}',
      p + ' .mc-usp-box .mc-usp{border-top:none'+I+';padding:0'+I+';margin:0'+I+';gap:9px'+I+'}',
      p + ' .mc-usp-ttl{font-size:10.5px'+I+';font-weight:700'+I+';color:var(--ds-text-muted,#666)'+I+';text-transform:uppercase'+I+';letter-spacing:.07em'+I+';margin:0 0 10px'+I+'}',
      p + ' .mc-ship{width:100%'+I+';text-align:center'+I+';font-size:11px'+I+';color:var(--ds-text-muted,#666)'+I+';font-weight:500'+I+';line-height:1.3'+I+';white-space:nowrap'+I+';overflow:hidden'+I+';text-overflow:ellipsis'+I+';padding:2px 0'+I+';margin:0'+I+'}',
      p + ' .mc-ship b{color:var(--ds-text,#111)'+I+';font-weight:700'+I+'}',
      p + ' .mc-ship-in{color:var(--ds-green,#0A7D56)'+I+';font-weight:700'+I+'}',
      p + ' .mc-checkout .isf-arrow-circle{display:inline-flex'+I+';align-items:center'+I+';justify-content:center'+I+';width:26px'+I+';height:26px'+I+';min-width:26px'+I+';background:rgba(255,255,255,0.2)'+I+';border-radius:50%'+I+';animation:isf-arrow-move-full 1.3s ease-in-out infinite'+I+'}',
      p + ' .mc-checkout .isf-arrow-circle svg{width:14px'+I+';height:14px'+I+';display:block'+I+'}',
      p + ' .mc-checkout:hover .isf-arrow-circle{transform:translateX(4px)'+I+';animation:none'+I+'}',
      '@keyframes isf-arrow-move-full{0%,100%{transform:translateX(0)}50%{transform:translateX(4px)}}',
      /* v277: CTA-Optik exakt wie Startseite (.isf-hero-cta) — Shine-Sweep + Puls + heller Hover-Verlauf */
      p + ' .mc-checkout{overflow:hidden'+I+';animation:isf-cta-pulse-full 2.4s ease-in-out infinite'+I+'}',
      p + ' .mc-checkout::after{content:""'+I+';position:absolute'+I+';inset:-40% -60%'+I+';background:linear-gradient(120deg,transparent 0%,rgba(255,255,255,0.18) 45%,rgba(255,255,255,0.35) 50%,rgba(255,255,255,0.18) 55%,transparent 100%)'+I+';transform:translateX(-120%) rotate(8deg)'+I+';animation:isf-cta-shine-full 3.8s ease-in-out infinite'+I+';pointer-events:none'+I+'}',
      p + ' .mc-checkout:hover{animation:none'+I+'}',
      '@keyframes isf-cta-pulse-full{0%,100%{transform:translateY(0) scale(1)}50%{transform:translateY(-1px) scale(1.008)}}',
      '@keyframes isf-cta-shine-full{0%,70%{transform:translateX(-120%) rotate(8deg);opacity:0}80%{opacity:1}100%{transform:translateX(120%) rotate(8deg);opacity:0}}',

      /* ─── v309: Handbuch kompakt (Preis-Stapel rechts) + Sanierungspaket-Berechnung einklappbar ── */
      p + ' .mc-item--gift .mc-gift-top{display:flex'+I+';justify-content:space-between'+I+';align-items:center'+I+';gap:10px'+I+';margin:0'+I+'}',
      p + ' .mc-gift-left{display:flex'+I+';flex-direction:column'+I+';gap:3px'+I+';min-width:0'+I+'}',
      p + ' .mc-item--gift .mc-gift-top .mc-name{margin:0'+I+';padding:0'+I+'}',
      p + ' .mc-price--gift{display:flex'+I+';flex-direction:column'+I+';align-items:flex-end'+I+';text-align:right'+I+';line-height:1.15'+I+';flex-shrink:0'+I+';gap:1px'+I+';margin:0'+I+';padding:0'+I+'}',
      p + ' .mc-price--gift .mc-gift-was{font-size:13px'+I+';color:var(--ds-text-dim,#999)'+I+';font-weight:500'+I+';text-decoration:line-through'+I+'}',
      p + ' .mc-price--gift .mc-gift-free{font-size:16px'+I+';font-weight:800'+I+';color:var(--ds-green,#2f8a47)'+I+'}',
      p + ' .mc-item--gift .mc-gift-toc{margin-top:3px'+I+'}',
      /* v309: dezentes Coupon-Feld + kompakterer Footer-Abstand */
      p + ' .mc-foot{gap:10px'+I+'}',
      p + ' .mc-coupon{margin:0'+I+'}',
      p + ' .mc-coupon--on{display:flex'+I+';align-items:center'+I+';justify-content:space-between'+I+';gap:10px'+I+';padding:8px 10px'+I+';background:var(--ds-green-soft,#eef6ee)'+I+';border:1px solid rgba(47,138,71,.3)'+I+';border-radius:9px'+I+'}',
      p + ' .mc-coupon-ok{font-size:13px'+I+';color:var(--ds-green,#2f8a47)'+I+';font-weight:600'+I+'}',
      p + ' .mc-total-sub{display:flex'+I+';justify-content:space-between'+I+';align-items:baseline'+I+';gap:10px'+I+';flex-wrap:wrap'+I+';margin-top:-6px'+I+'}',
      /* v345: "inkl. MwSt." schwarz, nur "Kostenloser Versand" gruen */
      p + ' .mc-tax-note--free .mc-mwst-note{color:var(--ds-text,#1a1a1a)'+I+';font-weight:500'+I+'}',
      p + ' .mc-coupon-on{align-self:baseline'+I+'}',
      p + ' .mc-total-sub .mc-tax-note{margin:0'+I+'}',
      p + ' .mc-coupon-trigger{flex-shrink:0'+I+';margin-left:auto'+I+'}',
      p + ' .mc-coupon-on{display:inline-flex'+I+';align-items:center'+I+';gap:6px'+I+'}',
      p + ' .mc-coupon-on-txt{font-size:12px'+I+';font-weight:600'+I+';color:#1565c0'+I+';line-height:1.2'+I+'}',
      /* v501: Entfernen-Knopf. 26x26 sichtbar, aber ueber ein Pseudo-Element
         auf 44px Trefferflaeche vergroessert — Zielgruppe 45+, Finger statt Maus. */
      p + ' .mc-coupon-off{position:relative'+I+';flex:0 0 auto'+I+';width:26px'+I+';height:26px'+I+';padding:0'+I+';margin:0'+I+';border:1px solid rgba(21,101,192,.35)'+I+';border-radius:999px'+I+';background:#fff'+I+';color:#1565c0'+I+';font-size:13px'+I+';line-height:1'+I+';cursor:pointer'+I+';display:inline-flex'+I+';align-items:center'+I+';justify-content:center'+I+'}',
      p + ' .mc-coupon-off::after{content:""'+I+';position:absolute'+I+';left:50%'+I+';top:50%'+I+';width:44px'+I+';height:44px'+I+';transform:translate(-50%,-50%)'+I+'}',
      p + ' .mc-coupon-off:hover{background:#1565c0'+I+';color:#fff'+I+';border-color:#1565c0'+I+'}',
      p + ' .mc-coupon-off:focus-visible{outline:2px solid #1565c0'+I+';outline-offset:2px'+I+'}',
      p + ' .mc-disc-code{font-weight:500'+I+';font-size:11.5px'+I+';color:var(--ds-text-dim,#888)'+I+'}',
      p + ' .mc-mwst-pre{display:none'+I+'}',

      '@media (max-width:520px){',
      '  ' + p + ' .mc-panel{width:100%'+I+';max-width:100%'+I+';border-left:none'+I+'}',
      /* ── Medienregel endet HIER ────────────────────────────────────────
         17.09.2026 — BEFUND, live reproduziert: Das gesamte v2-Stylesheet
         stand bis eben INNERHALB dieser @media (max-width:520px)-Regel.
         Folge: ab 521 px bekam v2-Markup nur die v1-Regeln. Gemessen wurde
         das Schloss der Verschluesselungszeile dort 391 px breit statt 12 —
         die Regel dafuer existierte, galt aber nur bis 520 px.
         Betroffen war nur, wer ?drawer=v2 benutzt hat; Voreinstellung ist
         v1 und ISO_DRAWER_TEST ist nicht gesetzt, also kein Kundenkontakt.
         Die drei @keyframes mcRail* mussten zwingend mit heraus: Keyframes,
         die in einer Medienregel definiert sind, existieren ausserhalb
         davon nicht — die Schienen-Animation waere sonst am Schreibtisch
         tot gewesen.
         Die echten Mobilregeln bleiben, wo sie hingehoeren: die eine davor
         (Panel auf volle Breite), die dreizehn dahinter in einem zweiten
         Block. Nichts an v1 aendert sich dadurch. */
      '}',

      /* ═══════════════════════════════════════════════════════════════
         v528 — CSS für Layout v2 („Der Rückenwind")
         Alles unter p + '.is-v2' — v1 bleibt damit buchstäblich unberührt,
         und Umschalten ist ein Klassentausch ohne CSS-Neuaufbau.
         ═══════════════════════════════════════════════════════════════ */
      /* Fortschrittsleiste: vier gleich breite Spalten, der Balken darüber
         trägt die Aussage, die Beschriftung nur das Wort dazu. */
      /* Die Kopfzeile traegt in v2 die Wanddaten — laenger als "2 Artikel",
         darf also umbrechen. nowrap wuerde sie abschneiden. */
      /* v528 (Björn): „Ihr Warenkorb, dann die weiteren Infos unten drunter,
         nicht rechts daneben." Die Kopfzeile ist von Haus aus eine Zeile mit
         Umbruch (flex-row, wrap) — dort stand die Wandangabe neben dem Titel.
         In v2 stapeln wir: Titel oben, Angaben darunter. */
      /* v528 (Björn): „den Schließen-Button finde ich etwas übertrieben."
         Stimmt — weiße Vollkreis-Fläche mit Rahmen, 44 px, auf rotem Grund:
         das leuchtendste Element der Kopfzeile war die Abbruchtaste.
         Jetzt nur noch das Kreuz in Weiß, ohne Fläche und Rahmen. Die
         Trefferfläche bleibt bei 44 px — das ist die Mindestgröße für die
         Zielgruppe und darf nicht mit der Optik schrumpfen. */
      p + '.is-v2 .mc-close{background:transparent'+I+';border-color:transparent'+I+';color:#fff'+I+';opacity:.85'+I+'}',
      p + '.is-v2 .mc-close:hover{background:rgba(255,255,255,.16)'+I+';color:#fff'+I+';opacity:1'+I+'}',
      p + '.is-v2 .mc-close svg{width:20px'+I+';height:20px'+I+'}',

      p + '.is-v2 .mc-head-title{flex-direction:column'+I+';align-items:flex-start'+I+';gap:3px'+I+'}',
      p + '.is-v2 .mc-head-sub{white-space:normal'+I+';line-height:1.35'+I+';margin-top:0'+I+';max-width:34ch'+I+'}',

      /* v528 (Björn): „der grüne dunkle Balken mit Gratis-Geschenk ist zu
         prägnant." Stimmt — Volltonfläche in Dunkelgrün zieht mehr Blick als
         der Kaufknopf, dabei ist das Handbuch eine Zugabe, nicht die Ware.
         Jetzt heller Grund, grüne Schrift, schmale Linie statt Balken. */
      p + '.is-v2 .mc-gift-flag{background:#EEF6F0'+I+';color:#1E7A34'+I+';font-weight:600'+I+';font-size:12.5px'+I+';border:1px solid #CDE8D4'+I+';border-radius:8px'+I+';padding:6px 10px'+I+'}',
      /* Die Karte drumherum darf dann auch zurücktreten. */
      p + '.is-v2 .mc-item--gift{border-color:#DCE8DF'+I+';background:#FBFDFC'+I+'}',
      /* v528 (Björn 15.09.): „Mach die Schiene so breit wie die Section drunter —
         ist aktuell schmal mit viel Abstand zu den Rändern."
         Gemessen: die Balken endeten 30 px vom Panelrand, die Artikelkarte
         darunter 16 px — die Schiene trug zusätzlich zum 16-px-Polster des
         Körpers noch 14 px eigenes. Das eigene Seitenpolster fällt weg, die
         Balken laufen jetzt auf derselben Kante wie die Karten. */
      p + '.is-v2 .mc-rail{display:grid'+I+';grid-template-columns:repeat(4,1fr)'+I+';gap:5px'+I+';padding:0 0 2px'+I+';margin:-6px 0 0'+I+'}',
      p + '.is-v2 .mc-rail div{font-size:10.5px'+I+';font-weight:600'+I+';letter-spacing:.04em'+I+';color:var(--ds-text-dim,#8a8a8a)'+I+';text-align:center'+I+'}',
      /* v528 (Björn 15.09.): „Der Kreis ist nicht mittig vor Adresse."
         Stimmt — gemessen saß er 2,5 px unter der Textmitte. Ursache war das
         handgesetzte vertical-align: der 14-px-Kreis ist höher als die
         10,5-px-Zeile, und ein Pixelwert an der Grundlinie trifft die Mitte nur
         zufällig. Label und Symbol liegen jetzt in einer echten Flex-Zeile mit
         align-items:center — das zentriert unabhängig von Schrift- und
         Symbolgröße und gilt für Haken und Kreis gleichermaßen. */
      p + '.is-v2 .mc-rail-lab{display:flex'+I+';align-items:center'+I+';justify-content:center'+I+';gap:3px'+I+';font-weight:inherit'+I+';font-size:inherit'+I+';line-height:1.15'+I+'}',
      p + '.is-v2 .is-naechst .mc-rail-lab{gap:4px'+I+'}',
      p + '.is-v2 .mc-rail div span{display:block'+I+';height:3px'+I+';border-radius:2px'+I+';background:var(--ds-border,#e5e5e5)'+I+';margin-bottom:6px'+I+';position:relative'+I+';overflow:hidden'+I+'}',
      p + '.is-v2 .mc-rail .is-fertig{color:#1E7A34'+I+'}',
      p + '.is-v2 .mc-rail .is-fertig span{background:#1E7A34'+I+'}',
      p + '.is-v2 .mc-rail .is-naechst{color:#1565C0'+I+'}',
      p + '.is-v2 .mc-rail .is-naechst span{background:rgba(21,101,192,.22)'+I+'}',
      /* v528 (Björn 15.09.): „Den Balken von links nach rechts animieren und die
         Adresse als nächsten Schritt animiert reinpacken — sonst habe ich das
         Gefühl, ich müsste die Adresse in DIESEM Schritt eingeben."
         Der Haken: Warenkorb ist grün (= erledigt), Adresse ist der nächste
         Schritt — der Kunde steht also ZWISCHEN zwei Spalten. Genau diese
         Übergabe zeigen wir jetzt: ein heller Streifen läuft über den fertigen
         Warenkorb-Balken nach rechts hinaus, danach füllt sich der Adress-
         Balken von links nach rechts blau. Die Bewegung kommt also sichtbar aus
         dem Warenkorb und endet in der Adresse — statt dass die Adress-Spalte
         für sich blinkt und wie ein Eingabefeld wirkt.
         ACHTUNG: auf animierten Eigenschaften (transform/opacity/left) darf
         KEIN !important stehen — eine Autoren-!important-Deklaration schlägt in
         der Kaskade die laufende Animation, der Balken stünde still (v527-Lehre). */
      p + '.is-v2 .mc-rail .is-naechst span::after{content:""'+I+';position:absolute'+I+';top:0'+I+';left:0'+I+';right:0'+I+';bottom:0'+I+';border-radius:2px'+I+';background:#1565C0'+I+';transform-origin:left center'+I+';transform:scaleX(0);animation:mcRailFuell 3.2s cubic-bezier(.4,0,.2,1) infinite}',
      p + '.is-v2 .mc-rail .is-uebergabe span::after{content:""'+I+';position:absolute'+I+';top:0'+I+';bottom:0'+I+';width:38%'+I+';border-radius:2px'+I+';background:linear-gradient(90deg,rgba(255,255,255,0),rgba(255,255,255,.9),rgba(255,255,255,0))'+I+';left:-40%;animation:mcRailUeber 3.2s ease-in-out infinite}',
      '@keyframes mcRailFuell{0%,20%{transform:scaleX(0);opacity:1}64%{transform:scaleX(1);opacity:1}88%{transform:scaleX(1);opacity:1}100%{transform:scaleX(1);opacity:0}}',
      '@keyframes mcRailUeber{0%{left:-40%;opacity:0}6%{opacity:1}22%{left:100%;opacity:0}100%{left:100%;opacity:0}}',
      '@media (prefers-reduced-motion: reduce){' + p + '.is-v2 .mc-rail .is-naechst span::after{animation:none;transform:scaleX(1);opacity:.5}' +
        p + '.is-v2 .mc-rail .is-uebergabe span::after{display:none' + I + '}}',
      /* v528 (Björn): „das oben mit Warenkorb und Adresse hochwertig animieren,
         dass das zum Klicken anspornt, oder man den nächsten Schritt sehen will."
         Bewusst zurückhaltend: Der Balken des NÄCHSTEN Schritts füllt sich
         langsam von links und läuft wieder leer — eine Bewegung nach vorn,
         kein Blinken. Sie zieht den Blick auf „Adresse", also dorthin, wo der
         Kauf weitergeht. 2,6 s Takt mit langer Pause, damit es beim Lesen
         nicht stört. Wer Bewegung abgeschaltet hat, sieht den Balken einfach
         halb gefüllt — die Aussage bleibt, die Animation entfällt. */
      /* v528 (Björn 14.09.): „Checkmarks bei Berechnet und Warenkorb. Der Pfeil
         — vielleicht ein bisschen kleiner, mit einem runden Hintergrund."
         Erledigte Schritte tragen jetzt einen grünen Haken, der nächste einen
         kleinen blauen Punkt mit weißem Winkel. Der Punkt selbst wandert nicht
         mehr über den Balken; er atmet nur leicht nach rechts — ruhiger als der
         gleitende Pfeil und trotzdem eine Richtung.

         ACHTUNG beim Ändern: transform hier NIEMALS mit !important setzen. Eine
         !important-Angabe des Autors schlägt in der Kaskade die Werte einer
         laufenden Animation — die Animation lief dann, ihr Ergebnis wurde aber
         jedes Bild überschrieben und es stand still. */
      p + '.is-v2 .mc-rail-ok{font-style:normal'+I+';color:#1E7A34'+I+';font-size:11px'+I+';font-weight:700'+I+';line-height:1'+I+'}',
      /* v528 (Björn 15.09.): „nimm doch gleich den Pfeil wie im Button."
         Derselbe SVG-Winkel wie im Kaufknopf, nur kleiner und in Blau statt
         Weiß-auf-Rot. Zentriert über inline-flex mit align/justify center —
         der vorherige Pseudo-Element-Winkel saß über feste Pixelwerte im
         Kreis und wirkte dadurch verschoben. */
      p + '.is-v2 .mc-rail-nun{display:inline-flex'+I+';align-items:center'+I+';justify-content:center'+I+';width:14px'+I+';height:14px'+I+';border-radius:50%'+I+';background:#1565C0'+I+';color:#fff'+I+';flex:0 0 14px'+I+';animation:mcRailNun 3.2s ease-in-out infinite'+I+'}',
      p + '.is-v2 .mc-rail-nun svg{width:8px'+I+';height:8px'+I+';display:block'+I+'}',
      '@keyframes mcRailNun{0%,46%{transform:translateX(0)}66%{transform:translateX(3px)}86%,100%{transform:translateX(0)}}',
      '@media (prefers-reduced-motion: reduce){' + p + '.is-v2 .mc-rail-nun{animation:none' + I + '}}',

      /* Zwei echte Knoepfe nebeneinander, je halbe Breite. Das Gewicht ist
         absichtlich ungleich: „Weitere Wand" traegt den Markenrahmen, „Neu
         berechnen" nur eine stille Flaeche. */
      /* v528 (Björn 15.09.): „Die Knöpfe können noch ein Stückchen höher."
         Margin raus — .mc-item ist eine Flex-Spalte mit gap:12px, das Margin kam
         oben drauf (23 px statt 12). Jetzt liegen Mengenzeile und Knopfzeile im
         selben Abstand zum Block darüber. */
      p + '.is-v2 .mc-nebenaktionen{grid-column:1 / -1'+I+';display:grid'+I+';grid-template-columns:1fr 1fr'+I+';gap:10px'+I+';margin:0'+I+'}',
      /* v528 (Björn 15.09.): „Die Knöpfe bisschen weniger Höhe." Beide Maße
         müssen runter — das Polster UND die Mindesthöhe, sonst hält letztere
         die alte Höhe fest. 36 px bleibt über der 24-px-Grenze für Tippziele. */
      p + '.is-v2 .mc-nebenaktionen .mc-item-recalc{width:100%'+I+';margin:0'+I+';padding:7px 6px'+I+';font-size:12.5px'+I+';min-height:36px'+I+';gap:5px'+I+'}',
      p + '.is-v2 .mc-nebenaktionen .mc-item-recalc svg{width:13px'+I+';height:13px'+I+';flex:0 0 13px'+I+'}',
      /* Auf 360 px brach „Weitere Wand" zweizeilig um und machte den Knopf
         wieder 46 px hoch — die Höhe kam dort also vom Text, nicht vom Polster.
         Einzeilig erzwingen, seitliches Polster knapper. */
      p + '.is-v2 .mc-nebenaktionen .mc-item-recalc span{white-space:nowrap'+I+'}',
      /* Der additive Weg: Markenrahmen, Markenfarbe. */
      p + '.is-v2 .mc-item-addwall{border-color:#D6001C'+I+';color:#D6001C'+I+';font-weight:700'+I+';margin-top:0'+I+'}',
      p + '.is-v2 .mc-item-addwall:hover{background:rgba(214,0,28,.06)'+I+';border-color:#D6001C'+I+'}',
      /* Der wegwerfende Weg: stille Flaeche, kein Rahmen, gedaempfte Schrift. */
      p + '.is-v2 [data-mc-recalc]{background:var(--ds-surface-alt,#f5f4f5)'+I+';border-color:transparent'+I+';color:var(--ds-text-dim,#6e6870)'+I+';font-weight:600'+I+'}',
      p + '.is-v2 [data-mc-recalc]:hover{color:#D6001C'+I+';border-color:transparent'+I+';background:var(--ds-surface-alt,#efedef)'+I+'}',

      /* Zusicherungen unter dem Kaufknopf */
      /* v528: Abstaende unter dem Kaufknopf. Gemessen waren es 23 und 21 px —
         beide setzen sich aus Margin PLUS Padding ueber der Trennlinie zusammen
         und waren dadurch doppelt so gross wie alles darueber (10/4/9 px).
         Jetzt beide 14 px: 6 Margin + 8 Padding, die Linie sitzt mittig dazwischen. */
      /* v528 — Abstände 1:1 aus Entwurf C, dort nachgemessen:
           Summe → Zusatzzeile        3 px
           Zusatzzeile → Kaufknopf   11 px
           Kaufknopf → Zusicherungen 11 px
           Zusicherungen → Zahlarten 12 px
           Zusicherungen untereinander 8 px
           Fuß-Innenabstand 13px 14px 15px
         Die Trennlinien liegen jeweils mittig im Abstand, nicht zusätzlich. */
      p + '.is-v2 .mc-zusi{display:grid'+I+';gap:8px'+I+';margin:11px 0 0'+I+';padding:0'+I+';border-top:0'+I+'}',
      p + '.is-v2 .mc-zusi div{display:grid'+I+';grid-template-columns:24px minmax(0,1fr)'+I+';gap:9px'+I+';align-items:start'+I+';font-size:12.5px'+I+';line-height:1.42'+I+';color:var(--ds-text-dim,#666)'+I+'}',
      p + '.is-v2 .mc-zusi b{color:var(--ds-text,#111)'+I+';font-weight:600'+I+'}',
      p + '.is-v2 .mc-zusi-hk{color:#1E7A34'+I+';font-weight:700'+I+'}',
      /* Symbolspalte: feste 24 px, damit die drei Zeilen trotz verschiedener
         Bilder an derselben Textkante beginnen. */
      p + '.is-v2 .mc-zusi-bild{width:24px'+I+';height:24px'+I+';object-fit:contain'+I+';display:block'+I+';margin-top:1px'+I+'}',
      p + '.is-v2 .mc-zusi-bild.is-rund{border-radius:50%'+I+';object-fit:cover'+I+'}',
      /* Der Lastwagen sitzt in derselben 24-px-Spalte wie Siegel und Foto,
         damit alle drei Zeilen an einer Textkante beginnen. */
      p + '.is-v2 .mc-zusi-lkw{font-size:15px'+I+';line-height:1'+I+';display:block'+I+';width:24px'+I+';text-align:center'+I+';margin-top:1px'+I+'}',
      /* Der Versandsatz steht in v2 in den Zusicherungen — dort ohne eigenen
         Kasten, sonst wäre es ein Rahmen im Rahmen. */
      p + '.is-v2 .mc-zusi .mc-ship-in{background:none'+I+';padding:0'+I+';margin:0'+I+';border:0'+I+'}',

      /* Zahlarten schließen den Fuß ab: die Frage „womit kann ich zahlen"
         stellt sich beim Klicken, nicht davor. */
      /* v528 (Björn 15.09.): „Die Icons, die da drüber stehen, noch ein bisschen
         näher dran." Gemeint ist der Abstand nach OBEN zu den Zusicherungen —
         12 auf 6 px. Die Zahlarten gehören optisch zum Kaufknopf-Block, nicht
         als eigener Absatz dazwischen. */
      p + '.is-v2 .mc-paylogos{margin-top:6px'+I+';padding-top:0'+I+';border-top:0'+I+'}',
      /* v528 (Björn): „vielleicht noch auf sichere Verbindung eingehen, mit so
         einem Schloss dran — sowas haben wir noch gar nicht."
         Stimmt, und es gehört HIERHER, nicht auf den Kaufknopf: Die Frage nach
         der Sicherheit stellt sich beim Blick auf die Zahlarten, nicht beim
         Lesen der Knopfbeschriftung. Der Knopf behält seine eigene Zusage. */
      p + '.is-v2 .mc-sicher{display:block'+I+';margin:14px 0 0'+I+';font-size:12px'+I+';line-height:1.4'+I+';color:var(--ds-text-dim,#6e6870)'+I+';text-align:center'+I+';text-wrap:balance'+I+'}',
      p + '.is-v2 .mc-sicher svg{width:12px'+I+';height:12px'+I+';display:inline-block'+I+';vertical-align:-2px'+I+';margin-right:5px'+I+'}',
      /* v532: nicht mehr an .is-v2 gebunden — der Zusatz erscheint jetzt in
         BEIDEN Fassungen, also muss auch seine Regel in beiden greifen.
         Spezifitaet faellt von (1 ID + 2 Klassen) auf (1 ID + 1 Klasse);
         unkritisch, weil .mc-qty-zus sonst nirgends angesprochen wird. */
      p + ' .mc-qty-zus{display:block'+I+';font-size:12px'+I+';color:var(--ds-text-dim,#8a8a8a)'+I+';font-weight:500'+I+';margin-top:1px'+I+'}',
      /* Medienspalte: Bild oben, Lieferumfang direkt darunter, gemeinsame linke
         Kante. Die Spalte ist breiter als das 84-px-Bild, weil „Injektions-
         aufsatz" sonst mitten im Wort bräche — gemessen, nicht geschätzt. */
      /* Menge/Preis als eigene Zeile unter der Bildzeile: linke Kante des
         Kartenpolsters, Preis rechts. Die Grundlinie der ersten Mengenzeile
         trägt den Preis — deshalb align-items:baseline (steht schon in der
         Grundregel) und kein zusätzliches Ausrichten hier. */
      /* v528 (Björn 15.09.): „Abstand nach oben bisschen geringer."
         Gemessen waren es 23 px, nicht die 11 aus dem Margin: .mc-item ist eine
         Flex-Spalte mit gap:12px, und ein Margin ADDIERT sich darauf (dieselbe
         Falle wie damals im Fuß, wo aus 11 px gemessene 21 wurden). Margin auf
         0 — dann gilt allein der gap, also 12 px. Die Knöpfe darunter behalten
         ihre 23 px: sie sind eine eigene Handlung, die Mengenzeile gehört noch
         zum Produkt. */
      p + '.is-v2 .mc-item > .mc-qtyprice{margin:0'+I+';width:100%'+I+'}',
      /* Wanddaten als eigener, sanft blau hinterlegter Kasten. Blau wie die
         Fortschrittsschiene (#1565C0) — informierend, nicht warnend; Rot ist auf
         dieser Seite für „kaufen" reserviert. Deckkraft bewusst niedrig, der
         Kasten soll ordnen, nicht rufen. */
      p + '.is-v2 .mc-props{background:rgba(21,101,192,.055)'+I+';border:1px solid rgba(21,101,192,.13)'+I+';border-radius:8px'+I+';padding:8px 10px'+I+';margin:3px 0 0'+I+';gap:0'+I+'}',
      p + '.is-v2 .mc-prop-row--daten{display:block'+I+'}',
      p + '.is-v2 .mc-prop-row--daten .mc-prop-key{display:flex'+I+';align-items:center'+I+';gap:5px'+I+';font-size:11.5px'+I+';font-weight:700'+I+';color:#1565C0'+I+';line-height:1.2'+I+';margin:0 0 2px'+I+'}',
      p + '.is-v2 .mc-prop-row--daten .mc-verif{width:14px'+I+';height:14px'+I+';min-width:14px'+I+';flex:none'+I+';display:block'+I+'}',
      p + '.is-v2 .mc-prop-haupt{display:block'+I+';font-size:13px'+I+';font-weight:700'+I+';color:var(--ds-text,#111)'+I+';line-height:1.25'+I+'}',
      p + '.is-v2 .mc-prop-neben{display:block'+I+';font-size:12px'+I+';font-weight:500'+I+';color:var(--ds-text-muted,#666)'+I+';line-height:1.28'+I+';margin-top:1px'+I+'}',
      /* Der Produktname war auf EINE Zeile geklemmt und las sich dadurch als
         „Isofin®…" — unbrauchbar, wo der Name laut Vorgabe exakt dem in Shopify
         entsprechen soll. Der Grund für die Klemme war Platzmangel in der
         rechten Spalte; der ist mit der eigenen Preiszeile weg. Zwei Zeilen,
         und das Polster rechts hält den Entfernen-Knopf frei. */
      p + '.is-v2 .mc-name{-webkit-line-clamp:3'+I+';padding:0 34px 0 0'+I+'}',
      /* Volle Kartenbreite, eine Zeile. 13,5 px statt 14, weil der Name bei
         360 px sonst 2 px zu breit wäre. Auslassungspunkte nur als Netz für
         künftig längere Produktnamen. */
      /* 25.09.: Name in der Spalte neben dem Bild (v2-Sanierungspaket), darf umbrechen;
         rechts 30 px frei für den Entfernen-Knopf. */
      p + '.is-v2 .mc-name.mc-name--spalte{display:block'+I+';white-space:normal'+I+';overflow:visible'+I+';-webkit-line-clamp:unset'+I+';font-size:14.5px'+I+';font-weight:700'+I+';line-height:1.25'+I+';padding:0 30px 0 0'+I+';margin:0 0 3px'+I+'}',
      p + '.is-v2 .mc-name--voll{display:block'+I+';white-space:nowrap'+I+';overflow:hidden'+I+';text-overflow:ellipsis'+I+';font-size:13.5px'+I+';line-height:1.25'+I+';padding:0 26px 0 0'+I+';margin:0'+I+'}',
      /* Handbuch-Zeile: eine Zeile, kein Umbruch. display:block statt -webkit-box,
         weil nowrap + Auslassungspunkte im Box-Modell unzuverlässig greifen.
         Kein Polster rechts — der Entfernen-Knopf sitzt bei der Geschenkzeile
         nicht über dem Titel, sondern der Preis steht als eigene Spalte daneben. */
      p + '.is-v2 .mc-item--gift .mc-name{display:block'+I+';white-space:nowrap'+I+';overflow:hidden'+I+';text-overflow:ellipsis'+I+';padding:0'+I+';font-size:13px'+I+';margin:0'+I+'}',
      /* v528 (Björn 15.09.): „Die Leerzeile muss da weg."
         Ursache gemessen: die Zeile ist 34,3 px hoch (der Preisblock stapelt
         29,90 € über gratis), der Knopf darin nur 14 px — mit align-items:
         center stand er mittig und ließ 15,7 px Luft zwischen Titel und Knopf
         stehen, was wie eine Leerzeile aussah. Oben ausrichten: der Knopf sitzt
         direkt unter dem Titel, der durchgestrichene Preis auf seiner Höhe.
         Die Kartenhöhe ändert sich nicht — die gibt ohnehin das 56-px-Bild vor. */
      p + '.is-v2 .mc-item--gift .mc-gift-top{align-items:flex-start'+I+';gap:8px'+I+'}',
      /* „Sonst mach die Schrift minimal kleiner": bei 360 px blieben mit 13 px
         nur 4,3 px Reserve — zu knapp, wenn Rubik nicht lädt und eine Systemschrift
         einspringt. 12,5 px bringt die Reserve auf 10,8 px. */
      /* v612 (Adrian 15.10.): Der Titel hat jetzt die ganze Spaltenbreite (der Preis steht
         in der Zeile darunter) – wieder 13,5 px wie die Messgerät-Zeile (175 px bei 211 px
         Spalte auf 360 px). */
      p + '.is-v2 .mc-item--gift .mc-name{font-size:13.5px'+I+';line-height:1.2'+I+'}',
      /* Unter 360 px reicht auch das nicht (bei 320 px stünden nur 132 px zur
         Verfügung). Dort lieber zweizeilig als mit Auslassungspunkten — ein
         abgeschnittener Titel verliert Information, ein Umbruch nicht. */
      '@media (max-width:359px){' + p + '.is-v2 .mc-item--gift .mc-name{white-space:normal'+I+';text-overflow:clip'+I+'}' +
        p + '.is-v2 .mc-gift-toc{white-space:normal'+I+';text-overflow:clip'+I+'}}',
      /* Der Knopf trägt in v2 ein Wort weniger, damit er neben dem Preis in eine
         Zeile geht; die Auslassungspunkte sind nur Netz für noch schmalere
         Geräte, damit er nie zweizeilig umbricht. */
      p + '.is-v2 .mc-gift-toc{white-space:nowrap'+I+';overflow:hidden'+I+';text-overflow:ellipsis'+I+';min-width:0'+I+'}',
      /* v534 (Björn 17.09.): Handbuch-Karte — „Preis und gratis neben die Schrift
         und Bild zentriert, nicht so weit nach unten“. Der Preis saß in der
         Zeile mit „Inhaltsverzeichnis“ und damit gemessen 11 px unter der
         Bildmitte. Ohne Markup-Änderung: .mc-gift-top löst sich per
         display:contents auf, Titel und Inhaltsverzeichnis stehen links
         untereinander, der Preis rechts über beide Zeilen und mittig.
         Gemessen danach: Preismitte = Bildmitte. margin:0 am
         Inhaltsverzeichnis, weil eine ältere Regel ihm 6 px unten gab und
         den Textblock sonst 3 px über die Mitte schob. */
      p + '.is-v2 .mc-item--gift .mc-item-main{align-items:center'+I+'}',
      /* v612 (Adrian 15.10.): Handbuch-Zeile wie die Messgerät-Zeile – das Raster mit dem
         über zwei Zeilen gestapelten Preis entfällt. Titel / Menge + „~~29,90 €~~ gratis"
         in einer Zeile / Inhaltsverzeichnis, untereinander, mittig neben dem 56-px-Bild.
         Zeilenhöhen knapp (1,2 / 1,15), damit drei Zeilen in die 56 px des Bildes passen
         und die Karte nicht höher wird als die Messgerät-Zeile (gemessen). */
      p + '.is-v2 .mc-item--gift .mc-info{display:flex'+I+';flex-direction:column'+I+';justify-content:center'+I+';gap:2px'+I+'}',
      p + '.is-v2 .mc-item--gift .mc-info > .mc-qtyprice{margin:0'+I+'}',
      p + '.is-v2 .mc-item--gift .mc-gift-toc{margin:0'+I+';align-self:flex-start'+I+';font-size:13px'+I+';line-height:1.15'+I+'}',
      /* Nachbesserung: Trefferfläche 44 px hoch (vorher 16 px) ohne die Zeile höher zu machen –
         Innenabstand 12 oben / 17 unten / 6 seitlich, durch gleich große negative Ränder wieder
         abgezogen. Darunter liegen gemessen nur Text und die 15 px Kartenrand unten, kein
         anderer Knopf (v496: die ganze Zeile darf NICHT zum Inhaltsverzeichnis führen – deshalb
         nicht mehr als die Menge-Zeile links darüber). Steht direkt nach der Regel oben, damit
         deren margin:0 hier überschrieben wird. */
      p + '.is-v2 .mc-item--gift .mc-info > .mc-gift-toc{padding:12px 6px 17px'+I+';margin:-12px -6px -17px'+I+'}',
      p + '.is-v2 .mc-item--gift .mc-price--gift{flex-direction:row'+I+';align-items:baseline'+I+';justify-content:flex-end'+I+';gap:6px'+I+'}',
      /* v528 (Björn 15.09.): „Nicht zu viel Abstand zum Bild, der ist sehr groß."
         Dahinter steckte ein echter Fehler: unterhalb der Umbruchbreite
         schrumpft das Bild auf 72 px, die Rasterspalte blieb aber bei 84 px
         stehen (die Regel dafür zielt auf .mc-item, das ist aber eine Flex-
         Spalte — grid-template-columns lief dort ins Leere). Sichtbar waren
         also 12 px tote Fläche PLUS 16 px Abstand.
         auto statt fester Breite: die Spalte ist immer exakt so breit wie das
         Bild, egal welche Größe gilt. Der Abstand steht dann allein im gap. */
      p + '.is-v2 .mc-item-main{grid-template-columns:auto minmax(0,1fr)'+I+';gap:9px'+I+';align-items:start'+I+'}',
      p + '.is-v2 .mc-item > .mc-qtyprice .mc-qty-text{font-size:13px'+I+';font-weight:600'+I+';color:var(--ds-text,#333)'+I+';line-height:1.3'+I+'}',
      /* 25.09. (Björn, Reihenfolge): beim Sanierungspaket steht Menge/Preis jetzt
         IN der Spalte neben dem Bild (unter den Sternen, über dem Wanddaten-
         Kasten). Die beiden Regeln darüber zielen mit „.mc-item >" auf die alte
         Lage und greifen dort nicht mehr — hier dieselben Werte für die neue.
         Außerhalb jeder Medienregel: gilt für 360 px wie für 440 px Panel.
         Raster statt Flex: Zeile 1 = Menge links, Preis rechts (gemeinsame
         Grundlinie); Zeile 2 = „inkl. Injektionsaufsatz und Anleitung“ über
         die volle Spaltenbreite. minmax(0,1fr) lässt die Menge umbrechen,
         statt den Preis aus der Zeile zu schieben (360 px, vierstelliger Preis). */
      p + '.is-v2 .mc-info > .mc-qtyprice{display:grid'+I+';grid-template-columns:minmax(0,1fr) auto'+I+';column-gap:10px'+I+';row-gap:0'+I+';align-items:baseline'+I+';margin:4px 0 0'+I+';width:100%'+I+'}',
      p + '.is-v2 .mc-info > .mc-qtyprice .mc-qty-text{font-size:13px'+I+';font-weight:600'+I+';color:var(--ds-text,#333)'+I+';line-height:1.3'+I+';min-width:0'+I+'}',
      p + '.is-v2 .mc-info > .mc-qtyprice .mc-price{grid-column:2'+I+';grid-row:1'+I+';white-space:nowrap'+I+'}',
      p + '.is-v2 .mc-info > .mc-qtyprice > .mc-qty-zus{grid-column:1 / -1'+I+';grid-row:2'+I+';line-height:1.3'+I+'}',
      p + '.is-v2 .mc-info > .mc-qtyprice + .mc-props{margin:6px 0 0'+I+'}',
      /* Der Fuss hatte unten nur 6 px — die Logozeile klebte am Rand. */
      /* Der Fuß ist ein Flex-Container mit gap:10px — der addiert sich auf JEDEN
         Margin darin. Deshalb kamen aus 11 px gemessene 21. In v2 auf 0, dann
         gilt genau das, was hier steht. */
      /* v528 (Björn 15.09.): „Hier unten noch ein bisschen Platz gewinnen."
         15 auf 9 px. Dabei das Safe-Area-Polster zurückgeholt: die v2-Regel hat
         die Medienregel mit env(safe-area-inset-bottom) überschrieben, dadurch
         saß der Fußrand auf iPhones mit Home-Leiste knapp darunter. */
      /* v533 (Björn 17.09.): Abstand über „Gesamtpreis“ verringern.
         Gemessen 31 px = 13 Polster + 10 Marge. Polster 13 -> 10. */
      p + '.is-v2 .mc-foot{padding:10px 14px calc(9px + env(safe-area-inset-bottom,0px))'+I+';gap:0'+I+'}',
      /* v533: Die 10 px Marge über dem Gesamtpreis waren im Normalfall reiner
         Leerraum — gemessen steht davor NICHTS. Nur mit aktivem Rabattcode
         sitzt dort die Rabattzeile, und nur dann braucht der Preis Abstand.
         Deshalb Marge 0, und 8 px nur, wenn ein Geschwister davor steht.
         Gemessen danach: 18 px statt 31. */
      p + '.is-v2 .mc-total{margin-top:0'+I+'}',
      p + '.is-v2 .mc-foot > * + .mc-total{margin-top:8px'+I+'}',
      p + '.is-v2 .mc-total-sub{margin-top:3px'+I+'}',
      /* v528 (Björn 15.09.): „Kostenloser Versand kann auch ein bisschen dünner
         geschrieben sein." Das <strong> im Markup zieht 700er Fett; die Aussage
         trägt schon durch das Grün und muss dem Gesamtpreis darüber nicht die
         Aufmerksamkeit streitig machen. Auf 600 herunter, Farbe bleibt. */
      p + '.is-v2 .mc-tax-note--free strong{font-weight:600'+I+'}',
      /* Kopfzeile, Fortschrittsleiste und Positionskarten ebenfalls auf die
         Maße des Entwurfs. */
      /* v533 (Björn 17.09.): roter Kopf „bisschen schmaler in der Höhe“.
         Gemessen 71 px. Die Höhe bestimmt der Schliessen-Knopf (44 px) — den
         nicht verkleinern, das ist die Mindest-Trefferfläche. Also nur das
         Polster: 14/12 -> 8/7, gemessen danach 60 px. */
      p + '.is-v2 .mc-head{padding:8px 14px 7px'+I+'}',
      /* v528 (Björn 15.09.): „Etwas weniger Abstand nach oben, kann näher unter
         den Header."
         Gemessen waren es 28 px bis zur Balkenkante: 16 px Polster des Körpers
         plus 12 px eigenes. Das eigene fällt weg, und ein negatives Margin holt
         6 px vom Körper-Polster zurück — die Schiene sitzt damit 10 px unter der
         Kopfzeile und liest sich als deren Fortsetzung statt als eigener Block.
         Das Margin zieht nur gegen das Polster des Körpers (die Schiene ist
         dessen erstes Kind), berührt also nichts darunter. */
      p + '.is-v2 .mc-rail{padding:0 0 4px'+I+';margin:-6px 0 0'+I+'}',
      /* v533 (Björn 17.09.): Sanierungspaket „alles sehr eng, ganz bisschen mehr
         Luft überall“. Bewusst nur +2/+3 px, damit früher gewollte
         Verdichtungen (Abstand zum Bild, Knopfhöhe) nicht zurückgedreht werden.
         Polster 13/14 -> 16, Spaltenabstand 12 -> 14, Bild-Text 9 -> 11.
         NUR für die Sanierungspaket-Karte (:not(.mc-item--gift)). Die erste
         Fassung traf beide Karten und machte die Handbuch-Karte schlechter —
         Björn: „da waren Abstände ok, nur der Rest nicht“. Deshalb bleiben
         Handbuch-Karte und Abstand zwischen den Karten wie vorher. */
      p + '.is-v2 .mc-item{padding:13px 14px'+I+'}',
      /* v611: auch die kompakte Zubehör-Zeile (.mc-item--zub) ausgenommen — die
         Karten-Regeln gelten nur noch für Paket und Einzelflaschen. */
      p + '.is-v2 .mc-item:not(.mc-item--gift):not(.mc-item--zub){padding:16px 16px'+I+';gap:14px'+I+'}',
      p + '.is-v2 .mc-item:not(.mc-item--gift):not(.mc-item--zub) .mc-item-main{gap:11px'+I+'}',
      /* ═══════════════════════════════════════════════════════════════
         v611 (Adrian 15.10.): kompakte Zubehör-Zeile (Messgerät, Gratis-Messgerät,
         gekauftes Handbuch). Maße wie die Geschenk-Zeile: Polster 13/14, Bild
         56 px, Abstand 11 px, Text mittig neben dem Bild. Gilt in v1 UND v2 —
         Selektor „.mc-item.mc-item--zub" (1 ID + 2–3 Klassen) schlägt die
         allgemeinen v1-Regeln und die .is-v2-Namensregel, ohne sie anzufassen.
         Schrift nirgends unter 13 px (Zielgruppe 45+).
         Entfernen-Knopf: sichtbar weiter 40 px (v492: bewusst zurückhaltend,
         Löschen ohne Rückfrage), die Trefferfläche wächst per unsichtbarem
         ::after um 2 px je Seite auf 44 × 44 px (−3 px ab Innenkante, weil der
         Knopf 1 px Rahmen trägt — gemessen). Der Name hält rechts 30 px frei,
         der Knopf überdeckt also weder Name noch Preis. */
      p + ' .mc-item.mc-item--zub{padding:13px 14px'+I+'}',
      p + ' .mc-item.mc-item--zub .mc-item-main{grid-template-columns:56px minmax(0,1fr)'+I+';gap:11px'+I+';align-items:center'+I+'}',
      p + ' .mc-item.mc-item--zub .mc-thumb{width:56px'+I+';height:56px'+I+'}',
      p + ' .mc-item.mc-item--zub .mc-info{gap:4px'+I+'}',
      p + ' .mc-item.mc-item--zub .mc-name{font-size:13.5px'+I+';line-height:1.25'+I+';-webkit-line-clamp:2'+I+';padding:0 30px 0 0'+I+';margin:0'+I+'}',
      p + ' .mc-item.mc-item--zub .mc-info > .mc-qtyprice{margin:0'+I+'}',
      /* Gratis: durchgestrichener Wert und „gratis" in EINER Zeile statt gestapelt. */
      p + ' .mc-item.mc-item--zub .mc-price--gift{flex-direction:row'+I+';align-items:baseline'+I+';justify-content:flex-end'+I+';gap:6px'+I+'}',
      p + ' .mc-item.mc-item--zub .mc-item-x::after{content:""'+I+';position:absolute'+I+';top:-3px'+I+';right:-3px'+I+';bottom:-3px'+I+';left:-3px'+I+';border-radius:50%'+I+'}',
      p + '.is-v2 .mc-checkout{margin-top:11px'+I+';margin-bottom:0'+I+'}',
      /* Zweizeiliger Kaufknopf: Titel mit Pfeil, darunter die Beruhigung. */
      p + '.is-v2 .mc-checkout{display:flex'+I+';flex-direction:column'+I+';align-items:center'+I+';justify-content:center'+I+';gap:3px'+I+';line-height:1.25'+I+';padding-top:14px'+I+';padding-bottom:14px'+I+'}',
      p + '.is-v2 .mc-checkout-txt{display:inline-flex'+I+';align-items:center'+I+';gap:9px'+I+'}',
      /* v612 (Adrian 15.10.): Unterzeile 12,5 -> 13 px (Zielgruppe 45+), Knopf sonst gleich. */
      p + '.is-v2 .mc-checkout-sub{font-size:13px'+I+';font-weight:500'+I+';opacity:.92'+I+'}',
      /* ═══════════════════════════════════════════════════════════════
         v612 (Adrian 15.10.) – Garantie an den Isofin-Zeilen, schmaler Fuß,
         Zusicherungen im Rumpf. Steht hinter allen älteren v2-Regeln, damit sie bei
         gleicher Spezifität gewinnt. Schrift nirgends unter 13 px (Zielgruppe 45+).
         v613 (Adrian 15.10.): Zusicherungen wieder im Fuß unter dem Kaufknopf, siehe unten.
         ═══════════════════════════════════════════════════════════════ */
      /* Garantie-Zeile (v1 und v2): Siegel 20 px und Text per align-items:center auf
         derselben Mitte (Wunsch A). Abstand v1: 10 px; v2: Karten-gap 14 − 6 = 8 px darüber,
         14 − 2 = 12 px darunter (die Zeile gehört zum Produkt, die Knöpfe sind eigene Handlung). */
      p + ' .mc-item > .mc-garantie{display:flex'+I+';align-items:center'+I+';gap:7px'+I+';margin:10px 0 0'+I+';padding:0'+I+';font-size:13px'+I+';line-height:1.3'+I+';font-weight:600'+I+';color:var(--ds-text,#111)'+I+';letter-spacing:0'+I+'}',
      p + ' .mc-garantie-bild{width:20px'+I+';height:20px'+I+';min-width:20px'+I+';max-width:20px'+I+';flex:0 0 20px'+I+';object-fit:contain'+I+';display:block'+I+';margin:0'+I+';padding:0'+I+';border:0'+I+';border-radius:0'+I+';box-shadow:none'+I+';background:none'+I+'}',
      p + ' .mc-garantie-txt{min-width:0'+I+';padding:0'+I+';margin:0'+I+';line-height:1.3'+I+'}',
      p + '.is-v2 .mc-item > .mc-garantie{margin-top:-6px'+I+';margin-bottom:-2px'+I+'}',
      /* ═══════════════════════════════════════════════════════════════
         v613 (Adrian 15.10.): „Die Reihenfolgen nicht ändern." Der feste Fuß steht wieder in
         der Reihenfolge von v611, aber mit den engen Abständen und 13-px-Schriften aus v612:
           Rabattzeile (schmal, ohne X, ohne Kasten) → Gesamtpreis mit „inkl. MwSt." klein davor
           → „Kostenloser Versand in Deutschland" → Code-Chip „✓ Rabattcode … ✕" (Platz wie v611)
           → Kaufknopf → Zusicherungen (Hendrik, Versand) → Zahlarten → „Verschlüsselte Verbindung".
         Entfallen: durchgestrichener Listenpreis vor dem Gesamtpreis, X in der Rabattzeile,
         Versandblock unter dem Gesamtpreis und Zusicherungen im Rumpf (v612).
         v615 (Adrian 16.10.): Chip entfallen, X ganz rechts in der Rabattzeile (Regeln unten).
         ═══════════════════════════════════════════════════════════════ */
      /* Rabattzeile: Bezeichnung links, Betrag rechts, eine Zeile, ohne Knopf (v613: das X sitzt
         wieder im Code-Chip). Grün #0A7D56 auf dem Fußgrund ≥ 4,5:1. Gilt in v1 und v2.
         v615 (Adrian 16.10.): mit Code wieder mit X, ganz rechts – Regeln direkt darunter. */
      p + ' .mc-rabatt{display:flex'+I+';align-items:baseline'+I+';gap:6px'+I+';margin:0'+I+';padding:0'+I+';font-size:13px'+I+';line-height:1.25'+I+';font-weight:600'+I+';color:#0A7D56'+I+'}',
      p + ' .mc-rabatt-lbl{min-width:0'+I+';padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-rabatt-wert{margin:0 0 0 auto'+I+';padding:0 0 0 8px'+I+';font-weight:700'+I+';white-space:nowrap'+I+'}',
      /* Rabattzeile → Gesamtpreis 4 px (v2: Fuß ohne gap, sonst griffe v533 mit 8 px;
         v1: Fuß-gap 10 px, daher −6 px). */
      p + '.is-v2 .mc-foot > .mc-rabatt + .mc-total{margin-top:4px'+I+'}',
      p + ':not(.is-v2) .mc-foot > .mc-rabatt + .mc-total{margin-top:-6px'+I+'}',
      /* v615 (Adrian 16.10.): Entfernen-X ganz rechts in der Rabattzeile (statt im blauen Chip).
         Aussehen unverändert aus .mc-coupon-off (26 px, 44 px Tippfläche per ::after). Betrag und X
         bleiben zusammen in einer Zeile (Betrag nowrap, X fest 26 px), nur die Bezeichnung bricht um.
         10 px zwischen Betrag und X (6 gap + 4), damit die 44-px-Fläche (9 px über den Rand) nicht
         in den Betrag reicht. Zeile mit X 26 px hoch, senkrecht mittig. */
      p + ' .mc-rabatt--x, ' + p + ' .mc-rabatt--code{align-items:center'+I+'}',
      p + ' .mc-rabatt .mc-coupon-off{margin:0 0 0 4px'+I+'}',
      p + ' .mc-rabatt--code .mc-coupon-off{margin-left:auto'+I+'}',
      /* Zwei Zeilen (Mengenrabatt + Code ohne Betrag) 10 px; nach dem Aktions-Kasten 6 px
         (v2: Fuß ohne gap; v1: Fuß-gap 10 px, daher negativ).
         v615 Nachbesserung (Prüfung 16.10.): senkrecht mindestens 9 px Luft um jede Zeile mit X.
         Die 44-px-Tippfläche ragt 9 px über und unter den 26-px-Knopf; mit 2 bzw. 4 px Abstand
         lag sie über „−60,00 €" (Mengenrabatt) bzw. dem oberen Rand des Gesamtpreises – ein Tipp
         dort entfernte den Code. Der Gesamtpreis (24/22 px, Zeilenhöhe 1) ragt mit seinen Glyphen
         3 px über seine Zeile, daher dort 9 + 3 + 1 Reserve = 13 px (gemessen: Tippfläche endet dann
         1 px über der Glyphenbox des Preises). Zur Nachbarzeile ebenso 9 + 1 Reserve = 10 px (sonst
         berührten sich Tippfläche und Zeile auf einer Linie). Im Aktions-Kasten (gap 4 px) oben 6 px,
         unten 4 px Rand (die Pflichtangabe darunter bringt 2 px mit) – je 10 px zur Nachbarzeile. */
      p + '.is-v2 .mc-foot > .mc-rabatt + .mc-rabatt{margin-top:10px'+I+'}',
      p + ':not(.is-v2) .mc-foot > .mc-rabatt + .mc-rabatt{margin-top:0'+I+'}',
      p + '.is-v2 .mc-foot > .mc-rabatt--x + .mc-total, ' + p + '.is-v2 .mc-foot > .mc-rabatt--code + .mc-total{margin-top:13px'+I+'}',
      p + ':not(.is-v2) .mc-foot > .mc-rabatt--x + .mc-total, ' + p + ':not(.is-v2) .mc-foot > .mc-rabatt--code + .mc-total{margin-top:3px'+I+'}',
      p + '.is-v2 .mc-foot > .mc-rabatt--x + .mc-ak-warn, ' + p + '.is-v2 .mc-foot > .mc-rabatt--code + .mc-ak-warn{margin-top:10px'+I+'}',
      p + ' .mc-total-row-saved.mc-hat-x{margin:6px 0 4px'+I+'}',
      /* Sehr lange Codes (bis 40 Zeichen, ohne Trennstelle) brechen um, statt unter das X zu laufen;
         ebenso die Bezeichnung im Aktions-Kasten (dort fehlte min-width:0). Nur Anzeige. */
      p + ' .mc-rabatt-lbl{overflow-wrap:anywhere'+I+'}',
      p + ' .mc-total-row-saved.mc-hat-x > span:first-child{min-width:0'+I+';overflow-wrap:anywhere'+I+'}',
      p + '.is-v2 .mc-foot > .mc-total-detail + .mc-rabatt{margin-top:6px'+I+'}',
      p + ':not(.is-v2) .mc-foot > .mc-total-detail + .mc-rabatt{margin-top:-4px'+I+'}',
      /* Aktion: X rechts hinter dem Betrag der Ersparniszeile im Kasten (Kasten sonst unverändert). */
      p + ' .mc-total-row-saved.mc-hat-x{align-items:center'+I+'}',
      p + ' .mc-total-row-saved.mc-hat-x .mc-total-saved-val{margin-left:auto'+I+';white-space:nowrap'+I+'}',
      /* „(inkl. Code)" in dieser Zeile: 13 statt 11,5 px und #5f5b56 statt #888 (≥ 4,5:1, Zielgruppe 45+). */
      p + ' .mc-total-row-saved.mc-hat-x .mc-disc-code{font-size:13px'+I+';color:#5f5b56'+I+'}',
      p + ' .mc-total-val{text-align:right'+I+'}',
      /* Zusatzzeile unter dem Gesamtpreis (wie v611: links Versandhinweis, der Code-Chip bricht
         rechtsbündig in eine eigene Zeile um) – Zeilenabstand 2 statt 10 px, Schrift 13 px.
         v615 (Adrian 16.10.): Chip entfallen, X in der Rabattzeile; die Chip-Regeln hier und
         .mc-coupon-on/.mc-coupon-trigger sind ohne Wirkung (später aufräumen). */
      p + ' .mc-total-sub{row-gap:2px'+I+'}',
      p + ' .mc-tax-note{font-size:13px'+I+'}',
      p + '.is-v2 .mc-total-sub{margin-top:2px'+I+'}',
      p + '.is-v2 .mc-total-sub .mc-tax-note{font-size:13px'+I+';line-height:1.3'+I+'}',
      p + ' .mc-coupon-on-txt{font-size:13px'+I+';line-height:1.25'+I+';min-width:0'+I+';text-align:right'+I+';text-wrap:balance'+I+'}',
      /* Lange Codes (z. B. „willkommenzurueck2026", auf 360 px schon „hendrik10euro"): mit 13 px lief
         der Chip sonst über den rechten Rand (gemessen) – jetzt bricht sein Text um, X bleibt rechts. */
      p + ' .mc-coupon-trigger{flex-shrink:1'+I+';min-width:0'+I+';max-width:100%'+I+'}',
      p + ' .mc-coupon-on{max-width:100%'+I+'}',
      /* Chip → Kaufknopf 10 px: die 44-px-Trefferfläche des X (26 px + 2 × 9 px) endet
         so über dem Knopf statt in ihm. v615 (Adrian 16.10.): Chip entfallen, Abstand bleibt. */
      p + '.is-v2 .mc-checkout{margin-top:10px'+I+'}',
      /* Zusicherungen unter dem Kaufknopf (Hendrik, Versand): eng – Zeilenhöhe 1,35 statt 1,42,
         Abstand 6 statt 8 px, 13 px statt 12,5, Symbol senkrecht mittig zur Textzeile. */
      p + '.is-v2 .mc-zusi{gap:6px'+I+';margin:8px 0 0'+I+'}',
      p + '.is-v2 .mc-zusi > div{grid-template-columns:22px minmax(0,1fr)'+I+';gap:8px'+I+';align-items:center'+I+';font-size:13px'+I+';line-height:1.35'+I+'}',
      p + '.is-v2 .mc-zusi .mc-zusi-bild{width:22px'+I+';height:22px'+I+';margin:0'+I+'}',
      p + '.is-v2 .mc-zusi-lkw{width:22px'+I+';margin:0'+I+'}',
      /* „Verschlüsselte Verbindung" wieder unter den Zahlarten, klein (13 px), eng. */
      p + '.is-v2 .mc-sicher{margin:6px 0 0'+I+';font-size:13px'+I+';line-height:1.3'+I+'}',
      /* v1: Versandzeile über dem Knopf 11 -> 13 px; darf umbrechen statt abgeschnitten zu werden. */
      p + ':not(.is-v2) .mc-ship{font-size:13px'+I+';white-space:normal'+I+';text-wrap:balance'+I+'}',
      /* „gratis" in Handbuch- und Zubehör-Zeile: dasselbe Grün, Kontrast ≥ 4,5:1
         (gemessen vorher 4,24:1 in der Handbuch-Zeile). */
      p + '.is-v2 .mc-item--gift .mc-price--gift .mc-gift-free,' + p + ' .mc-item.mc-item--zub .mc-price--gift .mc-gift-free{color:#0A7D56'+I+'}',
      /* ── und hier beginnt der zweite Mobilblock (v1-Feinschliff) ──── */
      '@media (max-width:520px){',
      /* v612 (Adrian 15.10.): v1-Karten haben mobil gap 12 px – Garantie-Zeile wieder auf 10 px. */
      '  ' + p + ' .mc-item > .mc-garantie{margin-top:-2px'+I+'}',

      '  ' + p + ' .mc-head{padding:4px 14px'+I+'}',
      '  ' + p + ' .mc-head-title h3{font-size:17px'+I+'}',
      '  ' + p + ' .mc-head-sub{font-size:11.5px'+I+'}',
      '  ' + p + ' .mc-body{padding:16px 16px 8px'+I+'}',
      '  ' + p + ' .mc-item{padding:14px'+I+';grid-template-columns:72px 1fr'+I+';gap:12px'+I+'}',
      '  ' + p + ' .mc-thumb{width:72px'+I+';height:72px'+I+'}',
      '  ' + p + ' .mc-foot{padding:12px 12px calc(6px + env(safe-area-inset-bottom,0px))'+I+'}',
      '  ' + p + ' .mc-total-val{font-size:22px'+I+'}',
      '  ' + p + ' .mc-mwst-note{display:none'+I+'}',
      '  ' + p + ' .mc-tax-note--free{font-size:14px'+I+'}',
      /* v613 (Adrian 15.10.): „inkl. MwSt." klein vor dem Preis wie v611 – aber 13 statt 11 px
         (Zielgruppe 45+) und dunkler (#888 lag unter 4,5:1). */
      '  ' + p + ' .mc-mwst-pre{display:inline-block'+I+';font-size:13px'+I+';font-weight:500'+I+';color:var(--ds-text-muted,#666)'+I+';margin-right:6px'+I+';line-height:1'+I+'}',
      '  ' + p + ' .mc-close{width:44px'+I+';height:44px'+I+';background:#fff'+I+';border-radius:50%'+I+'}',
      '  ' + p + ' .mc-close svg{width:20px'+I+';height:20px'+I+'}',
      '}'
    ].join('\n');
    (document.head || document.documentElement).appendChild(st);
  }

  /* ── Inline-Icons (stroke = currentColor) ─────────────────── */
  var ICO = {
    close:    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
    cart:     '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>',
    arrow:    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>',
    refresh:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10"/><path d="M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/></svg>',
    check:    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>',
    verified: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/><path d="m9 12 2 2 4-4"/></svg>',
    tag:      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>'
  };

  /* ── DOM ──────────────────────────────────────────────────── */
  function buildPanel() {
    var el = document.createElement('div');
    el.id = PANEL_ID;
    /* Das Layout haengt an einer Klasse, nicht an getrenntem Markup — Umschalten
       ist damit ein Klassentausch plus Neuzeichnen, kein Neuaufbau. */
    el.className = istV2() ? 'is-v2' : 'is-v1';
    el.innerHTML =
      '<div class="mc-backdrop" data-mc-close></div>' +
      '<aside class="mc-panel" role="dialog" aria-modal="true" aria-label="Warenkorb">' +
        '<header class="mc-head">' +
          '<div class="mc-head-title">' +
            '<h3>Ihr Warenkorb</h3>' +
            '<div class="mc-head-sub" id="mc-head-sub">&nbsp;</div>' +
          '</div>' +
          '<button class="mc-close" data-mc-close aria-label="Warenkorb schlie\u00dfen" title="Schlie\u00dfen">' + ICO.close + '</button>' +
        '</header>' +
        '<div class="mc-body" id="mc-body"></div>' +
        '<footer class="mc-foot" id="mc-foot"></footer>' +
      '</aside>';

    var bodyEl = el.querySelector('#mc-body');
    if (bodyEl) bodyEl.addEventListener('scroll', updateScrollCue, { passive: true });
    w.addEventListener('resize', updateScrollCue);

    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-mc-close]')) { close(); return; }
      /* v501: Rabattcode entfernen
         v503: Hier faellt auch das Rabatt-Signal an. Ein cart_drawer_discount_focus
         im Sinne des Dev-Auftrags ist NICHT baubar — das Eingabefeld wurde in v341
         bewusst entfernt, weil es die Cart->Checkout-Quote senkte (genau die
         Kennzahl, um die es geht). Messbar ist deshalb nur, dass sich jemand mit
         dem angezeigten Code befasst und ihn wieder loswerden will. */
      if (e.target.closest('[data-mc-coupon-off]')) {
        e.preventDefault();
        mcTrack('cart_drawer_discount_remove');
        removeCoupon();
        return;
      }
      /* Handbuch-/Inhaltsverzeichnis-Zeile. Der Klick selbst wird in der zweiten
         IIFE verarbeitet (openToc), die aber denselben Selektor auch auf der
         Ergebnisseite faengt — dort ist die Herkunft nicht unterscheidbar. Hier im
         Panel ist sie eindeutig, deshalb zaehlen wir sie an dieser Stelle mit und
         lassen den Klick danach normal weiterlaufen. */
      if (e.target.closest('[data-iso-toc]')) { mcTrack('cart_drawer_handbuch_toc'); }
      if (e.target.closest('[data-mc-scrolldown]')) {
        e.preventDefault();
        var sb = document.getElementById('mc-body');
        if (sb) sb.scrollBy({ top: Math.round(sb.clientHeight * 0.7), behavior: 'smooth' });
        return;
      }
      var removeBtn = e.target.closest('[data-mc-remove]');
      if (removeBtn) {
        e.preventDefault();
        removeLine(removeBtn.getAttribute('data-mc-remove'));
        return;
      }
      var incBtn = e.target.closest('[data-mc-inc]');
      if (incBtn) { e.preventDefault(); var _li = parseInt(incBtn.getAttribute('data-mc-inc'), 10); var _it = _cartData && _cartData.items && _cartData.items[_li - 1]; changeQty(_li, (_it ? _it.quantity : 1) + 1); return; }
      var decBtn = e.target.closest('[data-mc-dec]');
      if (decBtn) { e.preventDefault(); var _ld = parseInt(decBtn.getAttribute('data-mc-dec'), 10); var _id = _cartData && _cartData.items && _cartData.items[_ld - 1]; changeQty(_ld, (_id ? _id.quantity : 1) - 1); return; }
      if (e.target.closest('[data-mc-recalc]') || e.target.closest('[data-mc-reset]')) {
        e.preventDefault();
        handleReset();
        return;
      }
      /* v525: Weitere Wand — NICHTS löschen. Nur das Start-Signal für den Kalkulator
         setzen (der Loader liest __ISOWIZ_START_INTENT__ und öffnet direkt Schritt 1)
         und hinspringen. Die vorhandene Position bleibt im Warenkorb liegen. */
      if (e.target.closest('[data-mc-addwall]')) {
        e.preventDefault();
        /* v532 (Prüfung 17.09.): Lief bisher an mcTrack vorbei und trug deshalb
           als EINZIGES Schubladen-Ereignis keine Layout-Endung. Ausgerechnet
           dieser Knopf ist der wirtschaftliche Kern von v2 — er steht dort
           vorne und additiv. Ohne _lay_ wäre nicht messbar gewesen, ob die
           Umstellung wirkt. Basisname bleibt, die Zeitreihe bricht nicht ab. */
        mcTrack('cart_weitere_wand');
        try { if (w.isofinGA) w.isofinGA('cart_weitere_wand', {}); } catch (_eg) {}
        try {
          sessionStorage.setItem('__ISOWIZ_START_INTENT__', JSON.stringify({
            targetStep: 'step-1', stepId: 'step-1', quelle: 'warenkorb-weitere-wand', ts: Date.now()
          }));
        } catch (_es) {}
        try { window.location.href = '/pages/kalkulator'; } catch (_en) { window.location.reload(); }
        return;
      }
    });

    /* v308: Menge per Tastatur eintippbar (nicht nur +/-). 'change' feuert bei Blur/Enter →
       committet die getippte Menge. Leeres/ungueltiges Feld: zurueck auf aktuelle Menge (keine
       Aenderung). Waehrend des Tippens passiert nichts → Feld frei editierbar (1 loeschbar). */
    el.addEventListener('change', function (e) {
      var qi = e.target.closest('[data-mc-qtyinput]');
      if (!qi) return;
      var _lq = parseInt(qi.getAttribute('data-mc-qtyinput'), 10);
      var _cur = _cartData && _cartData.items && _cartData.items[_lq - 1];
      var _curQty = _cur ? _cur.quantity : 1;
      var _v = parseInt(qi.value, 10);
      if (isNaN(_v) || _v < 1) { qi.value = _curQty; return; }
      if (_v > 999) _v = 999;
      if (_v === _curQty) { qi.value = _curQty; return; }
      changeQty(_lq, _v);
    });
    el.addEventListener('focusin', function (e) {
      var qi = e.target.closest('[data-mc-qtyinput]');
      if (qi) { try { qi.select(); } catch (_) {} }
    });
    el.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      var qi = e.target.closest('[data-mc-qtyinput]');
      if (qi) { e.preventDefault(); qi.blur(); }
    });

    /* ESC to close */
    document.addEventListener('keydown', function (e) {
      if (_open && e.key === 'Escape') close();
    });

    /* v443: Panel-Mount-Ziel. NUR in #isodash haengen, wenn das die echte Vollbild-
       Dashboard-Shell ist (sichtbar + position:fixed) → dort erbt es CSS-Variablen + Theme.
       Auf Standalone-Seiten (z.B. /pages/feuchtigkeitsanalyse-tool) ist #isodash ein
       statischer, zeitweise hidden Container — dort in den body, sonst steckt der Drawer
       in einem display:none-Parent fest und laesst sich nicht oeffnen (bzw. taucht erst
       auf, wenn #isodash spaeter sichtbar wird). Alle Styles nutzen var(--x, fallback),
       daher ist der body-Mount stilistisch sicher (wie auf jeder normalen Shop-Seite). */
    var isoShell = document.getElementById('isodash');
    var host = document.body;
    if (isoShell && !isoShell.hasAttribute('hidden')) {
      try { if (w.getComputedStyle(isoShell).position === 'fixed') host = isoShell; } catch (_) {}
    }
    host.appendChild(el);
    return el;
  }

  function getRootUrl() {
    var root = '/';
    try {
      if (w.Shopify && w.Shopify.routes && w.Shopify.routes.root) root = w.Shopify.routes.root;
    } catch (_) {}
    if (!root) root = '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root;
  }

  function detachDynamicCheckoutNode(foot) {
    var node = foot && foot.querySelector && foot.querySelector('#mc-dynamic-checkout');
    if (node && node.parentNode) node.parentNode.removeChild(node);
    return node || null;
  }

  function normalizeDynamicCheckoutNode(node) {
    if (!node) return null;
    node.id = 'mc-dynamic-checkout';
    if (node.className.indexOf('mc-dynamic-checkout') === -1) {
      node.className += (node.className ? ' ' : '') + 'mc-dynamic-checkout';
    }
    try { node.removeAttribute('hidden'); } catch (_) {}
    try { node.style.display = ''; } catch (_) {}
    return node;
  }

  function hydrateDynamicCheckoutNode() {
    /* v275: Cart-Buttons kommen per Section Rendering API nachtraeglich in den
       Mini-Cart. Alte Shopify-Runtimes nutzen Shopify.PaymentButton.init(),
       neue Accelerated-Checkout-Custom-Elements hydrieren selbst, sobald sie im
       DOM sind. Der Init-Call ist bewusst optional und mehrfach harmless. */
    try {
      if (w.Shopify && w.Shopify.PaymentButton && typeof w.Shopify.PaymentButton.init === 'function') {
        w.Shopify.PaymentButton.init();
      }
    } catch (_) {}
  }

  function appendDynamicCheckoutNode(slot, node) {
    if (!slot || !node) return false;
    slot.hidden = false;
    slot.innerHTML = '';
    slot.appendChild(normalizeDynamicCheckoutNode(node));
    hydrateDynamicCheckoutNode();
    w.setTimeout(hydrateDynamicCheckoutNode, 250);
    w.setTimeout(hydrateDynamicCheckoutNode, 1000);
    return true;
  }

  /* v488 (Björn 16.07.): Zahlungsarten-Leiste unter "Zur Kasse gehen" — im
     MiniCart fehlte sie bisher komplett (nur der Dawn-Drawer und die
     Ergebnisseite hatten sie). Bewusst NUR die Icons, KEINE dynamischen
     Wallet-Buttons — die schaltet MC_EXPRESS (oben) ab.
     Quelle sind die bereits von Liquid gerenderten Logos aus
     snippets/cart-drawer.liquid (.iso-cart-paylogos) — die sind gegen
     shop.enabled_payment_types gefiltert. Klonen statt neu bauen, weil:
     (a) theme.liquid bleibt unangetastet (v272-CLS-Konflikt),
     (b) das ungefilterte Snippet iso-payment-icons.liquid würde Amex zeigen,
         obwohl im Shop nicht aktiv,
     (c) Aenderungen an der Whitelist wirken automatisch mit.
     Fehlt die Quelle (Drawer-Section nicht gerendert), passiert nichts. */
  /* v489 FIX 1 — 'document' statt 'd': Diese IIFE (ab Z. 20) bekommt NUR (w).
     Das 'd' der ZWEITEN IIFE (Z. 1588: '(function (w, d)') gilt hier nicht.
     v488 nutzte trotzdem d.querySelector -> ReferenceError, vom catch still
     verschluckt -> die Leiste waere NIE erschienen, auf keiner Seite. Alle
     anderen d.-Stellen dieser IIFE (Z. 149ff, 250f) sind lokale 'var d'.

     v489 FIX 2 — leerer Warenkorb beim Seitenaufbau: Die Quelle steht in
     snippets/cart-drawer.liquid hinter '{% if cart != empty %}' (dort Z. 722)
     und wird serverseitig nur EINMAL beim Seitenaufbau gerendert. Wer die Seite
     mit leerem Korb laedt und dann per AJAX hinzufuegt — der haeufigste
     Erst-Kauf-Fall — hat keine Quelle im DOM, und die Leiste fehlte ausgerechnet
     beim ersten Kauf. Dann holen wir die Section einmal nach (der Cart ist zu
     dem Zeitpunkt serverseitig nicht mehr leer) und merken uns die Logos. */
  var _payLogos = null;        /* Cache: einmal geholt, danach wiederverwendet */
  var _payLogosLaeuft = false; /* verhindert parallele Nachlade-Fetches */

  /* Icons ohne Label — exakt wie die Ergebnisseiten-Leiste (Bjoern:
     "nur die Icons, wie Ergebnisseite die Leiste"). Der Dawn-Drawer hat
     zusaetzlich "Sichere Bezahlung mit:", das bleibt hier bewusst weg. */
  function payLogosBauen(logos) {
    var wrap = document.createElement('div');
    wrap.className = 'mc-paylogos';
    wrap.setAttribute('role', 'img');
    wrap.setAttribute('aria-label', 'Akzeptierte Zahlungsarten');
    for (var i = 0; i < logos.length; i++) {
      var c = logos[i].cloneNode(true);
      c.setAttribute('class', 'mc-paylogo');
      c.removeAttribute('style');
      wrap.appendChild(c);
    }
    return wrap;
  }

  function payLogosSetzen(foot, logos) {
    if (!foot || !logos || !logos.length) return;
    if (foot.querySelector('.mc-paylogos')) return;
    var wrap = payLogosBauen(logos);
    var slot = foot.querySelector('#mc-dynamic-slot');
    if (slot && slot.parentNode) slot.parentNode.insertBefore(wrap, slot);
    else foot.appendChild(wrap);
  }

  function payLogosNachladen() {
    if (_payLogosLaeuft || _payLogos || isLocalDev() || !w.fetch) return;
    _payLogosLaeuft = true;
    w.fetch(getRootUrl() + '?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r && r.ok ? r.json() : null; })
      .then(function (sections) {
        if (!sections || !sections['cart-drawer']) return;
        var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        var src = doc.querySelector('.iso-cart-paylogos');
        var logos = src ? src.querySelectorAll('.iso-cart-paylogo') : null;
        if (!logos || !logos.length) return;
        _payLogos = [].slice.call(logos);
        payLogosSetzen(document.getElementById('mc-foot'), _payLogos);
      })
      .catch(function () {})
      .then(function () { _payLogosLaeuft = false; });
  }

  function mountPayLogos(foot) {
    try {
      if (!foot || foot.querySelector('.mc-paylogos')) return;
      var src = document.querySelector('.iso-cart-paylogos');
      var logos = src ? src.querySelectorAll('.iso-cart-paylogo') : null;
      if (logos && logos.length) { payLogosSetzen(foot, logos); return; }
      if (_payLogos) { payLogosSetzen(foot, _payLogos); return; }
      payLogosNachladen();
    } catch (ePL) {}
  }

  function mountDynamicCheckout(foot, preservedNode) {
    var slot = foot && foot.querySelector && foot.querySelector('#mc-dynamic-slot');
    if (!slot) return;

    /* v488: Schalter oben. Slot bleibt als Anker im DOM (mountPayLogos setzt die
       Logo-Zeile davor), nur leer + hidden — kein Fetch, keine Buttons. */
    if (!MC_EXPRESS) {
      slot.innerHTML = '';
      slot.hidden = true;
      return;
    }

    /* v273: Logr3-Tracking für Dynamic-/Express-Checkout-Klicks (Shop Pay / PayPal / Apple-/Google-Pay).
       Spiegelt die theme.liquid-v268-Delegation (checkout_drawer_click), aber HIER im JS, weil
       theme.liquid bewusst unangetastet bleibt (v272-cls-Konflikt). Provider liegen teils in
       Shadow-DOM/Iframes + sind nicht einzeln unterscheidbar → EIN Funnel-Event
       'checkout_dynamic_click'. Dedup (800ms) gegen Doppel-Feuern; Iframe-Provider (PayPal)
       per window-blur + activeElement=IFRAME als Best-Effort, da Klicks im Cross-Origin-Iframe
       nicht zur Slot-Ebene durchschlagen. */
    var fireDynamic = function () {
      var t = Date.now();
      if (t - (w.__isoDynamicLast || 0) < 800) return;
      w.__isoDynamicLast = t;
      if (typeof w.isoCheckoutIntent === 'function') w.isoCheckoutIntent('cart_drawer_express', 'checkout_dynamic_click');
      else if (typeof w.logr3Track === 'function') w.logr3Track('checkout_dynamic_click', { step: true });
      else if (typeof w.isoTrack === 'function') w.isoTrack('checkout_dynamic_click');
    };
    if (!slot.__isoDynamicTracked) {
      slot.__isoDynamicTracked = true;
      slot.addEventListener('click', fireDynamic, true);
    }
    if (!w.__isoDynamicBlurWired) {
      w.__isoDynamicBlurWired = true;
      w.addEventListener('blur', function () {
        var ae = document.activeElement;
        if (ae && ae.tagName === 'IFRAME') {
          var s = document.getElementById('mc-dynamic-slot');
          if (s && s.contains(ae)) fireDynamic();
        }
      }, true);
    }

    var node = preservedNode || document.getElementById('CartDrawer-DynamicCheckout');
    if (node) {
      appendDynamicCheckoutNode(slot, node);
      return;
    }

    if (isLocalDev() || !w.fetch) {
      slot.hidden = true;
      return;
    }

    fetch(getRootUrl() + '?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r && r.ok ? r.json() : null; })
      .then(function (sections) {
        if (!sections || !sections['cart-drawer']) throw new Error('no cart-drawer section');
        var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        var fresh = doc.getElementById('CartDrawer-DynamicCheckout');
        if (!fresh || !fresh.children.length) throw new Error('no dynamic checkout buttons');
        appendDynamicCheckoutNode(slot, fresh);
      })
      .catch(function () {
        slot.hidden = true;
      });
  }

  /* Scroll-Affordanz an/aus: zeigt Fade+Pfeil nur, wenn mehr Inhalt unten ist und
     man noch nicht am Ende angekommen ist. */
  function updateScrollCue() {
    if (!_panel) return;
    var b = document.getElementById('mc-body'); if (!b) return;
    var scrollable = b.scrollHeight > b.clientHeight + 6;
    var atBottom = (b.scrollHeight - b.scrollTop - b.clientHeight) <= 6;
    /* Pfeil nur zeigen, wenn wirklich viel zu scrollen ist: ab 3 Positionen ODER wenn
       Sanierungspaket + Einzelflaschen beide im Korb sind. Bei nur 1 Hauptprodukt passt
       alles (knapp) rein → der Pfeil würde nur die Sicht blockieren. */
    var its = (_cartData && _cartData.items) || [];
    var hasPaket = false, hasEinzel = false;
    for (var i = 0; i < its.length; i++) {
      var v = String(its[i].variant_id || '');
      if (v === ISOFIN_VARIANT) hasPaket = true;
      else if (v === '55868037857653') hasEinzel = true;
    }
    var enough = its.length >= 3 || (hasPaket && hasEinzel);
    _panel.classList.toggle('mc-can-scroll', scrollable && !atBottom && enough);
  }

  function renderCart(cart) {
    /* v313.2: Menü-Label (Sanierung berechnen ⇄ Berechnung ansehen) bei jeder Cart-Änderung mitziehen
       — auch auf Seiten ohne Sticky-Cart. Greift VOR dem Drawer-DOM-Check, damit es immer läuft. */
    try { if (window.IsofinCalcMenu) window.IsofinCalcMenu.refresh(cart); } catch (_eMx) {}
    var body = document.getElementById('mc-body');
    var foot = document.getElementById('mc-foot');
    var sub  = document.getElementById('mc-head-sub');
    if (!body || !foot) return;

    var isDev = !!(cart && cart._demo);
    var items = (cart && cart.items) || [];
    /* Flaschen-Zähler: NUR Sanierungspaket + Einzelflaschen (Handbuch/Messgerät sind keine Flaschen). */
    var totalQty = items.reduce(function (s, it) {
      var v = String(it.variant_id || '');
      return s + ((v === ISOFIN_VARIANT || v === '55868037857653') ? (it.quantity || 0) : 0);
    }, 0);

    var blurb = getWallBlurb();

    /* Header-Subline.
       v1: "3 Artikel · 24 Flaschen"
       v2 (Björn 11.09.): die Wanddaten selbst — "3 Meter Horizontalsperre ·
           4 Ecken · 36 cm Wandstärke". Sie sind Kontext, keine eigene
           Position; in der Kopfzeile stehen sie einmal statt zweimal, und
           der grüne Kasten im Rumpf kann entfallen. Genau der war Björn zu
           groß. Fällt der Blurb aus (keine Berechnung im Korb), zeigt auch
           v2 wieder die Artikelzählung — sonst stünde da nichts. */
    if (sub) {
      if (!items.length) {
        sub.textContent = 'Keine Artikel';
      } else {
        var artLbl = items.length === 1 ? '1 Artikel' : items.length + ' Artikel';
        var flLbl  = totalQty === 1 ? '1 Flasche' : totalQty + ' Flaschen';
        /* v528 · v2: die Kopfzeile fasst zusammen — bei einer Wand „1 Wand ·
           19 Flaschen", bei mehreren „3 Wände · 47 Flaschen gesamt". Die
           Einzelwerte stehen jetzt an der jeweiligen Position. */
        if (istV2()) {
          var _wZahl = 0;
          try { _wZahl = items.filter(function (it) { return String(it.variant_id) === ISOFIN_VARIANT; }).length; } catch (_eW) {}
          if (_wZahl > 0) {
            sub.textContent = (_wZahl === 1 ? '1 Wand' : _wZahl + ' Wände')
              + ' \u00b7 ' + totalQty + (_wZahl > 1 ? ' Flaschen gesamt' : (totalQty === 1 ? ' Flasche' : ' Flaschen'));
          } else {
            sub.textContent = artLbl + ' \u00b7 ' + flLbl;
          }
        } else {
          sub.textContent = artLbl + ' \u00b7 ' + flLbl;
        }
      }
    }

    /* Empty-State */
    if (!items.length) {
      /* v349: leerer Warenkorb = Weiche mit zwei Wegen (Feuchte-Check / Sanierung berechnen) */
      body.innerHTML =
        '<div class="mc-empty">' +
          '<div class="mc-empty-icon">' + ICO.cart + '</div>' +
          '<div class="mc-empty-title">Ihr Warenkorb ist leer</div>' +
          /* v409 (Björn): FA-Einstieg PAUSIERT bis Reaktivierung — Original
             in AENDERUNGEN/2026-07-06_50_v409-fa-einstiege-pausiert/_ZURUECK/ */
          '<p class="mc-empty-text">Der schnellste Weg zu Ihrer trockenen Wand:</p>' +
          '<a class="mc-empty-opt mc-empty-opt--primary" href="/pages/kalkulator" data-iso-track="calc_start_cart_empty" data-iso-source="cart_empty">' +
            '<span class="mc-empty-opt-t">Sanierung berechnen \u2192</span>' +
            '<span class="mc-empty-opt-s">Bohrplan, Materialmenge und Preis ermitteln \u2013 kostenlos</span>' +
          '</a>' +
          '<p class="mc-empty-note">Nach der Berechnung wird Ihr Sanierungspaket automatisch hier angezeigt.</p>' +
          (isDev ? '<div class="mc-dev-hint" style="margin-top:16px">Dev-Modus: keine Analyse geladen</div>' : '') +
        '</div>';
      foot.innerHTML = '';
      return;
    }

    /* Personalisierter Banner über dem Item (wenn Wand-Daten vorhanden) */
    /* v528: nach oben gezogen — in v2 füllt der Blurb die Kopfzeile,
       die weit vor dieser Stelle geschrieben wird. */
    /* v513 (Björn 03.09., #2981): Der Banner nahm die Berechnung der ERSTEN
       Zeile und unterdrückte sie in allen Zeilen — bei zwei Wänden standen
       19 und 24 Flaschen unter demselben Text. Ab zwei Isofin-Zeilen gibt es
       keinen Banner; jede Zeile trägt ihre eigene Berechnung. */
    var _isoZeilen = 0;
    try { _isoZeilen = ((_cartData && _cartData.items) || []).filter(function (it) { return String(it.variant_id) === ISOFIN_VARIANT; }).length; } catch (_) {}
    if (_isoZeilen > 1) blurb = null;
    /* v528 (Björn 11.09.): „bei dem Sanierungspaket mit rein, weil da ist der
       Bezug ja drauf." Richtig — die Angaben gehören an die Position, nicht nur
       in die Kopfzeile. Dort liest man sie als Dekoration, nicht als „das ist
       MEINE Wand". In v2 also NICHT unterdrücken; die Kopfzeile trägt dafür die
       Zusammenfassung über alle Wände. */
    _heroBlurbAktiv = istV2() ? false : !!blurb;
    /* v513 (Björn 03.09.): bei mehreren Wänden statt des Banners eine ruhige
       Summenzeile — nur Anzahl und Flaschen, keine neue Rechnung. */
    var _summeH = '';
    if (_isoZeilen > 1) {
      var _flaschenGesamt = 0;
      try { ((_cartData && _cartData.items) || []).forEach(function (it) { if (String(it.variant_id) === ISOFIN_VARIANT) _flaschenGesamt += (Number(it.quantity) || 0); }); } catch (_) {}
      _summeH = '<div class="mc-hero-banner mc-hero-banner--summe" role="note">' +
          '<div class="mc-hero-icon">' + ICO.verified + '</div>' +
          '<div class="mc-hero-text">' +
            '<div class="mc-hero-eyebrow">Ihre Berechnung</div>' +
            '<div class="mc-hero-detail">' + _isoZeilen + ' W\u00e4nde \u00b7 ' + _flaschenGesamt + ' Flaschen gesamt</div>' +
          '</div>' +
        '</div>';
    }
    /* v528 · v2: kein grüner Kasten mehr — die Angaben stehen in der Kopfzeile.
       Ohne Blurb (z. B. Einzelflaschen ohne Berechnung) bleibt die
       Mehrwand-Zusammenfassung _summeH auch in v2 sichtbar. */
    var bannerH = (istV2() && blurb)
      ? ''
      : blurb
      ? '<div class="mc-hero-banner" role="note">' +
          '<div class="mc-hero-icon">' + ICO.verified + '</div>' +
          '<div class="mc-hero-text">' +
            '<div class="mc-hero-eyebrow">Exakt berechnet f\u00fcr Ihre Wand</div>' +
            '<div class="mc-hero-detail">' + blurb + '</div>' +
          '</div>' +
        '</div>'
      : _summeH;

    /* Produkt-Stichpunkte (USPs) — eingebettet in jede Item-Card */
    /* "Exakt berechnet f\u00fcr Ihre Wand" steht bereits im Hero-Banner oben \u2192 hier raus. */
    var uspList = [
      'Einmalige Anwendung \u2013 kein Nachbehandeln',
      'Geeignet f\u00fcr Wohn- &amp; Schlafr\u00e4ume, Keller \u2013 innen oder au\u00dfen',
      /* v532 (Björn 17.09.): „einmal reicht, aber eher am Produkt." Der
         Injektionsaufsatz steht seit v532 direkt an der Mengenzeile der
         Position — dort, wo der Kunde die Flaschen sieht. Hier unten faellt
         er deshalb weg. Die Fuellmenge bleibt: sie ist eine eigene Aussage
         und steht in der alten Warenkorb-Fassung sonst nirgends. */
      'Flascheninhalt: 500\u202fml'
    ];
    var uspInner = '<ul class="mc-usp">' +
      uspList.map(function (t) {
        return '<li class="mc-usp-row"><span class="mc-usp-ico">' + ICO.check + '</span><span class="mc-usp-txt">' + t + '</span></li>';
      }).join('') +
    '</ul>';
    /* v277: USP-Liste EINMAL unter beide Items (statt pro Item) — schlankere Item-Cards. */
    var uspBoxH = '<div class="mc-usp-box"><div class="mc-usp-ttl">Gilt für Ihre Bestellung</div>' + uspInner + '</div>';

    /* Items (jedes Item enthält Ware + USPs in einer gemeinsamen Umrandung) */
    var itemsH = '';
    /* v525 (Björn 09.09.): „Wand 1" als Überschrift ergibt nur Sinn, wenn es
       mehrere Wände gibt. Bei einer einzigen Wand verwirrt die Nummer mehr,
       als sie ordnet — dann bleibt die Zeile weg. Deshalb hier VORHER zählen,
       wie viele verschiedene Wand-Nummern der Warenkorb überhaupt enthält. */
    var _wandAnzahl = (function () {
      var gesehen = {}, n = 0;
      try {
        for (var wi = 0; wi < items.length; wi++) {
          var wp = items[wi] && items[wi].properties;
          if (!wp || typeof wp !== 'object') continue;
          for (var wk in wp) {
            if (!Object.prototype.hasOwnProperty.call(wp, wk)) continue;
            if (String(wk).toLowerCase() !== 'wand') continue;
            var wv = String(wp[wk] || '');
            if (wv && !gesehen[wv]) { gesehen[wv] = 1; n++; }
          }
        }
      } catch (_ew) {}
      return n;
    })();
    /* v277: Sterne (Brand-Rating) an jedes Item. */
    var _stats = (w.ISO_STATS && typeof w.ISO_STATS === 'object') ? w.ISO_STATS : {};
    var _avg = _stats.avg || '4,77';
    var _tot = (_stats.total != null) ? _stats.total : 432;
    var _starsH = '<div class="mc-item-rating"><span class="mc-item-stars" aria-hidden="true">★★★★★</span><span class="mc-item-rtxt"><strong>' + _avg + '</strong> · ' + _tot + ' Bewertungen</span></div>';
    /* Anzeige-Reihenfolge — NUR die Anzeige, der Warenkorb selbst wird nicht umgebaut.
       data-mc-line bleibt am ECHTEN Cart-Index (items.indexOf) → Stepper/Entfernen korrekt.
       v611 (Adrian 15.10.): „erst immer Isofin anzeigen, dann Feuchtigkeitsmessgerät und dann
       unten drunter das Handbuch" — auch mit Rabattcode. Feste Rangfolge statt „Geschenk direkt
       unter das Paket": 0 Isofin (Paket, Einzelflaschen) · 1 Messgerät (gekauft, gratis) ·
       2 Handbuch (gekauft, Geschenk) · 3 alles übrige. Stabil: innerhalb eines Rangs bleibt die
       Warenkorb-Reihenfolge (mehrere Wände bleiben Wand 1, Wand 2 …). */
    var displayItems = items.slice();
    (function () {
      var rang = function (it) {
        var v = String((it && it.variant_id) || '');
        if (v === ISOFIN_VARIANT || v === '55868037857653') return 0;
        if (v === '55611265712501' || v === '57655948050805') return 1;
        if (v === '56015142388085' || v === '57299982582133') return 2;
        if (w.IsoGift && typeof w.IsoGift.isGiftItem === 'function' && w.IsoGift.isGiftItem(it)) return 2;
        return 3;
      };
      displayItems = displayItems
        .map(function (it, ix) { return { it: it, r: rang(it), ix: ix }; })
        .sort(function (a, b) { return (a.r - b.r) || (a.ix - b.ix); })
        .map(function (x) { return x.it; });
    })();
    displayItems.forEach(function (item) {
      var line     = items.indexOf(item) + 1;
      var thumb    = item.image || item.featured_image || '';
      var name     = item.product_title || item.title || 'Artikel';
      /* v528 · v2 (Entwurf C, 1:1): „Isofin® Sanierungspaket (DIY)". Der volle
         Shopify-Titel trägt noch „– individuell berechnet" und wird auf 440 px
         Panelbreite abgeschnitten — genau das stand im Entwurf nicht. Der Zusatz
         ist ohnehin doppelt: die Wandangaben stehen in der Kopfzeile. */
      if (istV2()) { name = name.replace(/\s*[–-]\s*individuell berechnet\s*$/i, ''); }
      var disc     = getItemDiscount(item);
      var qty      = disc.qty;
      var linePrc  = disc.finalPrc;
      /* v304: Geschenk-Zeile (Gratis-Handbuch) — schlank, kein Entfernen, 0,00 € + Wert durchgestrichen.
         Nur wenn wirklich kostenlos (linePrc === 0); sonst normale (bezahlte) Zeile als ehrlicher Fallback. */
      var _isGift = (w.IsoGift && typeof w.IsoGift.isGiftItem === 'function') ? w.IsoGift.isGiftItem(item) : false;
      if (_isGift && linePrc === 0) {
        var _giftWasC = (w.IsoGift && w.IsoGift.config && w.IsoGift.config.GIFT_VALUE_CENTS) || 2990;
        /* v496 (Björn 28.07.): data-iso-toc/role/tabindex hier ENTFERNT — die ganze
           Zeile war ein Knopf zum Inhaltsverzeichnis. Wer im Warenkorb die
           Handbuch-Zeile antippte (ansehen, pruefen, entfernen), bekam ein
           bildschirmfuellendes Overlay statt der Kasse. Klickbar ist jetzt
           nur noch der Link "Inhaltsverzeichnis ansehen ›" darunter. */
        itemsH += '<div class="mc-item mc-item--gift" data-mc-line="' + line + '">' +
          /* v496.2 (Björn 28.07.): Geschenk-Rahmung zurueck. Stand bis zum
             18.06. hier und wurde beim Drawer-Umbau entfernt — seitdem trug
             die Zeile den Wert nur noch als durchgestrichenen Preis. */
          /* v528 · v2 (Björn): „der grüne dunkle Balken mit Gratis-Geschenk ist zu
             prägnant." Im Entwurf C gibt es ihn nicht — dort sagt die Zeile selbst
             „gratis dabei", und die 0,00 € rechts sagen es ein zweites Mal. Der
             Balken war die dritte Wiederholung und zog mehr Blick als der
             Kaufknopf. v1 behält ihn. */
          (istV2() ? '' : '<div class="mc-gift-flag">\uD83C\uDF81 Gratis-Geschenk \u00b7 Wert ' + formatEuro(_giftWasC) + '</div>') +
          '<div class="mc-item-main">' +
            (thumb
              ? '<img src="' + thumb + '" alt="" class="mc-thumb" loading="lazy">'
              : '<div class="mc-thumb"></div>') +
            '<div class="mc-info">' +
              /* ═══════════════════════════════════════════════════════════
                 v528 (Björn 15.09.): „So kürzen, damit das in einer Zeile
                 steht, ohne Umbruch, notfalls Schrift minimal kleiner."

                 Kürzen allein reichte nicht: neben dem Preisblock blieben bei
                 360 px nur 113,6 px übrig — da passte gemessen KEINE Fassung,
                 auch „Handbuch · 108 S." nicht (114,4 px). Der Titel bekommt
                 deshalb in v2 die volle Breite der Infospalte (172 px bei
                 360 px), Knopf und Preis rücken in die Zeile darunter. Mit
                 13 px braucht „Isofin®-Handbuch · 108 S." 167,6 px und passt
                 damit auch auf dem schmalsten Telefon ohne Umbruch.

                 Nur die ANZEIGE: der Titel in Kasse, Bestellbestätigung und
                 Rechnung kommt aus Shopify und bleibt unberührt.
                 v1 behält den alten Aufbau unverändert.
                 ═══════════════════════════════════════════════════════════ */
              /* v612 (Adrian 15.10.): „Gratis-Handbuch-Zeile wie die Messgerät-Zeile" – Titel,
                 darunter Menge links und durchgestrichener Wert + „gratis" in EINER Zeile rechts
                 (wie Gratis-Messgerät, .mc-qtyprice), statt Wert über „gratis" gestapelt.
                 „Inhaltsverzeichnis ›" bleibt als dritte, kleine Zeile – gemessen nicht höher als
                 die Messgerät-Zeile (die Höhe gibt weiter das 56-px-Bild vor). Nur v2. */
              (istV2()
                ? '<h4 class="mc-name">Isofin®-Handbuch · 108 S.</h4>' +
                  '<div class="mc-qtyprice"><span class="mc-qty-text">' + qty + '&nbsp;St&uuml;ck</span>' +
                    '<div class="mc-price mc-price--gift"><s class="mc-gift-was">' + formatEuro(_giftWasC) + '</s><span class="mc-gift-free">gratis</span></div>' +
                  '</div>' +
                  '<button type="button" class="mc-gift-toc" data-iso-toc="1">Inhaltsverzeichnis ›</button>'
                : '<div class="mc-gift-top">' +
                    '<div class="mc-gift-left">' +
                      '<h4 class="mc-name">+ 1× Isofin®-Handbuch · 108 Seiten</h4>' +
                      '<button type="button" class="mc-gift-toc" data-iso-toc="1">Inhaltsverzeichnis ansehen ›</button>' +
                    '</div>' +
                    '<div class="mc-price mc-price--gift"><s class="mc-gift-was">' + formatEuro(_giftWasC) + '</s><span class="mc-gift-free">' + formatEuro(linePrc) + '</span></div>' +
                  '</div>') +
            '</div>' +
          '</div>' +
        '</div>';
        return;
      }
      var priceBlock = '<div class="mc-price">' + formatEuro(linePrc) + '</div>';
      var isMainProduct = String(item.variant_id || '') === ISOFIN_VARIANT;
      /* v283: Stepper (+/-) fuer Stueck-Produkte (Messgeraet/Handbuch/Einzelflaschen); Sanierungspaket bleibt statisch */
      var _vid = String(item.variant_id || '');
      var _isEinzel = (_vid === '55868037857653');
      /* v304: Messgeraet = feste Menge (1x, KEIN Stepper) — Zubehoer, Menge nicht verstellbar; nur entfernbar (x). */
      var _isFixedOne = (_vid === '55611265712501' || _vid === '57655948050805');
      /* v610: Gratis-Messgeraet (Zugabe aus Hendriks Link, eigener 0-EUR-Artikel) – wie das
         Gratis-Handbuch mit durchgestrichenem Wert und "gratis", Menge fest 1 Stueck. */
      /* v611 (Adrian 15.10.): „gratis“ nur, wenn die Zeile wirklich 0,00 € kostet (wie beim
         Gratis-Handbuch, v304) — sonst der echte Preis als ehrlicher Rückfall. */
      if (_vid === '57655948050805' && linePrc === 0) priceBlock = '<div class="mc-price mc-price--gift"><s class="mc-gift-was">' + formatEuro(MG_WERT_CENT * qty) + '</s><span class="mc-gift-free">gratis</span></div>';
      var _isStepper = !_isFixedOne && (_vid === '56015142388085' || _isEinzel);
      /* v611 (Adrian 15.10.): Zubehör-Zeile (Messgerät, Gratis-Messgerät, gekauftes Handbuch) —
         kompakt, siehe unten bei _isZub. */
      var _isZub = _isFixedOne || _vid === '56015142388085';
      /* v612 (Adrian 15.10.): „Lasst uns die lebenslange Wirksamkeitsgarantie bei Isofin jeweils
         mit reinnehmen. Also beim Sanierungspaket und bei den Einzelflaschen – das unten rausnehmen."
         Eigene kleine Zeile über die volle Kartenbreite unter Bild/Beschreibung: in der Spalte
         neben dem Bild brach sie gemessen um (Text 230 px, Spalte 211 px bei 360 / 241 px bei 390).
         Siegel 20 px, per align-items:center senkrecht mittig zur Textzeile (Wunsch A: das Siegel
         saß unter dem Kaufknopf 4,5 px tiefer als die Textmitte). Schrift 13 px. v1 und v2. */
      var _garantieH = (isMainProduct || _isEinzel)
        ? '<div class="mc-garantie"><img class="mc-garantie-bild" src="' + GARANTIE_BILD + '" alt="" loading="lazy" width="20" height="20">' +
            '<span class="mc-garantie-txt">Lebenslange Wirksamkeits-Garantie</span></div>'
        : '';
      var _qtyHtml, _calcHint = '', _qtyZusH = '';
      if (_isFixedOne) {
        _qtyHtml = '<span class="mc-qty-text">' + qty + '&nbsp;St&uuml;ck</span>';
      } else if (_isStepper) {
        _qtyHtml = '<div class="mc-stepper"><button type="button" class="mc-step" data-mc-dec="' + line + '" aria-label="Menge verringern">&minus;</button><input type="text" inputmode="numeric" class="mc-step-val" data-mc-qtyinput="' + line + '" value="' + qty + '" aria-label="Menge"><button type="button" class="mc-step" data-mc-inc="' + line + '" aria-label="Menge erhoehen">+</button></div>';
        if (_isEinzel) { _calcHint = '<div class="mc-calc-hint">Zur Berechnung der richtigen Flaschenanzahl empfehlen wir die Nutzung unseres <a href="/pages/kalkulator">Isofin-Kalkulators</a>.</div>'; }
      } else {
        /* v528 · v2 (Entwurf C): „17 × Flaschen à 500 ml" — der Inhalt gehoert
           dazu, sonst weiss der Leser nicht, wovon 17 Stueck kommen. */
        /* v528 (Björn): „da könnte man auch nochmal schreiben: inklusive
           Injektionsaufsatz — dass die halt wissen, da ist alles bei." */
        /* 25.09. (Björn, Reihenfolge): „à“ fest an „500 ml“ gebunden — in der
           schmaleren Spalte bricht die Zeile sonst als „15× Flaschen à / 500 ml“.
           Sichtbar gleich. */
        _qtyHtml = '<span class="mc-qty-text">' + qty + '&times;&nbsp;Flaschen' + (istV2() ? ' \u00e0\u00a0500\u00a0ml' : '')
          /* v532 (Björn 17.09.): „im warenkorb muss auch stehen inkl.
           Injektionsaufsatz". Stand bisher nur in v2 — und weil die
           Voreinstellung v1 ist und der Test nicht scharf laeuft, hat ihn
           faktisch KEIN Kunde gesehen. Jetzt in beiden Fassungen.
           „a 500 ml" bleibt bewusst v2-exklusiv, das war nicht Teil des
           Auftrags. */
        + (istV2() && isMainProduct ? '' : '<span class="mc-qty-zus">inkl. Injektionsaufsatz und Anleitung</span>') + '</span>'; /* v535 (Björn 17.09.): „und Anleitung“ — die gedruckte Schnellanleitung liegt jedem Paket bei */
        /* 25.09. (Björn, Reihenfolge): v2-Sanierungspaket — der Zusatz steht als
           eigene Zeile UNTER Menge und Preis und darf die volle Spaltenbreite
           nutzen; neben dem Preis brach er schon bei 390 px um („… und /
           Anleitung“). Gleicher Text, gleiche Klasse. „und Anleitung“ ist
           gebunden: bricht die Zeile doch (360 px), dann vor „und“. */
        if (istV2() && isMainProduct) _qtyZusH = '<span class="mc-qty-zus">inkl. Injektionsaufsatz und\u00a0Anleitung</span>';
      }
      var removeBtn = '<button class="mc-item-x" data-mc-remove="' + line + '" type="button" aria-label="Produkt aus Warenkorb entfernen" title="Produkt entfernen"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="6" y1="12" x2="18" y2="12"/></svg></button>';
      /* ═══════════════════════════════════════════════════════════════
         v528 · v2 — Die zwei Nebenaktionen sind NICHT gleichwertig

         Björn (11.09.): „vielleicht statt Text zwei Buttons nebeneinander,
         weil das ja den Warenwert hoch treibt. Erst weitere Wand, dann neu
         berechnen."

         Stimmt, und es widerlegt meinen ersten Entwurf. Wirtschaftlich sind
         die beiden Gegenteile:
           · „Weitere Wand" ist ADDITIV — der Warenkorb bleibt, es kommt
             etwas dazu. Mehrwand-Bestellungen sind die größeren.
           · „Neu berechnen" ist DESTRUKTIV — die vorhandene Berechnung wird
             weggeworfen.
         Dass beide bisher identisch aussahen, war der eigentliche Fehler:
         der zerstörende Weg bekam dasselbe Gewicht wie der aufbauende.

         In v2 daher: „Weitere Wand" zuerst und als sichtbarer Knopf mit
         Pluszeichen, „Neu berechnen" daneben und deutlich leiser.
         v1 bleibt unverändert — dort stehen weiter zwei gleiche Balken.
         ═══════════════════════════════════════════════════════════════ */
      var _btnNeu = '<button class="mc-item-recalc" data-mc-recalc type="button">' + ICO.refresh
        + '<span>' + (istV2() ? 'Neu berechnen' : 'Sanierungspaket neu berechnen') + '</span></button>';
      var _btnWand = '<button class="mc-item-recalc mc-item-addwall" data-mc-addwall type="button">'
        + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>'
        + '<span>' + (istV2() ? 'Weitere Wand' : 'Weitere Wand berechnen') + '</span></button>';

      var recalcBtn = !isMainProduct ? ''
        /* v2: der aufbauende Weg zuerst, der wegwerfende danach. */
        : (istV2() ? (_btnWand + _btnNeu) : (_btnNeu + _btnWand));

      /* v528 · nur v2: Die beiden Knoepfe sind Rasterzellen von .mc-item und
         landen deshalb untereinander. Ein eigener Container ueber die ganze
         Breite stellt sie nebeneinander — Bjoern: „vielleicht die beiden
         Buttons eher nebeneinander, damit die nicht so breit laufen."
         v1 bekommt den Container NICHT, dort bleibt das Markup unveraendert. */
      if (istV2() && recalcBtn) {
        recalcBtn = '<div class="mc-nebenaktionen">' + recalcBtn + '</div>';
      }

      /* v236.2: Properties anzeigen (z.B. "Berechnung: 8 Meter Horizontalsperre \u00b7 2 Ecken \u00b7 36 cm Wandst\u00e4rke")
         Iteriert \u00fcber item.properties (Shopify cart.js Format). Underscore-Prefix-Keys werden ignoriert. */
      var propsH = '';
      /* 25.09. (Björn, Reihenfolge): v2-Sanierungspaket — der Kasten mit den
         Wanddaten rückt unter Menge/Preis. „Wand N" bleibt IM Kasten direkt
         über „Berechnet" (sonst stünde „Wand N" vor der Bewertung, und
         „Berechnet" hätte keinen Bezug mehr). */
      var _v2Paket = istV2() && isMainProduct;
      try {
        var props = item.properties;
        var pairs = [];
        if (props && typeof props === 'object') {
          if (Array.isArray(props)) {
            for (var pi = 0; pi < props.length; pi++) {
              var pair = props[pi];
              if (Array.isArray(pair) && pair.length === 2) pairs.push([pair[0], pair[1]]);
            }
          } else {
            for (var pk in props) {
              if (Object.prototype.hasOwnProperty.call(props, pk)) pairs.push([pk, props[pk]]);
            }
          }
        }
        /* v496.6 (Björn 28.07.): 'Berechnung' hier auslassen, wenn der gruene
           Banner oben dieselbe Angabe schon traegt — sonst steht sie doppelt. */
        if (_heroBlurbAktiv) {
          pairs = pairs.filter(function (pp) {
            return String(pp[0] || '').toLowerCase().indexOf('berechnung') === -1;
          });
        }
        if (props && typeof props === 'object') {
        }
        var rowsH = '';
        for (var ri = 0; ri < pairs.length; ri++) {
          var pKey = String(pairs[ri][0] || '');
          var pVal = pairs[ri][1];
          if (!pKey || pKey.charAt(0) === '_') continue;
          if (pVal == null || pVal === '') continue;
          /* v513: „Wand: 1" liest sich in der Schublade als „Wand 1", fett — als
             Überschrift der Position. In Kasse/Mail/Rechnung bleibt „Wand: 1". */
          if (pKey.toLowerCase() === 'wand') {
            /* v525: nur zeigen, wenn wirklich mehrere Wände im Warenkorb liegen. */
            if (_wandAnzahl > 1) {
              rowsH = '<div class="mc-prop-row mc-prop-row--wand"><span class="mc-prop-key">Wand ' + esc(String(pVal)) + '</span></div>' + rowsH;
            }
            continue;
          }
          /* v528 · v2: „Berechnung:" sagt nicht, wessen Berechnung. „Berechnet
             für Ihre Wand:" stellt den Bezug her — das war Björns eigentlicher
             Punkt. Nur das Anzeigewort ändert sich; in Kasse, Bestellung und
             Rechnung bleibt der Schlüssel „Berechnung". */
          /* Bei mehreren Wänden steht die Überschrift „Wand 1" schon darüber —
             dann wäre „für Ihre Wand" die zweite Ansage in derselben Zeile. */
          var pKeyAnzeige = pKey;
          if (istV2() && pKey.toLowerCase().indexOf('berechnung') !== -1) {
            pKeyAnzeige = (_wandAnzahl > 1) ? 'Berechnet' : 'Berechnet für Ihre Wand';
          }
          /* ═══════════════════════════════════════════════════════════════
             v528 (Björn 15.09.): „Berechnet für Ihre Wand — Absatz — 4 m
             Horizontalsperre — Absatz — 2 Ecken · 36 cm Wandstärke, und das
             Ganze sanft blau hinterlegt. Nutzt genauso viel Platz, ist aber
             übersichtlicher. An der Stelle ist wichtig, dass sie verstehen:
             das ist wirklich genau für IHRE Wand."

             Umgesetzt als drei Ebenen statt einer Fließzeile: Label klein und
             blau, die tragende Zahl groß, die Nebenmaße darunter leise.
             „Meter" wird zu „m" — der Kunde liest hier Maße, keine Prosa.
             Getrennt wird am ersten Mittelpunkt des gespeicherten Werts; hat
             der Wert keinen, steht er einfach allein in der großen Zeile.
             NUR die Anzeige: in Kasse, Bestellung und Rechnung bleibt der Wert
             unverändert, wie er in der Warenkorb-Eigenschaft steht. */
          if (istV2()) {
            var _teile = String(pVal).split(/\s*[\u00b7\u2022]\s*/);
            var _kurz = function (t) { return String(t).replace(/(\d+(?:[.,]\d+)?)\s*Meter\b/gi, '$1\u00a0m'); };
            var _haupt = _kurz(_teile.shift() || '');
            var _neben = _teile.length ? _kurz(_teile.join(' \u00b7 ')) : '';
            rowsH += '<div class="mc-prop-row mc-prop-row--daten">' +
                       /* 25.09. (Nutzer): Verifiziert-Häkchen vor „Berechnet für Ihre Wand" –
                          Kreis + Haken direkt gezeichnet (keine url(#)-Verweise). */
                       '<span class="mc-prop-key"><svg class="mc-verif" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><circle cx="8" cy="8" r="8" fill="#1565C0"/><path d="M4.6 8.3l2.3 2.3 4.6-4.9" fill="none" stroke="#fff" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/></svg>' + esc(pKeyAnzeige) + '</span>' +
                       '<span class="mc-prop-haupt">' + esc(_haupt) + '</span>' +
                       (_neben ? '<span class="mc-prop-neben">' + esc(_neben) + '</span>' : '') +
                     '</div>';
          } else {
            rowsH += '<div class="mc-prop-row">' +
                       '<span class="mc-prop-key">' + esc(pKeyAnzeige) + ':</span> ' +
                       '<span class="mc-prop-val">' + esc(String(pVal)) + '</span>' +
                     '</div>';
          }
        }
        if (rowsH) {
          /* v309.7: Wanddaten direkt anzeigen — Akkordeon raus (Toggle war so groß wie der Inhalt selbst) */
          propsH = '<div class="mc-props">' + rowsH + '</div>';
        }
      } catch (_e) {}

      var _thumbH = (thumb
        ? '<img src="' + thumb + '" alt="" class="mc-thumb" loading="lazy">'
        : '<div class="mc-thumb"></div>');
      /* ═══════════════════════════════════════════════════════════════
         v528 (Björn 15.09.): „Das hier mit Bild in eine Zeile, quasi
         nebeneinander, zwei Spalten: Name, Sterne, Bewertungen, Wanddaten.
         Dann darunter links 19× Flaschen à 500 ml / inkl. Injektionsaufsatz
         und rechts der Preis."

         Der Zwischenschritt — Menge in der schmalen Bildspalte — war die
         falsche Lösung: die Spalte musste auf 112 px wachsen, damit
         „Injektionsaufsatz" nicht bricht, und nahm der rechten Spalte 21 px
         weg; die Wanddaten wurden vierzeilig.

         Jetzt trägt die obere Zeile nur noch Bild und Beschreibung, und
         Menge/Preis stehen als eigene Zeile über die volle Kartenbreite
         darunter. Beides bekommt damit mehr Platz statt weniger. Nur v2 —
         in v1 bleibt die Preiszeile in der rechten Spalte. */
      var _qpH = '<div class="mc-qtyprice">' + _qtyHtml + priceBlock + _qtyZusH + '</div>';
      /* ═══════════════════════════════════════════════════════════════
         v611 (Adrian 15.10.): „Die Anordnung rechts in der Schublade … nimmt viel
         zu viel Platz ein. Der Preis darf nicht unten drunter stehen, mit dem einen
         Stück muss auch daneben sein. Feuchtigkeitsmessgerät sollte nicht oben
         drüber stehen, alles rechtsbündig neben das Bild. Das ist der Trick, dass
         das nicht so viel Höhe bekommt und nicht so viel Priorität."
         Zubehör bekommt eine eigene, kompakte Zeile nach dem Muster der
         Geschenk-Zeile: Bild 56 px links, rechts daneben Name und darunter Menge
         links / Preis rechts. Keine Sterne (Platz). Gemessen vorher 168–197 px,
         Ziel höchstens ~100 px. In BEIDEN Fassungen gleich (v1 trug schon fast
         diesen Aufbau, nur mit Sternen und 72-px-Bild).
         Nur die ANZEIGE: „– Gratis" fällt beim Namen weg (das grüne „gratis" am
         Preis sagt es), das gekaufte Handbuch heißt wie die Geschenk-Zeile
         „Isofin®-Handbuch · 108 S." — sonst bräche der lange Shopify-Titel neben
         dem Plus/Minus-Feld zweizeilig um. Kasse, Bestellung, Rechnung: unberührt.
         Paket und Einzelflaschen bleiben unverändert. CSS: .mc-item--zub.
         ═══════════════════════════════════════════════════════════════ */
      if (_isZub) {
        var _zubName = (_vid === '56015142388085')
          ? 'Isofin®-Handbuch · 108 S.'
          : name.replace(/\s*[–-]\s*Gratis\s*$/i, '');
        itemsH += '<div class="mc-item mc-item--zub" data-mc-line="' + line + '">' +
          removeBtn +
          '<div class="mc-item-main">' +
            _thumbH +
            '<div class="mc-info">' +
              '<h4 class="mc-name">' + _zubName + '</h4>' +
              _qpH + propsH +
            '</div>' +
          '</div>' +
        '</div>';
        return;
      }
      itemsH += '<div class="mc-item" data-mc-line="' + line + '">' +
        removeBtn +
        /* ═══════════════════════════════════════════════════════════════
           v528 (Björn 15.09.): „Bei Isofin Sanierungspaket (DIY) können wir
           zusehen, dass das in eine Zeile passt."

           In der rechten Spalte geht das nicht — gemessen: der Name braucht
           bei 14 px 210 px, verfügbar sind 125 px (360-px-Gerät) bzw. 155 px
           (390 px). Auch kleiner gesetzt reicht es nicht, und selbst der auf
           „Sanierungspaket (DIY)" gekürzte Name scheitert bei 360 px.
           Der Grund ist strukturell: das Bild nimmt die halbe Kartenbreite,
           und der Entfernen-Knopf braucht rechts 34 px Freiraum.

           Deshalb steht der Name in v2 über der Bildzeile, über die volle
           Kartenbreite. Dort stehen 208 px (360 px) bis 272 px zur Verfügung —
           eine Zeile, vollständiger Shopify-Name, kein Abschneiden.
           v1 bleibt unverändert. */
        /* 25.09. (Nutzer): beim v2-Sanierungspaket steht der Name wieder in der Spalte
           neben dem Bild („Headline rüberziehen, Bild nach oben rücken"). Er darf dort
           zweizeilig umbrechen – kein Abschneiden. Alle anderen v2-Karten wie bisher. */
        ((istV2() && !_v2Paket) ? '<h4 class="mc-name mc-name--voll">' + name + '</h4>' : '') +
        '<div class="mc-item-main">' +
          _thumbH +
          '<div class="mc-info">' +
            (istV2() ? (_v2Paket ? '<h4 class="mc-name mc-name--spalte">' + name + '</h4>' : '') : '<h4 class="mc-name">' + name + '</h4>') +
            /* ═══════════════════════════════════════════════════════════
               25.09. (Björn): „Erst Bewertung. Flaschenanzahl 500 ml inkl.
               Injektionsaufsatz und Anleitung, Preis daneben, und unten
               drunter in der gleichen Spalte ‚Berechnet für Ihre Wand' —
               als Details zum Produkt. Dann die beiden Knöpfe."
               Nur v2-Sanierungspaket: Menge/Preis kommen aus der vollen
               Kartenbreite in die Spalte neben dem Bild, direkt unter die
               Sterne; der Wanddaten-Kasten folgt darunter, gleiche linke
               Kante. Stepper-Artikel bleiben unten (passen nicht in die
               schmale Spalte), v1 bleibt unverändert. */
            _starsH +
            (_v2Paket ? _qpH + propsH : propsH) +
            (istV2() ? '' : _qpH + _calcHint) +
          '</div>' +
        '</div>' +
        /* v612 (Adrian 15.10.): Garantie-Zeile direkt unter Bild/Beschreibung (siehe _garantieH). */
        _garantieH +
        /* v528 (Björn 15.09.): „Das soll da oben wieder drin bleiben und klein
           bleiben. Das solltest du im Warenkorb gar nicht erst ändern."
           Zurückgenommen: die Wanddaten stehen wieder in der rechten Spalte
           direkt unter den Sternen, wie vorher. Geblieben ist nur das, was er
           behalten wollte — die drei Ebenen und das leichte Blau, jetzt in
           kleinerem Schriftgrad, damit die schmale Spalte reicht. */
        ((istV2() && !_v2Paket) ? _qpH + _calcHint : '') +
        recalcBtn +
      '</div>';
    });

    /* v528 · v2 („Der Rückenwind"): Fortschrittsleiste oben. Sie beantwortet die
       Frage, die „Zur Kasse" offen lässt — wie viel kommt da noch? Zwei Schritte,
       dann fertig. Der USP-Kasten entfällt in v2: er erklärt ein Produkt, das
       längst im Warenkorb liegt, und steht zwischen Preis und Kasse. */
    /* v528 (Björn 14.09.): „Berechnet grün, Warenkorb heißt ja auch: die Ware
       liegt schon drin — das will ich auch grün. Und wenn man was rot laufen
       lässt, ist das immer Warnung."
       Genau. Rot heißt auf dieser Seite „Achtung" oder „Kaufen" — als Marke für
       den nächsten Schritt liest es sich falsch. Erledigtes ist grün, der
       nächste Schritt blau (dasselbe Blau wie der E-Mail-Knopf auf der
       Ergebnisseite: informierend, nicht warnend), das Spätere bleibt grau. */
    var railH = (istV2() && items.length)
      ? '<div class="mc-rail" role="img" aria-label="Schritt 2 von 4: Warenkorb, als Nächstes Adresse">' +
          '<div class="is-fertig"><span></span><b class="mc-rail-lab"><i class="mc-rail-ok" aria-hidden="true">\u2713</i>Berechnet</b></div>' +
          '<div class="is-fertig is-uebergabe"><span></span><b class="mc-rail-lab"><i class="mc-rail-ok" aria-hidden="true">\u2713</i>Warenkorb</b></div>' +
          '<div class="is-naechst"><span></span><b class="mc-rail-lab"><i class="mc-rail-nun" aria-hidden="true">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"></path></svg>' +
          '</i>Adresse</b></div>' +
          '<div><span></span><b class="mc-rail-lab">Fertig</b></div>' +
        '</div>'
      : '';

    body.innerHTML = railH + bannerH + itemsH + (items.length && !istV2() ? uspBoxH : '') +
      (items.length
        ? '<div class="mc-fade" aria-hidden="true"><button class="mc-scrolldown" type="button" data-mc-scrolldown aria-label="Nach unten scrollen" title="Mehr anzeigen">' +
          '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>' +
          '</button></div>'
        : '');

    /* Footer \u2014 mit Mengenrabatt-Aufschl\u00fcsselung */
    var totals = getCartTotals(cart);
    /* v490 (Björn 22.07., WhatsApp-Kundenfund 50 Fl. + neuewand5): Shopify rechnet
       aktivierte Rabattcodes INZWISCHEN selbst in den Warenkorb ein —
       cart.total_price enthält den Code bereits, cart.discount_codes[].applicable
       sagt es explizit (live verifiziert: total_price 897,75 = 945 − 47,25).
       Die v309/v341-Eigenrechnung stammt aus der Zeit, als Codes erst im Checkout
       griffen — sie zog den Code deshalb DOPPELT ab: Drawer zeigte 852,86 €,
       der Checkout verlangte 897,75 € → der Preis STIEG genau an der Schwelle
       Warenkorb→Kasse. Fies: erst ab dem 2. Render, weil die Cookie-Erkennung
       weiter unten NACH dieser Rechnung läuft — beim ersten Öffnen stimmte er.
       FIX: Trägt der Warenkorb einen anwendbaren Code, steckt Shopifys Abzug
       schon in totals.final UND totals.saved (original_total_price − total_price)
       → Eigenrechnung aus (_cpSaved = 0), die Anzeige übernimmt Shopifys Zahlen.
       Die Eigenrechnung bleibt NUR als Fallback für Cookie-Codes, die (noch)
       nicht am Warenkorb hängen — dort sichert wie bisher der Checkout-Link
       /discount/CODE die Anwendung. */
    var _cartCode = null;      /* anwendbarer Code am Warenkorb (Name) */
    var _cartInaktiv = false;  /* Codes am Warenkorb, aber KEINER anwendbar */
    var _cartAbzugOhneName = false; /* Code-Abzug steckt in den Summen, Name unbekannt */
    try {
      var _dcs = (cart && cart.discount_codes) || [];
      for (var _di = 0; _di < _dcs.length; _di++) {
        if (_dcs[_di] && _dcs[_di].applicable && _dcs[_di].code) { _cartCode = String(_dcs[_di].code); break; }
      }
      if (!_cartCode && _dcs.length) _cartInaktiv = true;
      if (!_cartCode && cart && cart.cart_level_discount_applications) {
        /* Fallback für Cart-JSONs ohne discount_codes-Feld */
        var _apps = cart.cart_level_discount_applications;
        for (var _ai = 0; _ai < _apps.length; _ai++) {
          if (_apps[_ai] && _apps[_ai].type === 'discount_code' && _apps[_ai].total_allocated_amount > 0) {
            /* Abzug steckt in den Summen — auch bei leerem title NIE selbst rechnen */
            if (_apps[_ai].title) { _cartCode = String(_apps[_ai].title); break; }
            _cartAbzugOhneName = true;
          }
        }
      }
    } catch (_eDc) {}
    /* Chip + Label zeigen den Code, der WIRKLICH in den Zahlen steckt — auch ohne Cookie.
       v490-Audit-Härtung: Meldet der Warenkorb seine Codes als NICHT anwendbar
       (abgelaufen/Limit/Mindestwert — der Checkout gewährt sie dann auch nicht),
       Geister-_coupon aus Cookie/Vor-Render löschen: kein Abzug, kein Chip,
       Checkout-Link neutral. Shopifys applicable-Urteil ist die Wahrheit. */
    /* v501-Fix (Björn 11.08.: »bleibt der Text aber trotzdem stehen«):
       Vorher stand hier nur "else if (_cartInaktiv) _coupon = null". Wenn der
       Warenkorb GAR KEINEN Code mehr hat, ist _cartCode leer UND _cartInaktiv
       false — es griff also KEINER der beiden Zweige, und _coupon behielt den
       Wert aus dem vorigen Rendern. Der Chip blieb stehen, obwohl der Code weg
       war. Jetzt ist der Warenkorb die alleinige Wahrheit: kein anwendbarer
       Code im Warenkorb -> kein Chip. Die Cookie-Rückfallebene weiter unten
       darf ihn danach wieder setzen, solange der Cookie existiert (kurzes
       Fenster, bevor Shopify den Code im Warenkorb meldet). */
    if (_cartCode) _coupon = { code: _cartCode };
    else _coupon = null;
    var _cpSaved = (_coupon && !_cartCode && !_cartAbzugOhneName)
      ? Math.max(0, mcCouponSaved(_coupon.code, totals.final)) : 0;
    var _combinedSaved = totals.saved + _cpSaved;
    var _finalC = Math.max(0, totals.final - _cpSaved);
    var _showDiscount = totals.hasDiscount || _cpSaved > 0;
    var _codeImLabel = !!(_coupon && (_cartCode || _cpSaved > 0));
    /* v615 (Adrian 16.10.), Nachbesserung nach Prüfung: Anteil des Codes am Abzug schon HIER lesen
       (vorher erst unten bei der Rabattzeile) – nur aus Shopifys Zuteilungen, Anzeigewort, kein
       Rechenweg. Hat der Code KEINEN eigenen Betrag (Versandcode, 0-€-Code), gehört er nicht in die
       Rabatt-Bezeichnung und das X nicht in diese Zeile: sonst stünde „Gesamtrabatt inkl. „Code““
       über dem reinen Mengenrabatt und das X entfernte scheinbar Rabatt, ohne dass sich die Summe
       ändert. Dann „Mengenrabatt"/Aktionsname ohne X und darunter die eigene Zeile _codeZeileH. */
    var _codeCent = _cpSaved;
    if (_codeImLabel && _cartCode) {
      try {
        ((cart && cart.cart_level_discount_applications) || []).forEach(function (ap) {
          if (ap && ap.type === 'discount_code') _codeCent += Number(ap.total_allocated_amount) || 0;
        });
        ((cart && cart.items) || []).forEach(function (it) {
          ((it && it.line_level_discount_allocations) || []).forEach(function (al) {
            var ap = al && al.discount_application;
            if (ap && ap.type === 'discount_code') _codeCent += Number(al.amount) || 0;
          });
        });
      } catch (_eCc) {}
    }
    if (_codeImLabel && !(_codeCent > 0)) _codeImLabel = false;
    var _discLbl =_codeImLabel ? 'Gesamtrabatt' : (totals.hasDiscount ? 'Mengenrabatt' : 'Gesamtrabatt');
    /* Aktion Paket 2: mit zugeteiltem Aktionsrabatt „Normalpreis“ / Aktionsname und darunter
       die Pflichtangabe (15 px). Ohne Zuteilung in der Vorschau ein roter Hinweis. */
    var _akT = _akAktiv();
    if (totals.aktion && _akT && !_codeImLabel) _discLbl = esc(_akT.bezeichnung || 'Aktion');
    var _akRefH = (totals.aktion && _akT && _akT.pflichtangabe) ? '<div class="mc-ak-ref iso-ak-an">' + esc(_akT.pflichtangabe) + '.</div>' : '';
    var _akWarnH = '';
    if (_akT && !totals.aktion && _akT.vorschau) {
      var _akHatIso = false;
      try { (cart.items || []).forEach(function (it) { if (_akIsofinZeile(it) && (it.quantity || 0) > 0) _akHatIso = true; }); } catch (_eW) {}
      if (_akHatIso) _akWarnH = '<div class="mc-ak-warn iso-ak-an">Vorschau: Im Warenkorb steckt kein Rabatt \u201e' + esc(_akT.rabattTitel || '') + '\u201c \u2013 die Kasse rechnet ohne Aktionspreis.</div>';
    }
    /* v615 (Adrian 16.10.): „Bei dem Hendrik-Rabatt nicht doppelt schreiben […] da muss daneben
       dieser Schließen-Button […] bei allen Rabatten dann das Schließen-Zeichen, und der blaue muss
       dann weg." Das Entfernen-X sitzt jetzt GANZ RECHTS in der grünen Rabattzeile (hinter dem
       Betrag), in der Aktion rechts in der Ersparniszeile des Kastens. Aussehen (.mc-coupon-off,
       26 px sichtbar, 44 px Tippfläche), Attribute (data-mc-coupon-off, data-iso-track=
       "cart_coupon_remove", aria-label) und Weg (Klick-Delegation -> removeCoupon()) wie das
       bisherige X im blauen Chip. _codeXImRabatt: der Code steht schon mit Betrag in einer
       Rabattzeile/im Kasten -> X dort, keine zweite Nennung. */
    var _codeXH = function (code) {
      return '<button type="button" class="mc-coupon-off" data-mc-coupon-off ' +
          'data-iso-track="cart_coupon_remove" ' +
          'aria-label="Rabattcode ' + esc(code) + ' entfernen" ' +
          'title="Rabattcode entfernen">✕</button>';
    };
    var _codeXImRabatt = !!(_showDiscount && _codeImLabel && _coupon);
    var totalRow = _showDiscount
      ? '<div class="mc-total-detail' + (totals.aktion ? ' is-aktion' : '') + '">' +
          '<div class="mc-total-row mc-total-row-orig">' +
            '<span>' + (totals.aktion ? 'Normalpreis' : 'Listenpreis') + '</span>' +
            '<span class="mc-total-orig-val">' + formatEuro(totals.original) + '</span>' +
          '</div>' +
          '<div class="mc-total-row mc-total-row-saved' + (_codeXImRabatt ? ' mc-hat-x' : '') + '">' +
            '<span>' + _discLbl + (_codeImLabel ? ' <span class="mc-disc-code">(inkl. ' + esc(_coupon.code) + ')</span>' : '') + '</span>' +
            '<span class="mc-total-saved-val">\u2212' + formatEuro(_combinedSaved) + '</span>' +
            (_codeXImRabatt ? _codeXH(_coupon.code) : '') +
          '</div>' +
          _akRefH +
        '</div>' + _akWarnH
      : _akWarnH;
    /* Trust-Element: Bewertung \u00fcber dem Checkout-Button (Conversion-Vertrauen direkt vor dem Klick).
       v232.3 (2026-05-24): "600+ Baustellen erfolgreich saniert"-Sub-Zeile auf User-Wunsch entfernt. */
    var stats = (w.ISO_STATS && typeof w.ISO_STATS === 'object') ? w.ISO_STATS : {};
    var avgStr = stats.avg || '4,77';
    var totalStr = (stats.total != null) ? stats.total : 432;
    var trustH =
      '<div class="mc-trust">' +
        '<div class="mc-trust-rating">' +
          '<span class="mc-trust-stars" aria-hidden="true">\u2605\u2605\u2605\u2605\u2605</span>' +
          '<span class="mc-trust-text"><strong>' + avgStr + '</strong> / 5 \u00b7 ' + totalStr + ' Bewertungen</span>' +
        '</div>' +
      '</div>';
    /* v525.8: Versandkosten-Pitch \u2014 ab 99,00 \u20ac versandkostenfrei.
       Vorher 10000 (=100,00 \u20ac), die Copy sagt aber \u00fcberall \"ab 99 \u20ac\".
       Eine 1-m-Wand landet bei 99,50 \u20ac und fiel damit genau in die L\u00fccke. */
    var FREE_SHIPPING_CENTS = 9900; /* 99,00 \u20ac */
    /* v490 (Bj\u00f6rn 22.07.): Gratisversand-Schwelle misst am LISTENPREIS \u2014
       "bei versand nach brutto wert gehen vor coupon" + "mengenrabatt spielt
       da eh nicht mit rein". Also Wert VOR allen Rabatten:
       cart.original_total_price (im Live-Test 995,00 bei total 897,75).
       Weder Rabattcode noch Mengenstaffel/Aktionen kosten damit jemandem den
       Gratisversand. Das Gratis-Handbuch verf\u00e4lscht nichts (Variante kostet
       0,00 \u2014 Live-Messung: original_total_price = exakt 50\u00d719,90).
       Fallback-Kette, falls Felder je fehlen: Listenpreis \u2192 Zwischensumme
       vor Codes \u2192 angezeigter Endpreis (konservativ). */
    var _shipBase = (cart && cart.original_total_price != null) ? cart.original_total_price
      : ((cart && cart.items_subtotal_price != null) ? cart.items_subtotal_price : _finalC);
    /* Aktion Paket 2, Nachbesserung 04.10. (Prüfung Ansicht M3, BAULISTE Frage 2): In der Aktion
       misst die Schublade nach Rabatt (cart.total_price), wie die Ergebnisseite (sec-06 „ab 99 €“).
       Sonst versprach sie bei 5 und 6 Flaschen (79,50 / 95,40 €) Gratisversand, den die Kasse
       nach der Gegenprüfung nicht gibt. Senkt Adrian die Schwelle im Fenster (Frage 2), hier und in
       sec-06 anpassen. Außerhalb der Aktion unverändert (Listenpreis, v490). */
    if (_akT && cart && cart.total_price != null) _shipBase = cart.total_price;
    var freeShipping = (_shipBase || 0) >= FREE_SHIPPING_CENTS;
    var taxNoteH = freeShipping
      ? '<small class="mc-tax-note mc-tax-note--free"><span class="mc-mwst-note">inkl. MwSt. \u00b7 </span><strong>Kostenloser Versand in Deutschland</strong></small>'
      : '<small class="mc-tax-note"><span class="mc-mwst-note">inkl. MwSt., </span>zzgl. Versand</small>';

    /* v341: aktivierten Rabattcode erkennen (Shopify setzt discount_code-Cookie bei /discount/CODE).
       v490: nicht bei _cartInaktiv — sonst würde der Cookie den eben gelöschten
       Geister-Code sofort wieder in den Chip heben. */
    if (!_coupon && !_cartInaktiv) {
      try {
        var _ck = (w.document.cookie.match(/(?:^|; )discount_code=([^;]+)/) || [])[1];
        if (_ck) {
          _ck = decodeURIComponent(_ck).trim();
          if (/^[A-Za-z0-9._!-]{2,40}$/.test(_ck)) _coupon = { code: _ck };
        }
      } catch (_eCk) {}
    }
    /* v341: KEIN Eingabefeld mehr — nur Anzeige, wenn ein Code aktiviert wurde.
       v501 (Björn 11.08.: »brauche eine option den rabatt code wieder zu entfernen«):
       Dazu ein Entfernen-Knopf. LIVE NACHGEMESSEN, was Shopify wirklich zulässt:
         POST /cart/update.js {discount:''}  -> HTTP 200, discount_codes wird [],
                                               Summe ging 867,51 € -> 963,90 € zurück
         danach steht der discount_code-Cookie ABER NOCH -> der Chip käme beim
         nächsten Rendern über die Cookie-Erkennung oben sofort zurück.
       Deshalb beides: Cart-Attribut löschen UND Cookie löschen. Der Cookie ist
       nicht HttpOnly, JS darf ihn entfernen (geprüft). Genau die v490-Falle,
       die im Kommentar oben schon steht.
       v615 (Adrian 16.10.): Der blaue Chip „✓ Rabattcode „X“ wird angewendet ✕" entfällt in v1
       und v2 (couponTriggerH bleibt leer, der leere Platzhalter in subH wie bisher ohne Code).
       Das X steht jetzt rechts in der grünen Rabattzeile (_codeXH, siehe oben). Nur wenn der Code
       KEINEN eigenen Betrag in einer Rabattzeile hat (nur Cookie, noch nicht anwendbar, Versand-
       code, 0 €) – dort war der Chip bisher der einzige Hinweis –, steht an derselben Stelle über
       dem Gesamtpreis die grüne Zeile „Rabattcode „X“ wird angewendet" mit dem X rechts statt
       Betrag, damit der Code sichtbar und entfernbar bleibt. */
    var couponTriggerH = '';
    var _codeZeileH = (_coupon && !_codeXImRabatt)
      ? '<div class="mc-rabatt mc-rabatt--code">' +
          '<span class="mc-rabatt-lbl">Rabattcode „' + esc(_coupon.code) + '“ wird angewendet</span>' +
          _codeXH(_coupon.code) +
        '</div>'
      : '';
    var couponInputH = '';

    /* ═══════════════════════════════════════════════════════════════
       v612 (Adrian 15.10.): „Das darf nicht viel Platz brauchen […] Viel wichtiger sind die
       Produkte." Statt Kasten „Listenpreis / Gesamtrabatt (inkl. Code)" EINE schmale
       Rabattzeile über dem Gesamtpreis. Nur die ANZEIGE – alle Beträge kommen unverändert
       aus totals/_combinedSaved/_finalC (keine neue Rechnung).
       v613 (Adrian 15.10.): „Die Reihenfolgen nicht ändern." Die schmale Rabattzeile bleibt,
       aber OHNE Entfernen-X und nur dort, wo es einen Betrag gibt:
         · Code am Warenkorb mit Abzug        -> „Rabatt „X““ bzw. „Gesamtrabatt inkl. „X““ −Betrag
                                                 (steckt mehr als der Code im Abzug, z. B. Mengen-
                                                 rabatt; Anteil des Codes nur aus Shopifys
                                                 Zuteilungen gelesen – Anzeigewort, kein Rechenweg)
         · sonst Abzug (Mengenrabatt)         -> „Mengenrabatt −Betrag“ (bzw. _discLbl)
         · Code ohne eigenen Betrag (nur Cookie, Versandcode …) -> keine Rabattzeile
       Der Code selbst steht mit dem X wieder wie in v611 als Chip „✓ Rabattcode „X“ wird
       angewendet ✕" unter „Kostenloser Versand in Deutschland" (subH/couponTriggerH, dieselben
       Attribute data-mc-coupon-off und data-iso-track="cart_coupon_remove"). Kein durch-
       gestrichener Listenpreis mehr vor dem Gesamtpreis – dort steht wieder „inkl. MwSt.".
       In der Aktion (totals.aktion: „Normalpreis", Aktionsname, Pflichtangabe) bleibt der
       Kasten wie in v611. Gilt in v1 und v2.
       v615 (Adrian 16.10.): Chip entfällt; das X steht wieder in der Rabattzeile, jetzt ganz rechts
       hinter dem Betrag; Code ohne eigenen Betrag -> eigene Zeile _codeZeileH (siehe oben). */
    var _kompakt = !totals.aktion;
    var _rabattH = '';
    if (_kompakt && _showDiscount) {
      var _rbLbl = _discLbl;
      if (_codeImLabel && _coupon) {
        /* v615: _codeCent wird jetzt oben gelesen (gleiche Zuteilungen, gleicher Wert). */
        _rbLbl =((_combinedSaved - _codeCent) > 1 ? 'Gesamtrabatt inkl. ' : 'Rabatt ') + '„' + esc(_coupon.code) + '“';
      }
      /* v615 (Adrian 16.10.): mit Code hier ganz rechts hinter dem Betrag das X (reiner
         Mengenrabatt ohne Code: ohne X, nicht entfernbar). */
      _rabattH = '<div class="mc-rabatt' + (_codeXImRabatt ? ' mc-rabatt--x' : '') + '">' +
          '<span class="mc-rabatt-lbl">' + _rbLbl + '</span>' +
          '<span class="mc-rabatt-wert">−' + formatEuro(_combinedSaved) + '</span>' +
          (_codeXImRabatt ? _codeXH(_coupon.code) : '') +
        '</div>';
    }

    var dynamicCheckoutNode = detachDynamicCheckoutNode(foot);
    var shipH = mcShipETA();
    /* Bausteine des Fußes — beide Layouts benutzen dieselben Stücke, nur in
       anderer Reihenfolge. Nichts davon wird doppelt berechnet. */
    var gwpH      = (w.IsoGift && typeof w.IsoGift.offerHTML === 'function' ? w.IsoGift.offerHTML(cart) : '');
    /* v613 (Adrian 15.10.): Gesamtpreis und Zusatzzeile wieder wie v611 – „inkl. MwSt." klein
       vor dem Preis (mobil), darunter „Kostenloser Versand in Deutschland" und der Code-Chip mit X.
       v615 (Adrian 16.10.): Chip entfallen (couponTriggerH leer), X in der Rabattzeile. */
    var summeH    = '<div class="mc-total">' +
                      '<div class="mc-total-lbl"><span>Gesamtpreis</span></div>' +
                      '<div class="mc-total-val"><span class="mc-mwst-pre">inkl. MwSt.</span>' + formatEuro(_finalC) + '</div>' +
                    '</div>';
    var subH      = '<div class="mc-total-sub">' + taxNoteH + '<span class="mc-coupon-trigger">' + couponTriggerH + '</span></div>';
    /* v528 (Björn): Der Knopf soll der aus dem Entwurf sein — mit Unterzeile.
       „Sie zahlen jetzt noch nichts" nimmt die Sorge, der Klick sei schon
       verbindlich; derselbe Satz steht auf der Ergebnisseite unter dem
       Kaufknopf und hat dort dieselbe Aufgabe. v1 behält den einzeiligen. */
    var kaufPfeil = '<span class="isf-arrow-circle" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg></span>';
    /* Aktion Paket 2: Abzeichen + feste Frist (keine Uhr — die Schublade liegt über Seiten,
       deren Hauptknopf schon eine laufende Uhr trägt). Nur im Layout v2 (Spaltenknopf). */
    var _akKnopf = { m: '', f: '' };
    /* Nachbesserung (Prüfung Ansicht S5): nur, wenn Shopify den Aktionsrabatt wirklich zugeteilt hat —
       sonst stünde „Black Friday Wochen“ über einer Summe ohne Aktionspreis. */
    try { if (totals.aktion && w.ISO_AKTION && typeof w.ISO_AKTION.knopfHtml === 'function') _akKnopf = { m: w.ISO_AKTION.knopfHtml('marke'), f: w.ISO_AKTION.knopfHtml('frist') }; } catch (_eAkK) {}
    var kaufH = istV2()
      ? '<button class="mc-checkout" data-mc-checkout>'
        + _akKnopf.m
        + '<span class="mc-checkout-txt">Zur Kasse gehen ' + kaufPfeil + '</span>'
        + '<span class="mc-checkout-sub">Sie zahlen jetzt noch nichts</span>'
        + _akKnopf.f
        + '</button>'
      : '<button class="mc-checkout" data-mc-checkout>Zur Kasse gehen ' + kaufPfeil + '</button>';
    var slotH     = '<div class="mc-dynamic-slot" id="mc-dynamic-slot" hidden></div>';
    var devH      = (isDev ? '<div class="mc-dev-hint">Dev-Modus: lokaler Mock \u2014 Shopify-Cart ist nicht erreichbar</div>' : '');
    var shipBlockH= (shipH ? '<div class="mc-ship">' + shipH + '</div>' : '');

    /* v528 · v2: Die Zusicherungen stehen UNTER dem Kaufknopf, nicht darüber.
       Der Einwand („und wenn es nicht klappt?") kommt im Moment des Klickens,
       nicht davor. Garantie und Hendrik sind dieselben Aussagen wie auf der
       Ergebnisseite — Wortlaut bewusst identisch, Hendriks Nummer ist Kanon. */
    /* v528 (Björn 14.09.): „anstatt vorne drei grüne Haken: bei Hendrik nehmen
       wir Hendrik als Symbol, bei der Wirksamkeitsgarantie das Logo davon, und
       den LKW beim Versand."
       Richtig — drei gleiche Haken sagen nur „Häkchen", die Sache selbst sagt
       mehr. Das Siegel und Hendriks Gesicht sind wiedererkennbar und stehen
       genauso auf der Ergebnisseite; der Lastwagen trägt die Versandzeile.

       Der Lastwagen kommt dabei AUS shipH — deshalb bleibt er dort und wird
       nicht zusätzlich davorgesetzt, sonst stünden wieder zwei nebeneinander
       (Fehler aus der ersten Fassung). */
    /* v611 (Adrian 15.10.): \u201ewenn Rabattcode von Hendrik angewendet wird, dass wir unten
       drunter Hendrik ausblenden in der Beschreibung, um den Platz zu bekommen."
       Der Kunde kennt Hendrik dann schon \u2014 ebenso, wenn er \u00fcber Hendriks Link kam
       (Bestellmerkmal isofin_berater=Hendrik, v603; der Warenkorb-Link legt es am
       Warenkorb ab \u2014 gelesen an Bestellung #3159: Landeseite /cart, Merkmal vorhanden).
       Erkannt wird jeder Code, der mit \u201ehendrik" beginnt (Gro\u00df/Klein egal): der Code im
       Chip (_coupon, inkl. Cookie-R\u00fcckfall), alle Warenkorb-Codes (auch nicht anwendbare \u2014
       den Code hat der Kunde trotzdem von Hendrik), die Rabatt-Anwendungen auf Warenkorb-
       und Zeilenebene. Garantie und Versandzeile bleiben. Nur v2 (v1 hat die Zeile nicht).
       v612 (Adrian 15.10.): Die Garantie steht seit v612 an den Produktzeilen (Paket,
       Einzelflaschen). v613: Hendrik- und Versandzeile wieder hier unter dem Kaufknopf
       (zusicherungH) – Logik hier unverändert. */
    var _hendrikBekannt = false;
    try {
      var _hT = function (s) { return /^hendrik/i.test(String(s == null ? '' : s).trim()); };
      if (_coupon && _hT(_coupon.code)) _hendrikBekannt = true;
      ((cart && cart.discount_codes) || []).forEach(function (dc) { if (dc && _hT(dc.code)) _hendrikBekannt = true; });
      ((cart && cart.cart_level_discount_applications) || []).forEach(function (ap) { if (ap && ap.type === 'discount_code' && _hT(ap.title)) _hendrikBekannt = true; });
      ((cart && cart.items) || []).forEach(function (it) {
        ((it && it.line_level_discount_allocations) || []).forEach(function (al) {
          var ap = al && al.discount_application;
          if (ap && ap.type === 'discount_code' && _hT(ap.title)) _hendrikBekannt = true;
        });
      });
      if (_hT(((cart && cart.attributes) || {}).isofin_berater)) _hendrikBekannt = true;
    } catch (_eHb) {}
    /* v613 (Adrian 15.10.): „Die Reihenfolgen nicht ändern." Die Zusicherungen stehen wieder
       wie in v611 UNTER dem Kaufknopf im festen Fuß (v612 hatte Hendrik und „Verschlüsselte
       Verbindung" in den Rumpf und den Versand über den Knopf verschoben):
         · Garantie: NICHT hier – bleibt seit v612 an Paket/Einzelflaschen.
         · Hendrik: Wortlaut und Ausblenden-Regel wie v611 (_hendrikBekannt).
         · Versand: Lastwagen in der Symbolspalte wie v611 (v528).
       Eng: 13 px, Zeilenhöhe 1,35, Abstand 6 px, Symbole mittig (CSS v613). Nur v2. */
    var _zusiZeilenH = (_hendrikBekannt ? '' :
          '<div><img class="mc-zusi-bild is-rund" src="https://cdn.shopify.com/s/files/1/0846/5550/5691/files/2026-hendrik-fluegge-blau-avatar-mittel-300px.jpg?v=1790351554&width=96" alt="" loading="lazy" width="24" height="24">' +
            '<span><b>Hendrik Fl\u00fcgge</b>, Mauerwerks-Abdichtungsexperte \u2014 kostenlos am Telefon und per WhatsApp, vor dem Kauf, w\u00e4hrend der Anwendung und danach</span></div>') +
          /* v528: Der Lastwagen gehört in die Symbolspalte, nicht in den Text —
             sonst begänne die Zeile an der linken Kante statt an derselben
             Textkante wie Garantie und Hendrik (so war es im ersten Anlauf,
             die Zeile sah verrutscht aus). shipH trägt sein Symbol am Anfang;
             wir schneiden es dort ab und setzen es in die eigene Spalte.
             v613 (Adrian 15.10.): die Garantie steht seit v612 an den Produktzeilen. */
          (shipH ? '<div><span class="mc-zusi-lkw" aria-hidden="true">\ud83d\ude9a</span>' +
                     '<span>' + shipH.replace(/^\s*\ud83d\ude9a\s*/, '') + '</span></div>' : '');
    var zusicherungH = (istV2() && _zusiZeilenH) ? '<div class="mc-zusi">' + _zusiZeilenH + '</div>' : '';

    foot.innerHTML = istV2()
      /* v2 – v613 (Adrian 15.10.): wieder die Reihenfolge von v611:
         Rabattzeile (bzw. Aktion-Kasten) → Summe → Versandhinweis + Code-Chip → Knopf →
         Zusicherungen → Zahlarten → „Verschlüsselte Verbindung".
         v528 (Björn): die Sicherheitszeile steht UNTER den Zahlarten, zentriert.
         mountPayLogos() hängt die Logos vor #mc-dynamic-slot ein — steht die
         Zeile davor, landet sie über den Logos. Also hinter den Slot.
         v613 (Adrian 15.10.): der rote Vorschau-Hinweis der Aktion (_akWarnH) steht wie in
         v611 HINTER der Rabattzeile (v611: hinter dem Kasten), nicht davor.
         v615 (Adrian 16.10.): Code ohne eigenen Betrag (_codeZeileH) direkt unter der Rabatt-
         zeile bzw. dem Aktions-Kasten, über dem Gesamtpreis; der blaue Chip in subH entfällt. */
      ? gwpH + (_kompakt ? _rabattH + _codeZeileH + _akWarnH : totalRow + _codeZeileH) + summeH + subH + couponInputH + kaufH + zusicherungH + slotH
        /* v528 (Björn): „das Schloss oben mit in die erste Zeile." Es sitzt jetzt
           IM Textfluss, als erstes Zeichen des Satzes, nicht als eigene Spalte
           daneben — dadurch steht es immer in der ersten Zeile, egal wo der
           Text umbricht.
           v528 (Björn 15.09.): „Verschlüsselung erstmal nur so als Text." Der
           Zusatz „Bezahlung erst im nächsten Schritt" fällt weg — der Kaufknopf
           trägt zwei Zeilen darüber schon „Sie zahlen jetzt noch nichts". */
        + '<p class="mc-sicher"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4" y="11" width="16" height="10" rx="2"></rect><path d="M8 11V7a4 4 0 0 1 8 0v4"></path></svg>Verschl\u00fcsselte Verbindung</p>'
        + devH
      /* v1: Reihenfolge wie v611; v612/v613 (Adrian 15.10.): außerhalb der Aktion die schmale
         Rabattzeile statt Kasten (wie v2), Code-Chip mit X wieder in der Zusatzzeile (subH).
         v615 (Adrian 16.10.): wie v2 – X in der Rabattzeile, Chip weg, _codeZeileH über dem Preis. */
      : gwpH + (_kompakt ? _rabattH + _codeZeileH + _akWarnH : totalRow + _codeZeileH) + summeH + subH + couponInputH + shipBlockH + kaufH + slotH + devH;
    mountDynamicCheckout(foot, dynamicCheckoutNode);
    mountPayLogos(foot);
    if (w.requestAnimationFrame) w.requestAnimationFrame(updateScrollCue); else updateScrollCue();

    var coBtn = foot.querySelector('[data-mc-checkout]');
    if (coBtn) {
      coBtn.addEventListener('click', function () {
        if (isDev) {
          alert('Dev-Modus: Checkout w\u00fcrde jetzt zu /checkout navigieren.');
          return;
        }
        var _coUrl = '/checkout';
        if (_coupon && _coupon.code) { _coUrl = '/discount/' + encodeURIComponent(_coupon.code) + '?redirect=' + encodeURIComponent('/checkout'); }
        window.location.href = _coUrl;
      });
    }

    /* v341: keine Coupon-Eingabe-Handler mehr — Code kommt ausschließlich über
       Shopify-Aktivierung (Hendrik-Links); Anzeige oben ist rein informativ. */
  }

  function changeQty(lineIdx, newQty) {
    lineIdx = parseInt(lineIdx, 10); newQty = parseInt(newQty, 10);
    if (!lineIdx || lineIdx < 1 || _busy) return;
    if (!newQty || newQty < 1) { removeLine(lineIdx); return; }
    _busy = true;
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ line: lineIdx, quantity: newQty }) })
      .then(function (r) { return r && r.ok ? r.json() : null; })
      .then(function () { _busy = false; refresh(); })
      .catch(function () { _busy = false; });
  }

  /* v501: Rabattcode wieder entfernen (Björn 11.08.).
     ZWEI Schritte sind nötig, live nachgemessen am 11.08.:
       1. POST /cart/update.js {discount:''} — Shopify nimmt den Code aus dem
          Warenkorb (discount_codes wird [], Summe springt zurück). HTTP 200.
       2. Den discount_code-Cookie löschen. Schritt 1 räumt ihn NICHT mit weg,
          und renderCart() liest ihn als Rückfallebene — ohne Schritt 2 stünde
          der Chip beim nächsten Rendern sofort wieder da (v490-Falle).
     Der Cookie ist nicht HttpOnly, JS darf ihn entfernen (geprüft).
     Zusätzlich der Merker in sessionStorage, über den v309 den Code aus
     Hendrik-Links wieder einspielt — sonst käme er beim nächsten Öffnen zurück. */
  function removeCoupon() {
    if (_busy) return;
    _busy = true;

    /* Cookie zuerst — falls der Netzaufruf scheitert, ist wenigstens die
       Anzeige-Rückfallebene weg und der Nutzer sieht keinen Geister-Chip. */
    try {
      var wege = ['path=/', 'path=/; domain=' + w.location.hostname,
                  'path=/; domain=.' + w.location.hostname.replace(/^www\./, '')];
      for (var i = 0; i < wege.length; i++) {
        w.document.cookie = 'discount_code=; Max-Age=0; ' + wege[i];
      }
    } catch (_eCk) {}
    /* Der Schlüssel heißt iso_drawer_discount (siehe open(), v309-Block) —
       nicht wie zunächst angenommen __ISO_DISCOUNT__. */
    try { w.sessionStorage.removeItem('iso_drawer_discount'); } catch (_eSt) {}

    /* Sofort aus dem Anzeigezustand nehmen, nicht erst nach der Antwort:
       sonst blitzt der Chip bis zum nächsten Rendern weiter. _couponEntfernt
       verhindert zusätzlich, dass ein noch in der Adresszeile stehendes
       ?discount=… den Code beim nächsten Öffnen wieder hereinholt. */
    _coupon = null;
    _couponEntfernt = true;

    fetch('/cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: '' })
    })
      .then(function (r) { return r && r.ok ? r.json() : null; })
      .then(function () { _busy = false; refresh(); })
      .catch(function () { _busy = false; refresh(); });
  }

  function removeLine(lineIdx) {
    lineIdx = parseInt(lineIdx, 10);
    if (!lineIdx || lineIdx < 1 || _busy) return;
    _busy = true;

    var card = _panel && _panel.querySelector('[data-mc-line="' + lineIdx + '"]');
    if (card) card.classList.add('mc-item-leaving');

    /* v236.4: Sanierungspaket-Detection + SOFORT-Reset (vor postRemove).
       Storage-Clear ist von der async Cart-Mutation unabhängig — wenn User
       direkt nach Klick weiternavigiert, ist der Reset trotzdem schon passiert. */
    var wasSanierungspaket = false;
    try {
      var existingItems = (_cartData && _cartData.items) || [];
      var idx0 = lineIdx - 1;
      if (existingItems[idx0]) {
        wasSanierungspaket = String(existingItems[idx0].variant_id || '') === ISOFIN_VARIANT;
      }
    } catch (_e) {}
    if (wasSanierungspaket && w.IsoWizardReset && typeof w.IsoWizardReset.clearState === 'function') {
      try { w.IsoWizardReset.clearState(); } catch (_eR) {}
    }

    postRemove(lineIdx).then(function (cart) {
      if (cart && cart.items) {
        _cartData = cart;
        renderCart(cart);
      } else {
        return refresh();
      }
      refreshCartIconBubble();
      refreshTopbar();
      dispatchAddEvents(_cartData);
      return cart;
    }, function () {
      return refresh();
    }).then(function () {
      _busy = false;
    }, function () {
      _busy = false;
    });
  }

  function clearCalculationState() {
    try {
      if (w.IsoDash && w.IsoDash.Calculations && typeof w.IsoDash.Calculations.clearAnalysis === 'function') {
        w.IsoDash.Calculations.clearAnalysis();
      }
    } catch (_) {}
    var keys = ['isodash_project_v8','isofinHeroState','isofinAnalysis','__ISOWIZ_RESUME_ANALYSIS__','__ISOWIZ_analysis','fa_state_v2','isodash_moisture_check_completed','isodash_flow_phase','isodash_entry_mode','isodash_capillary_fit','isodash_capillary_confidence','isodash_capillary_check','isodash_masonry_type','isodash_moisture_type','isodash_analysis_source','isodash_nav_unlock_shown','isodash_a2c_done','isodash_transition_shown','__ISOWIZ_state__','__ISOWIZ_share_state__','isodash-wiz:analysis','isodash-wiz:calcState','isofinCalcState'];
    keys.forEach(function (k) {
      try { localStorage.removeItem(k); } catch (_) {}
      try { sessionStorage.removeItem(k); } catch (_) {}
    });
    try {
      for (var i = localStorage.length - 1; i >= 0; i--) {
        var lk = localStorage.key(i);
        if (lk && lk.indexOf('__ISOWIZ') === 0) localStorage.removeItem(lk);
      }
    } catch (_) {}
    try {
      for (var j = sessionStorage.length - 1; j >= 0; j--) {
        var sk = sessionStorage.key(j);
        if (sk && sk.indexOf('__ISOWIZ') === 0) sessionStorage.removeItem(sk);
      }
    } catch (_) {}
    try { if (w.IsoWiz && w.IsoWiz.Storage && typeof w.IsoWiz.Storage.resetAll === 'function') w.IsoWiz.Storage.resetAll(); } catch (_) {}
  }

  function removeSanierungspaketLines() {
    if (_cartData && _cartData._demo) {
      var kept = (_cartData.items || []).filter(function (it) {
        return String(it.variant_id || '') !== ISOFIN_VARIANT;
      });
      var total = kept.reduce(function (s, it) { return s + (it.final_line_price || it.line_price || 0); }, 0);
      var cnt = kept.reduce(function (s, it) { return s + (it.quantity || 0); }, 0);
      _cartData = { items: kept, total_price: total, item_count: cnt, _demo: true };
      return Promise.resolve(_cartData);
    }

    return fetchCart().then(function (cart) {
      var items = (cart && cart.items) || [];
      var lines = [];
      items.forEach(function (it, idx) {
        if (String(it.variant_id || '') === ISOFIN_VARIANT) lines.push(idx + 1);
      });
      if (!lines.length) return cart;

      lines.sort(function (a, b) { return b - a; });
      var chain = Promise.resolve(cart);
      lines.forEach(function (line) {
        chain = chain.then(function () { return postRemove(line); });
      });
      return chain.then(function (nextCart) {
        if (nextCart && nextCart.items) return nextCart;
        return fetchCart();
      });
    });
  }

  function refreshTopbar() {
    /* Force-refresh des Cart-Caches in der Shell — sonst greift dort der
       1.5s-Debounce und die Topbar zeigt kurz veraltete Werte. Direkt nach
       Mini-Cart-Mutationen (remove, add, …) wollen wir sofortige Konsistenz
       zwischen Cart-Sidebar und Topbar-Anzeige. */
    if (w.IsoDash && typeof w.IsoDash.refreshCartCache === 'function') {
      try { w.IsoDash.refreshCartCache(); } catch (_) {}
    } else if (w.IsoDash && typeof w.IsoDash.renderTopbarData === 'function') {
      try { w.IsoDash.renderTopbarData(); } catch (_) {}
    }
  }

  function handleReset() {
    /* Cart schließen und den zentralen Reset-Flow (Confirm-Modal + Storage-Reset + Reload)
       aus der Shell auslösen. */
    close();
    if (w.ID && typeof w.ID.resetAll === 'function') {
      /* Im Dashboard / auf Wizard-Seiten — Shell hat schon Modal + komplette Logik */
      setTimeout(function () { try { w.ID.resetAll(); } catch (_) {} }, 280);
      return;
    }
    /* v201: Standalone-Reset für alle anderen Seiten (Startseite, Produktseite, etc.) —
       Shell ist dort nicht geladen, daher inline:
       1. Confirm-Dialog, 2. Calculation-Storage löschen, 3. nur Sanierungspaket entfernen,
       4. Navigation zur Kalkulator-Seite. Separate Einzelflaschen bleiben im Warenkorb. */
    setTimeout(function () {
      if (!confirm('Möchten Sie das Sanierungspaket neu berechnen?\n\nDie aktuelle Berechnung wird zurückgesetzt. Einzelflaschen bleiben im Warenkorb.')) return;
      clearCalculationState();
      var done = false;
      function _go() {
        if (done) return;
        done = true;
        try { window.location.href = '/pages/kalkulator'; } catch (_) { window.location.reload(); }
      }
      try {
        removeSanierungspaketLines().then(_go, _go);
        setTimeout(_go, 1500);
      } catch (_) { _go(); }
    }, 280);
  }

  function refresh() {
    return fetchCart().then(function (cart) {
      _cartData = cart;
      renderCart(cart);
      refreshTopbar();
      /* v309-Fix: JEDE Mutation via refresh() (Mengenänderung, Fallback-Pfade) muss
         externe Listener (Homepage-CTA, Sticky) benachrichtigen — nicht nur der Add-Pfad.
         Sicher gegen Schleifen: der eigene Cart-Event-Listener ruft nur schedule()→
         reconcile() (Geschenk-Banner), niemals refresh(). */
      dispatchAddEvents(cart);
      return cart;
    });
  }

  function refreshCartIconBubble() {
    var root = '/';
    try {
      if (w.Shopify && w.Shopify.routes && w.Shopify.routes.root) root = w.Shopify.routes.root;
    } catch (_) {}
    if (!root) root = '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';

    return fetch(root + '?sections=cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) { return r && r.ok ? r.json() : null; })
      .then(function (sections) {
        if (!sections || !sections['cart-icon-bubble']) return;
        var doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        /* v310-Fix: Das Section-Markup ist in .shopify-section gewrappt und enthaelt
           NICHT die ID #cart-icon-bubble (die sitzt nur auf dem <a> im Header) →
           getElementById lieferte immer null, der Badge wurde nie aktualisiert (blieb
           auf dem Server-Stand vom Seitenladen). Jetzt den Section-Inhalt uebernehmen;
           bei leerem Warenkorb fehlt die .cart-count-bubble → die "2" verschwindet. */
        var sec  = doc.querySelector('#shopify-section-cart-icon-bubble') || doc.querySelector('.shopify-section');
        var html = sec ? sec.innerHTML : (doc.body ? doc.body.innerHTML : '');
        var curr = document.getElementById('cart-icon-bubble');
        if (curr && html) curr.innerHTML = html;
      })
      .catch(function () {});
  }

  function dispatchAddEvents(cart) {
    try {
      document.dispatchEvent(new CustomEvent('product:added', { detail: { cart: cart || _cartData || null } }));
    } catch (_) {}
    try {
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart || _cartData || null } }));
    } catch (_) {}
    try {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart || _cartData || null } }));
    } catch (_) {}
  }

  function openAfterAdd() {
    refreshCartIconBubble();
    _autoOeffnung = true;   /* nicht vom Nutzer ausgeloest — eigener Ereignisname */
    open();
    dispatchAddEvents(_cartData);
  }

  function markUserAddIntent() {
    try { w.__IsoDashA2CUserIntentUntil = Date.now() + 6000; } catch (_) {}
  }

  function hasUserAddIntent() {
    try { return Number(w.__IsoDashA2CUserIntentUntil || 0) > Date.now(); } catch (_) {}
    return false;
  }

  function consumeUserAddIntent() {
    var ok = hasUserAddIntent();
    if (ok) {
      try { w.__IsoDashA2CUserIntentUntil = 0; } catch (_) {}
    }
    return ok;
  }

  function isCartAddUrl(raw) {
    if (!raw) return false;
    try {
      var u = new URL(raw, w.location.origin);
      return u.origin === w.location.origin && /\/cart\/add(?:\.js)?\/?$/.test(u.pathname);
    } catch (_) {
      return /\/cart\/add(?:\.js)?(?:[?#]|$)/.test(String(raw));
    }
  }

  function toAjaxCartAddUrl(raw) {
    try {
      var u = new URL(raw || '/cart/add', w.location.origin);
      return u.pathname.replace(/\/cart\/add(?:\.js)?\/?$/, '/cart/add.js');
    } catch (_) {
      return '/cart/add.js';
    }
  }

  function getQtyNear(el) {
    var root = (el && el.closest && el.closest('form,.iso-product-hero-info,.product-form')) || document;
    var input = null;
    try { input = root.querySelector('[name="quantity"],#iso-qty-input,[data-iso-quantity]'); } catch (_) {}
    var qty = parseInt(input && input.value, 10);
    if (isNaN(qty) || qty < 1) qty = 1;
    if (qty > 999) qty = 999;
    return qty;
  }

  function setLoading(el, on) {
    if (!el) return;
    if (on) {
      if (el.__isoA2cLoading) return;
      el.__isoA2cLoading = true;
      el.__isoA2cHTML = el.innerHTML;
      el.setAttribute('aria-busy', 'true');
      if ('disabled' in el) el.disabled = true;
      if (el.tagName === 'BUTTON' || el.getAttribute('role') === 'button') {
        el.innerHTML = '<span>Wird hinzugefügt ...</span>';
      }
      return;
    }
    el.__isoA2cLoading = false;
    el.removeAttribute('aria-busy');
    if ('disabled' in el) el.disabled = false;
    if (el.__isoA2cHTML != null) el.innerHTML = el.__isoA2cHTML;
  }

  function parseAddError(response) {
    return response.json()
      .then(function (err) {
        return new Error((err && (err.description || err.message)) || ('HTTP ' + response.status));
      })
      .catch(function () {
        return new Error('HTTP ' + response.status);
      });
  }

  function postCartAdd(input, opts) {
    opts = opts || {};
    var init = {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    };
    if (opts.json) {
      init.headers['Content-Type'] = 'application/json';
      init.body = JSON.stringify(input);
    } else {
      init.body = input;
    }
    return fetch(opts.url || '/cart/add.js', init)
      .then(function (r) {
        if (!r || !r.ok) return parseAddError(r).then(function (err) { throw err; });
        return r.json();
      })
      .then(function (lineItem) {
        openAfterAdd();
        return lineItem;
      });
  }

  function addAndOpen(variantId, quantity, properties) {
    var payload = { id: variantId, quantity: quantity || 1 };
    if (properties) payload.properties = properties;
    return postCartAdd(payload, { json: true });
  }

  function showAddError(el, err) {
    console.error('[IsoDashMiniCart] Add-to-cart failed:', err);
    var host = el && el.closest && el.closest('product-form');
    var wrapper = host && host.querySelector('.product-form__error-message-wrapper');
    var msg = wrapper && wrapper.querySelector('.product-form__error-message');
    if (msg) {
      msg.textContent = (err && err.message) || 'Artikel konnte nicht hinzugefügt werden.';
      wrapper.hidden = false;
      setLoading(el, false);
      return;
    }
    if (el && (el.tagName === 'BUTTON' || el.getAttribute('role') === 'button')) {
      el.innerHTML = '<span>Fehler - erneut versuchen</span>';
      setTimeout(function () { setLoading(el, false); }, 1800);
      return;
    }
    setLoading(el, false);
  }

  function wireGlobalAddToCart() {
    if (w.__IsoDashA2CBridgeWired) return;
    w.__IsoDashA2CBridgeWired = true;

    document.addEventListener('click', function (e) {
      var trigger = e.target && e.target.closest && e.target.closest('[data-iso-add-to-cart],a[href]');
      if (!trigger) return;

      if (trigger.hasAttribute('data-iso-add-to-cart')) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        if (trigger.__isoA2cLoading) return;
        var variantId = parseInt(trigger.getAttribute('data-iso-add-to-cart'), 10);
        if (!variantId) return;
        markUserAddIntent();
        setLoading(trigger, true);
        addAndOpen(variantId, getQtyNear(trigger))
          .then(function () { setLoading(trigger, false); })
          .catch(function (err) { showAddError(trigger, err); });
        return;
      }

      if (trigger.tagName === 'A' && isCartAddUrl(trigger.getAttribute('href'))) {
        if (trigger.hasAttribute('data-iso-direct-checkout')) return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        if (trigger.__isoA2cLoading) return;
        var url = new URL(trigger.href, w.location.origin);
        var id = url.searchParams.get('id');
        var qty = parseInt(url.searchParams.get('quantity'), 10);
        if (!qty || qty < 1) qty = getQtyNear(trigger);
        if (!id) return;
        markUserAddIntent();
        setLoading(trigger, true);
        addAndOpen(id, qty)
          .then(function () { setLoading(trigger, false); })
          .catch(function (err) { showAddError(trigger, err); });
      }
    }, true);

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.getAttribute || !isCartAddUrl(form.getAttribute('action'))) return;
      var submitter = e.submitter || document.activeElement;
      if (submitter && submitter.name === 'checkout') return;
      if (submitter && submitter.closest && submitter.closest('.shopify-payment-button')) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      if (submitter && submitter.__isoA2cLoading) return;
      markUserAddIntent();
      setLoading(submitter, true);
      postCartAdd(new FormData(form), { url: toAjaxCartAddUrl(form.getAttribute('action')) })
        .then(function () { setLoading(submitter, false); })
        .catch(function (err) {
          showAddError(submitter || form, err);
          if (!submitter) setLoading(submitter, false);
        });
    }, true);
  }

  /* ── Public API ───────────────────────────────────────────── */
  function open(quelle) {
    /* v531: Die Öffnungsquelle kommt jetzt als Argument herein (header_icon,
       cart_redirect, sticky, ergebnis …). Alle Altaufrufe ohne Argument
       funktionieren unverändert weiter — dann bleibt die Quelle leer. */
    if (quelle) {
      try { _oeffnungsQuelle = String(quelle).replace(/[^a-z0-9]+/gi, '').toLowerCase(); } catch (_eQ) {}
      /* v537 (Analytics 18.09.): feste Werteliste. Bisher wurde JEDER Wert
         zum Ereignisnamen — am 17.09. landeten so Prüfwerte wie
         cart_drawer_open_von_diagnose882 dauerhaft in den echten Daten.
         Unbekannte Werte erzeugen jetzt KEINE _von_-Variante (die Basis
         cart_drawer_open zählt weiter). Neuer Öffner mit Quelle → hier eintragen
         und im Tracking-Katalog nachziehen. */
      if (!Object.prototype.hasOwnProperty.call({ headericon: 1, cartredirect: 1 }, _oeffnungsQuelle)) _oeffnungsQuelle = '';
    }
    /* v148: Defensiv — falls open() aufgerufen wird bevor init() lief
       (z.B. via header.liquid Event-Delegation auf einer Page wo es
       kein Dashboard gibt), CSS hier nachholen. */
    if (!document.getElementById(CSS_ID)) injectCSS();
    if (!_panel) _panel = buildPanel();
    var _warOffen = _open;
    _panel.classList.add('mc-open');
    _open = true;
    /* open() hat keinen Eigen-Guard und wird von sieben Stellen gerufen —
       ohne Vorzustands-Pruefung zaehlt jedes weitere Hinzufuegen mit. */
    if (!_warOffen) {
      var _basis = _autoOeffnung ? 'cart_drawer_open_auto' : 'cart_drawer_open';
      mcTrack(_basis);
      /* Seite und Auslöser als eigene Namen — ohne Layout-Endung, sonst
         entstünde ein Kreuzprodukt aus Seite × Quelle × Layout.
         v532: in try/catch — mcTrack schützt sich selbst, diese beiden
         Direktaufrufe taten es nicht. Ein Fehler hier hätte open() mitten im
         Aufbau abgebrochen und die Schublade leer stehen lassen. */
      try {
        mcSend(_basis + '_seite_' + mcSeite());
        if (_oeffnungsQuelle) mcSend(_basis + '_von_' + _oeffnungsQuelle);
      } catch (_eO) {}
    }
    _autoOeffnung = false;
    _oeffnungsQuelle = '';
    /* v313.1: Gegenseitig ausschließen — Warenkorb auf → Sanierungsplan-Schublade (Sticky-Footer) zu. */
    try { if (window.IsofinStickyPlan && window.IsofinStickyPlan.closeAll) window.IsofinStickyPlan.closeAll(); } catch (_eSx) {}
    /* v309: Scroll-Lock NUR mobil (Vollbild-Drawer) — sonst scrollt der Hintergrund mit und das fuehlt
       sich wie ein Bug an. Auf Desktop (Seitenpanel, >520px) bleibt die Hauptseite scroll- & klickbar
       (Backdrop pointer-events:none). Unlock in close(). */
    try { if ((w.innerWidth || 0) <= 520) document.body.style.overflow = 'hidden'; } catch (_e0) {}
    /* v309: Rabattcode aus Hendrik-Link / URL (?discount=) bzw. /cart-Redirect (sessionStorage)
       automatisch erkennen und anwenden — fuer alle Cases (Code URL-decodiert, z.B. hendrik%2110 -> hendrik!10). */
    if (!_coupon && !_couponEntfernt) {
      try {
        var _pc = '';
        var _m = (location.search || '').match(/[?&]discount=([^&]+)/i);
        if (_m) { try { _pc = decodeURIComponent(_m[1].replace(/\+/g, ' ')); } catch (_e) { _pc = _m[1]; } }
        if (!_pc) { try { _pc = sessionStorage.getItem('iso_drawer_discount') || ''; } catch (_e2) {} }
        if (_pc) _coupon = { code: _pc };
        try { sessionStorage.removeItem('iso_drawer_discount'); } catch (_e3) {}
      } catch (_e4) {}
    }
    refresh();
  }

  function close() {
    var _warOffen = _open;
    if (_panel) _panel.classList.remove('mc-open');
    _open = false;
    try { document.body.style.overflow = ''; } catch (_) {}
    /* handleReset() ruft close() auch bei geschlossenem Drawer — sonst entstuenden
       Schliess-Ereignisse ohne zugehoeriges Oeffnen. */
    if (_warOffen) mcTrack('cart_drawer_close');
  }

  /* ── Topbar-Binding (Klick auf #tb-sys-wrap und #tb-prod-img) ── */
  function wireTopbar() {
    var tries = 0;
    var tick = function () {
      var sys = document.getElementById('tb-sys-wrap');
      var img = document.getElementById('tb-prod-img');
      var wired = 0;
      [sys, img].forEach(function (el) {
        if (!el || el.dataset.mcWired) return;
        el.style.cursor = 'pointer';
        el.setAttribute('role', 'button');
        el.setAttribute('tabindex', '0');
        el.setAttribute('aria-label', 'Warenkorb \u00f6ffnen');
        el.addEventListener('click', function (e) { e.preventDefault(); open(); });
        el.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); }
        });
        el.dataset.mcWired = '1';
        wired++;
      });
      tries++;
      if (!(sys && img) && tries < 30) setTimeout(tick, 250);
    };
    tick();
  }

  function init() {
    injectCSS();
    wireTopbar();
    wireGlobalAddToCart();
  }

  /* Aktion Paket 2, Nachbesserung 04.10. (Prüfung Technik S2): Wechselt die Aktionsphase, während
     die Schublade offen ist (13.11. 0:00 bzw. 01.12. 0:00), Warenkorb neu holen und neu zeichnen —
     „Normalpreis“ / Aktionsname / Pflichtangabe verschwinden bzw. erscheinen ohne Neuladen.
     Bewusst ohne refresh(): keine product:added-/cart:*-Ereignisse an andere Teile der Seite.
     IIFE 1: document., nie d. */
  try {
    document.addEventListener('iso:aktion', function () {
      if (!_open) return;
      try { fetchCart().then(function (c) { _cartData = c; renderCart(c); }, function () {}); } catch (_eAkR) {}
    });
  } catch (_eAkL) {}

  w.IsoDashMiniCart = {
    open: open,
    close: close,
    refresh: refresh,
    init: init,
    openAfterAdd: openAfterAdd,
    addAndOpen: addAndOpen,
    markUserAddIntent: markUserAddIntent,
    consumeUserAddIntent: consumeUserAddIntent,
    hasUserAddIntent: hasUserAddIntent,

    /* v528 — Notschalter fuer das Layout.
       In der Konsole:  __ISO_DRAWER__.set('v1')   bzw.  .set('v2')
       Wirkt sofort: Klasse tauschen, neu zeichnen, Wahl merken. Kein
       Neuladen noetig, kein Upload. .get() sagt, was gerade laeuft. */
    setLayout: function (v) {
      if (v !== 'v1' && v !== 'v2') { return layoutLesen(); }
      _layout = v;
      try { w.localStorage.setItem(LAYOUT_KEY, v); } catch (e) {}
      try {
        var el = document.getElementById(PANEL_ID);
        if (el) { el.className = (v === 'v2') ? 'is-v2' : 'is-v1'; }
      } catch (e2) {}
      try { refresh(); } catch (e3) {}
      return v;
    },
    getLayout: layoutLesen
  };

  /* Kurzer Name fuer die Konsole — damit Bjoern im Zweifel nicht den langen
     Modulnamen tippen muss. */
  try {
    w.__ISO_DRAWER__ = {
      set: function (v) { return w.IsoDashMiniCart.setLayout(v); },
      get: function () { return layoutLesen(); }
    };
  } catch (eG) {}

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})(window);

/* v304: klarer Alias (Datei heißt jetzt iso-cart-drawer.js; globaler Name bleibt für Rückwärts-Kompatibilität) */
try { window.IsoCartDrawer = window.IsoDashMiniCart; } catch (_) {}

/* v520 (Bjoern 07.09.): Warenkorb per Link oeffnen — ?warenkorb=auf an Links aus den
   Klaviyo-Mails (Trocknungs-Guide). Wer aus der Mail zurueckkommt, sieht sofort seinen
   Warenkorb wieder. Nur Desktop (> 520 px: mobil ist der Drawer Vollbild und wuerde die
   Seite verdecken) und nur, wenn wirklich etwas drinliegt. Bewusst `document`/`window`
   (eigene IIFE, kein `d`). Parameter danach aus der URL nehmen, damit Reload/Teilen sauber bleibt. */
(function () {
  try {
    if (!/[?&]warenkorb=auf(?:&|$)/.test(window.location.search || '')) return;
    var cleanUrl = function () {
      try { var u = new URL(window.location.href); u.searchParams.delete('warenkorb'); window.history.replaceState(null, '', u.pathname + u.search + u.hash); } catch (_e) {}
    };
    if ((window.innerWidth || 0) <= 520) { cleanUrl(); return; }
    var go = function () {
      cleanUrl();
      if (typeof window.fetch !== 'function') return;
      window.fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
        if (!cart || !cart.item_count) return;
        if (window.IsoDashMiniCart && typeof window.IsoDashMiniCart.open === 'function') {
          window.IsoDashMiniCart.open();
          try { if (typeof window.isoTrack === 'function') window.isoTrack('cart_drawer_open_link', {}); } catch (_t) {}
        }
      }).catch(function () {});
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(go, 900); });
    else setTimeout(go, 900);
  } catch (_) {}
})();

/* ════════════════════════════════════════════════════════════════
   v304 — Gratis-Handbuch (Auto-Add ab 199 € · v310.8, war 200 €) + Messgerät-Upsell
   Self-contained Engine für DIESEN Drawer. Definiert window.IsoGift (von der
   Render-Logik oben genutzt), legt das Handbuch (0-€-Variante) automatisch
   rein/raus, behandelt das Messgerät-„+ Hinzufügen", setzt den „Gratis-Handbuch
   dabei"-Banner auf der Kalkulator-Endseite, und refresht den eigenen Drawer.
   Konfig optional via window.ISO_GIFT_CONFIG.
   ════════════════════════════════════════════════════════════════ */
(function (w, d) {
  'use strict';
  var CFG = (w.ISO_GIFT_CONFIG && typeof w.ISO_GIFT_CONFIG === 'object') ? w.ISO_GIFT_CONFIG : {};
  function num(v, def) { return (v != null && isFinite(v)) ? Number(v) : def; }

  var ENABLED          = CFG.enabled !== false;
  var GIFT_VID         = String(CFG.giftVariantId       || '57299982582133');
  var MG_VID           = String(CFG.messgeraetVariantId || '55611265712501');
  var THRESHOLD        = Math.round(num(CFG.thresholdEuro, 199) * 100); /* v310.8: Gratis-Handbuch ab 199 € (war 200 €) */
  var GIFT_VALUE_CENTS = Math.round(num(CFG.giftValueEuro, 29.90) * 100);
  var MG_OFFER_CENTS   = Math.round(num(CFG.messgeraetOfferEuro, 49) * 100);
  var MG_REG_CENTS     = Math.round(num(CFG.messgeraetRegularEuro, 79) * 100);
  var MG_IMG           = CFG.messgeraetImg || 'https://cdn.shopify.com/s/files/1/0846/5550/5691/files/messgeraet-isofin-1080px.jpg?v=1752249558&width=120';
  var GIFT_TITLE       = CFG.giftTitle || '+ Isofin®-Handbuch · 108 S.';
  var GIFT_TITLE_FULL  = CFG.giftTitleFull || '+ Isofin®-Handbuch · 108 Seiten';
  var GIFT_DESC        = CFG.giftDesc  || '65 Jahre Erfahrung vom Erfinder';
  var GIFT_IMG         = CFG.giftImg   || 'https://cdn.shopify.com/s/files/1/0846/5550/5691/files/2026-isofin-anwendungsbuch-produktbild-200px.jpg?v=1780939298&width=110';
  var ACTIVE_UNTIL     = CFG.activeUntil || null;
  /* v305: Messgerät-Angebot vorerst AUS (nur Gratis-Handbuch). Reaktivieren: window.ISO_GIFT_CONFIG.messgeraetOffer = true */
  var MG_OFFER_ENABLED = CFG.messgeraetOffer === true;

  var ROOT = '/'; try { if (w.Shopify && w.Shopify.routes && w.Shopify.routes.root) ROOT = w.Shopify.routes.root; } catch (_) {}
  if (ROOT.charAt(ROOT.length - 1) !== '/') ROOT += '/';

  var _busy = false, _timer = null, _lastCart = null, _mgSeen = false;
  var _pending = false;   /* v512: siehe reconcile() */

  function euro(c) { return (Number(c || 0) / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'; }
  function track(n, da) { try { if (typeof w.isoTrack === 'function') w.isoTrack(n, da || {}); } catch (_) {} }
  function isActive() {
    if (!ENABLED) return false;
    if (ACTIVE_UNTIL) { try { var e = new Date(ACTIVE_UNTIL + 'T23:59:59'); if (isFinite(e.getTime()) && new Date() > e) return false; } catch (_) {} }
    return true;
  }
  function isGift(it) {
    if (it && String(it.variant_id || '') === GIFT_VID) return true;
    var p = it && it.properties; if (!p) return false;
    if (Array.isArray(p)) { for (var i = 0; i < p.length; i++) { if (p[i] && p[i][0] === '_iso_gift' && p[i][1]) return true; } return false; }
    return !!p._iso_gift;
  }
  function findGift(cart) { if (!cart || !cart.items) return null; for (var i = 0; i < cart.items.length; i++) { if (isGift(cart.items[i])) return cart.items[i]; } return null; }
  function hasVariant(cart, vid) { if (!cart || !cart.items) return false; for (var i = 0; i < cart.items.length; i++) { if (String(cart.items[i].variant_id || '') === String(vid)) return true; } return false; }
  function qualifying(cart) {
    if (!cart || !cart.items) return 0;
    var s = 0;
    for (var i = 0; i < cart.items.length; i++) { var it = cart.items[i]; if (isGift(it)) continue; s += (it.final_line_price != null ? it.final_line_price : (it.line_price || 0)); }
    return s;
  }

  function getCart() { return fetch(ROOT + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r && r.ok ? r.json() : null; }).catch(function () { return null; }); }
  function addGift() { return fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ items: [{ id: Number(GIFT_VID) || GIFT_VID, quantity: 1, properties: { _iso_gift: '1' } }] }) }).then(function (r) { return r && r.ok ? r.json() : null; }); }
  function addMg() { return fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ items: [{ id: Number(MG_VID) || MG_VID, quantity: 1 }] }) }).then(function (r) { return r && r.ok ? r.json() : null; }); }
  function removeKey(k) { return fetch(ROOT + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ id: k, quantity: 0 }) }).then(function (r) { return r && r.ok ? r.json() : null; }); }
  function drawerRefresh() { try { if (w.IsoDashMiniCart && typeof w.IsoDashMiniCart.refresh === 'function') return w.IsoDashMiniCart.refresh(); } catch (_) {} return null; }

  function offerHTML(cart) {
    if (!MG_OFFER_ENABLED) return '';            /* v305: Messgerät-Angebot vorerst AUS */
    if (!isActive() || !cart) return '';
    if (hasVariant(cart, MG_VID)) return '';
    var qual = qualifying(cart);
    var bridges = (qual < THRESHOLD) && ((qual + MG_OFFER_CENTS) >= THRESHOLD);
    var sub = bridges
      ? '<span class="iso-mg-bridge">+ ' + euro(MG_OFFER_CENTS) + ' &rarr; schaltet Ihr <b>Gratis-Handbuch</b> frei</span>'
      : 'Feuchte pr&uuml;fen &amp; Trocknung kontrollieren';
    if (!_mgSeen) { _mgSeen = true; track('messgeraet_offer_view', {}); }
    return '<div class="iso-mg-offer">' +
        '<div class="iso-mg-ttl">Messger&auml;t dazubestellen?</div>' +
        '<div class="iso-mg-sub">' + sub + '</div>' +
        '<div class="iso-mg-foot">' +
          '<img class="iso-mg-img" src="' + MG_IMG + '" alt="" loading="lazy">' +
          '<div class="iso-mg-price"><s>' + euro(MG_REG_CENTS) + '</s> <b>' + euro(MG_OFFER_CENTS) + '</b></div>' +
          '<button type="button" class="iso-mg-add" data-iso-offer-add="messgeraet">+ Hinzuf&uuml;gen</button>' +
        '</div>' +
      '</div>';
  }

  /* ─────────────────────────────────────────────────────────────────
     v512 (Björn 01.09.): Nach dem Verringern der Flaschenmenge blieb das
     Gratis-Handbuch lange im Warenkorb liegen. Zwei Ursachen:

     1. FEHLER — reconcile() verwarf jeden Aufruf, der auf einen laufenden
        Durchgang traf, und holte ihn nie nach. Zwei schnelle Klicks auf „−"
        und die zweite Änderung ging komplett verloren; das Handbuch blieb
        stehen, bis zufällig ein anderes Ereignis die Engine anstieß.
        → _pending merkt sich das und zieht einmal nach.

     2. LEERLAUF — after() holte den Warenkorb neu, obwohl change.js ihn
        bereits als Antwort zurückgibt.
        → Antwort weiterreichen statt neu laden.

     BEWUSST NICHT GEMACHT: die eigenen Ereignisse nach drawerRefresh() zu
     unterdrücken. Das spart zwar einen weiteren Durchgang, verschluckt aber
     genauso einen echten zweiten Klick des Nutzers — also derselbe Fehler in
     neuer Form. Der eine Leerlauf-Durchgang bleibt, er kostet einen GET.

     Nichts davon lädt zusätzlich etwas; es fällt nur Arbeit weg.
     ───────────────────────────────────────────────────────────────── */
  function schedule() { if (_timer) return; _timer = w.setTimeout(function () { _timer = null; reconcile(); }, 120); }
  function reconcile() {
    if (_busy) { _pending = true; return; }
    _busy = true;
    getCart().then(function (cart) {
      _lastCart = cart;
      if (!cart || !cart.items) { done(); return; }
      var gift = findGift(cart), qual = qualifying(cart);
      /* v513 (#2981: zwei Gratis-Handbücher): add.js ADDIERT bei Shopify die Menge,
         wenn Variante und Eigenschaften gleich sind. Läuft die Prüfung überlappend
         (z.B. während der Kalkulator Zeilen löscht und neu anlegt), kann so ein
         zweites Handbuch entstehen. Mehr als eins wird hier auf eins gesetzt —
         egal, woher es kam. */
      if (gift && Number(gift.quantity) > 1) {
        fetch(ROOT + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin',
              body: JSON.stringify({ id: gift.key, quantity: 1 }) })
          .then(function (r) { return r && r.ok ? r.json() : null; })
          .then(function (c) { track('gwp_handbuch_dedupe', { war: gift.quantity }); after(c); }, fail);
        return;
      }
      if (!isActive()) { if (gift) { removeKey(gift.key).then(after, fail); return; } banner(); done(); return; }
      if (qual >= THRESHOLD && !gift) { addGift().then(function () { track('gwp_handbuch_added', { qualifying: Math.round(qual / 100) }); after(); }, fail); }
      else if (qual < THRESHOLD && gift) { removeKey(gift.key).then(after, fail); }
      else { banner(); done(); }
    }, fail);
    /* change.js liefert den neuen Warenkorb als Antwort mit. add.js tut das
       nicht — dort greift der Rückfall auf getCart(). */
    function after(neu) {
      var quelle = (neu && neu.items) ? Promise.resolve(neu) : getCart();
      quelle.then(function (c) { if (c && c.items) _lastCart = c; return drawerRefresh(); })
            .then(function () { banner(); done(); }, done);
    }
    function fail() { done(); }
    function done() {
      _busy = false;
      if (_pending) { _pending = false; schedule(); }
    }
  }

  function banner() {
    /* Geschenk-Karte direkt UNTER den Isofin-Eintrag im Sanierungspaket (sec-03). */
    var rows = d.querySelectorAll('.isocal-s6s3-product-row'); if (!rows.length) return;
    var on = isActive() && _lastCart && !!findGift(_lastCart);
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i], next = row.nextElementSibling;
      var ex = (next && next.classList && next.classList.contains('iso-gift-banner')) ? next : null;
      if (on && !ex) {
        var g = _lastCart && findGift(_lastCart);
        var img = (g && g.image) ? g.image : GIFT_IMG;
        var b = d.createElement('div'); b.className = 'iso-gift-banner';
        /* v496: auch hier nicht mehr die ganze Flaeche — nur der Link unten. */
        b.innerHTML =
          '<img class="iso-gift-banner-img" src="' + img + '" alt="" loading="lazy" width="52" height="52">' +
          '<div class="iso-gift-banner-main">' +
            '<div class="iso-gift-banner-ttl">' + GIFT_TITLE_FULL + '</div>' +
            '<div class="iso-gift-banner-sub">' + GIFT_DESC + ' · <span class="iso-gift-banner-toc" data-iso-toc="1">Inhalt ansehen ›</span></div>' +
          '</div>' +
          '<div class="iso-gift-banner-price">' +
            '<s>' + euro(GIFT_VALUE_CENTS) + '</s>' +
            '<span class="iso-gift-banner-free"><span class="iso-gift-banner-ic" aria-hidden="true">✓</span>Gratis</span>' +
          '</div>';
        if (row.parentNode) row.parentNode.insertBefore(b, row.nextSibling);
      } else if (!on && ex) { ex.parentNode.removeChild(ex); }
    }
  }

  d.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-iso-offer-add="messgeraet"]');
    if (!btn) return;
    e.preventDefault();
    if (_busy) return;
    _busy = true; btn.disabled = true;
    var qb = qualifying(_lastCart || { items: [] });
    addMg().then(function () {
      track('messgeraet_added', {});
      if (qb < THRESHOLD && (qb + MG_OFFER_CENTS) >= THRESHOLD) track('gwp_unlock_via_messgeraet', {});
      _busy = false; reconcile();
      try { if (w.IsoDashMiniCart && w.IsoDashMiniCart.open) w.IsoDashMiniCart.open(); } catch (_) {}
    }, function () { _busy = false; btn.disabled = false; });
  });

  /* ── Inhaltsverzeichnis-Overlay (Klick auf Geschenk/Handbuch) ── */
  var TOC_CHAPTERS = [
    { ic: '📚', t: '1. Grundlagen & Theorie',
      p: 'Warum feuchte Wände über Jahrtausende normal waren — und wie sich das mit der Bauphysik des 20. Jahrhunderts geändert hat.',
      items: ['Geschichte der Bauwerks-Abdichtung', 'Physik der Kapillarfeuchte — wie Wasser im Mauerwerk hochsteigt', 'Aufsteigende Feuchtigkeit & Querdurchfeuchtung', 'Druckwasser-Schäden erkennen', 'Kondensat und Hygroskopik', 'Grundbegriffe (Diffusion, Kapillarität, w-/μ-Wert)'] },
    { ic: '⚖️', t: '2. Sperren im Vergleich — Methoden-Übersicht',
      p: 'Ehrlicher Vergleich aller verbreiteten Sperr-Methoden mit Vor- und Nachteilen.',
      items: ['Mechanische Sperren (Edelstahlplatten, Mauersäge)', 'Negativ-Abdichtungen (Sperr-/Sanierputze)', 'Elektroosmose & Funkelektroosmose', 'Verkieselungssperren (Wasserglas)', 'Silikonat-Sperren', 'Wässrige Gel-Sperren', 'Mikroemulsion', 'Isofin (porenoffene Hydrophobierung)', 'Vergleichstabelle: Dauer, Kosten, Aufwand'] },
    { ic: '🔧', t: '3. Wirkung & praktische Anwendung von Isofin',
      p: 'Wie Isofin im Mauerwerk wirkt, wie die Wand danach trocknet und welche Effekte sich ergeben.',
      items: ['Wirkung & Anwendung — chemisch-physikalisch', 'Wie und wodurch die Wand trocknet', 'Trocknungs-Geschwindigkeit (Wochen bis Monate)', 'Isofin erhöht die Wärmedämmung', 'Was „porenoffen“ bedeutet', 'Wirkungstiefe im Mauerwerk'] },
    { ic: '🏠', t: '4. Feuchtigkeit im Keller – alle Fälle',
      p: 'Systematische Diagnose: welche Art Feuchtigkeit liegt vor und welche Maßnahme ist die richtige?',
      items: ['Messung der Feuchteursache', 'Aufsteigende Feuchtigkeit', 'Querfeuchte aus dem Erdreich', 'Druckwasser', 'Kondensat', 'Hygroskopische Feuchte', 'Leitungswasser-Schäden', 'Häufige Diagnose-Fehler', 'Innensanierung vs. Außenabdichtung'] },
    { ic: '🛠️', t: '5. Erstellung der Isofin-Sperre – Schritt für Schritt',
      p: 'Die praktische Anleitung für Selbstanwender — vom Bohrplan bis zur Nachkontrolle.',
      items: ['Werkzeug-Checkliste', 'Wand vorbereiten — Putz entfernen oder nicht?', 'Bohrplan erstellen (Abstände, Reihen, Winkel)', 'Bohren (Tiefe ~2/3 Wanddicke)', 'Injektion durchführen', 'Material-Verbrauch berechnen', 'Bohrlöcher verschließen', 'Nachkontrolle mit Messgerät', 'Wann eine zweite Behandlung sinnvoll ist'] },
    { ic: '🧱', t: '6. Spezielle Materialien & Bauweisen',
      p: 'Was, wenn das Mauerwerk nicht aus klassischem Ziegel besteht?',
      items: ['Geeignete & ungeeignete Putze', 'Behandelbare Steine (Ziegel, KS, Naturstein, Beton)', 'Welches Mauerwerk hydrophobiert werden kann', 'Isofin in Beton-Wänden', 'Mischmauerwerk', 'Sandstein, Tuffstein, Kalkstein', 'Sehr dicke Wände (>60 cm) & Bruchstein'] },
    { ic: '🔲', t: '7. Flächensperren im Keller',
      p: 'Wenn nicht nur aufsteigende Feuchte das Problem ist, sondern auch Querfeuchte durch die Wandfläche.',
      items: ['Wann eine Flächensperre nötig ist', 'Bohrloch-Verteilung in der Fläche', 'Material-Mengen je Wandstärke', 'Zeitlicher Ablauf', 'Wann eine halbe Flächensperre reicht', 'Kombination mit Außenabdichtung'] },
    { ic: '🏡', t: '8. Wohnbereich oberhalb des Erdreichs',
      p: 'Feuchteschäden gibt es nicht nur im Keller — Sockel, Hochwasser, Spritzwasser.',
      items: ['Fehler im nichtunterkellerten Bereich', 'Sockelbereich von außen behandeln', 'Hochwasser-Schäden', 'Spritzwasserzonen', 'Sanierung ohne Möbel auszuräumen', 'Wohnzimmer, Bad, Küche'] },
    { ic: '❌', t: '9. Fehler vermeiden & Hilfe',
      p: 'Die häufigsten Fallen für Selbstanwender — und wie Sie sie vermeiden.',
      items: ['Häufig gestellte Fragen', 'Fehlerübersichten', 'Praxisbeispiele aus 55+ Jahren', 'Die 10 typischen Anwender-Fehler', 'Wann professionelle Hilfe sinnvoll ist', 'Wer hilft bei Problemen', 'Reklamation & Garantie'] },
    { ic: '🆘', t: '10. Service & Anhang',
      p: 'Alles für den schnellen Zugriff: Kontakt, Garantie, Literatur.',
      items: ['Hotline & WhatsApp-Expertencheck', 'Direkter Kontakt zu Hendrik Flügge', 'Rückruf-Service', 'Garantie-Bedingungen', 'Ersatzteile & Nachkauf', 'Glossar der Fachbegriffe', 'Weiterführende Literatur', 'Quellenverzeichnis'] }
  ];
  function injectTocCss() {
    if (d.getElementById('iso-toc-css')) return;
    var s = d.createElement('style'); s.id = 'iso-toc-css';
    s.textContent =
      '#iso-toc-ov{position:fixed;inset:0;z-index:2147483000;visibility:hidden;opacity:0;transition:opacity .2s ease,visibility .2s;font-family:Rubik,-apple-system,sans-serif}' +
      '#iso-toc-ov.open{visibility:visible;opacity:1}' +
      '#iso-toc-ov .iso-toc-bd{position:absolute;inset:0;background:rgba(0,0,0,.55)}' +
      '#iso-toc-ov .iso-toc-panel{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%) scale(.98);width:min(520px,92vw);max-height:86vh;display:flex;flex-direction:column;background:#fff;border-radius:18px;overflow:hidden;box-shadow:0 24px 60px rgba(0,0,0,.32);transition:transform .2s ease}' +
      '#iso-toc-ov.open .iso-toc-panel{transform:translate(-50%,-50%) scale(1)}' +
      '#iso-toc-ov .iso-toc-head{display:flex;align-items:center;justify-content:space-between;gap:14px;padding:15px 20px;background:linear-gradient(180deg,#0f6e56,#0c5b47);color:#fff;flex-shrink:0}' +
      '#iso-toc-ov .iso-toc-htitle{font-size:17px;font-weight:700}' +
      '#iso-toc-ov .iso-toc-x{width:34px;height:34px;border:none;border-radius:10px;background:rgba(255,255,255,.18);color:#fff;font-size:20px;cursor:pointer;display:flex;align-items:center;justify-content:center;flex-shrink:0}' +
      '#iso-toc-ov .iso-toc-body{padding:20px;overflow-y:auto;-webkit-overflow-scrolling:touch}' +
      '#iso-toc-ov .iso-toc-cover{display:flex;gap:14px;align-items:center;margin:0 0 12px}' +
      '#iso-toc-ov .iso-toc-cover-img{width:76px;height:auto;max-height:104px;flex:none;border-radius:8px;object-fit:contain;background:#fff;box-shadow:0 2px 10px rgba(0,0,0,.18)}' +
      '#iso-toc-ov .iso-toc-cover-txt{min-width:0}' +
      '#iso-toc-ov .iso-toc-h2{font-size:19px;font-weight:800;color:#1a1a1a;margin:0 0 4px;line-height:1.2}' +
      '#iso-toc-ov .iso-toc-sub{font-size:13.5px;color:#0f6e56;font-weight:600;margin:0}' +
      '#iso-toc-ov .iso-toc-intro{font-size:14px;line-height:1.5;color:#555;margin:0 0 14px}' +
      '#iso-toc-ov .iso-toc-list{margin:0;padding:0}' +
      '#iso-toc-ov .iso-toc-acc{border-bottom:1px solid rgba(0,0,0,.07)}' +
      '#iso-toc-ov .iso-toc-acc:last-child{border-bottom:none}' +
      '#iso-toc-ov .iso-toc-sum{list-style:none;display:flex;align-items:center;gap:11px;padding:13px 2px;cursor:pointer;font-size:14.5px;font-weight:700;color:#1a1a1a}' +
      '#iso-toc-ov .iso-toc-sum::-webkit-details-marker{display:none}' +
      '#iso-toc-ov .iso-toc-ico{font-size:18px;flex:none;width:24px;text-align:center}' +
      '#iso-toc-ov .iso-toc-sumtxt{flex:1;min-width:0;line-height:1.3}' +
      '#iso-toc-ov .iso-toc-chev{flex:none;color:#0f6e56;font-size:13px;transition:transform .2s ease}' +
      '#iso-toc-ov .iso-toc-acc[open] .iso-toc-chev{transform:rotate(180deg)}' +
      '#iso-toc-ov .iso-toc-cbody{padding:0 2px 14px 39px}' +
      '#iso-toc-ov .iso-toc-cintro{font-size:13px;line-height:1.5;color:#666;margin:0 0 8px}' +
      '#iso-toc-ov .iso-toc-ul{margin:0;padding:0 0 0 18px;display:flex;flex-direction:column;gap:5px}' +
      '#iso-toc-ov .iso-toc-ul li{font-size:13.5px;line-height:1.45;color:#333}' +
      '@media (max-width:600px){' +
        '#iso-toc-ov .iso-toc-panel{left:0;top:auto;bottom:0;transform:translateY(100%);width:100%;max-width:100%;max-height:90vh;border-radius:18px 18px 0 0}' +
        '#iso-toc-ov.open .iso-toc-panel{transform:translateY(0)}' +
        '#iso-toc-ov .iso-toc-sum{font-size:15.5px}' +
        '#iso-toc-ov .iso-toc-ul li{font-size:14.5px}' +
      '}';
    d.head.appendChild(s);
  }
  function openToc() {
    injectTocCss();
    var ov = d.getElementById('iso-toc-ov');
    if (!ov) {
      ov = d.createElement('div'); ov.id = 'iso-toc-ov';
      var listH = TOC_CHAPTERS.map(function (c) {
        var lis = c.items.map(function (it) { return '<li>' + it + '</li>'; }).join('');
        return '<details class="iso-toc-acc">' +
          '<summary class="iso-toc-sum"><span class="iso-toc-ico">' + c.ic + '</span><span class="iso-toc-sumtxt">' + c.t + '</span><span class="iso-toc-chev" aria-hidden="true">▾</span></summary>' +
          '<div class="iso-toc-cbody"><p class="iso-toc-cintro">' + c.p + '</p><ul class="iso-toc-ul">' + lis + '</ul></div>' +
        '</details>';
      }).join('');
      var coverImg = String(GIFT_IMG).replace(/([?&])width=\d+/, '$1width=220');
      ov.innerHTML =
        '<div class="iso-toc-bd" data-iso-toc-close="1"></div>' +
        '<div class="iso-toc-panel" role="dialog" aria-modal="true" aria-label="Inhaltsverzeichnis">' +
          '<div class="iso-toc-head"><div class="iso-toc-htitle">📖 Isofin®-Handbuch</div>' +
            '<button class="iso-toc-x" data-iso-toc-close="1" aria-label="Schließen">×</button></div>' +
          '<div class="iso-toc-body">' +
            '<div class="iso-toc-cover">' +
              '<img class="iso-toc-cover-img" src="' + coverImg + '" alt="Isofin®-Handbuch" loading="lazy">' +
              '<div class="iso-toc-cover-txt">' +
                '<div class="iso-toc-h2">Vollständiges Inhaltsverzeichnis</div>' +
                '<div class="iso-toc-sub">108 Seiten · 65 Jahre Erfahrung vom Erfinder</div>' +
              '</div>' +
            '</div>' +
            '<p class="iso-toc-intro">10 Kapitel — von den Grundlagen über die Wirkung bis zu speziellen Materialien und FAQs.</p>' +
            '<div class="iso-toc-list">' + listH + '</div>' +
          '</div>' +
        '</div>';
      d.body.appendChild(ov);
      ov.addEventListener('click', function (e) { if (e.target.closest('[data-iso-toc-close]')) closeToc(); });
    }
    d.body.style.overflow = 'hidden';
    w.requestAnimationFrame(function () { ov.classList.add('open'); });
    try { track('handbuch_toc_open', {}); } catch (e) {}
  }
  function closeToc() {
    var ov = d.getElementById('iso-toc-ov');
    if (ov) ov.classList.remove('open');
    /* Scroll-Lock nur lösen, wenn der Warenkorb-Drawer NICHT offen ist. */
    var mc = d.getElementById('isodash-mini-cart');
    d.body.style.overflow = (mc && mc.classList.contains('mc-open')) ? 'hidden' : '';
  }
  d.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-iso-toc]')) { e.preventDefault(); openToc(); }
  });
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeToc(); });

  ['cart:updated', 'cart:refresh', 'isofin:cartUpdated', 'isofin:cart-updated', 'product:added'].forEach(function (ev) { d.addEventListener(ev, schedule); });
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', reconcile); else reconcile();

  /* Step-4 (Ergebnisseite) wird nach der Berechnung dynamisch gerendert. Sobald das
     CTA frisch ins DOM kommt, reconcile() nachziehen → Geschenk + Banner ohne Reload. */
  (function () {
    if (!w.MutationObserver || !d.body) return;
    var mo = new w.MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (!n || n.nodeType !== 1) continue;
          if ((n.matches && n.matches('.isocal-s6s3-product-row')) ||
              (n.querySelector && n.querySelector('.isocal-s6s3-product-row'))) { schedule(); return; }
        }
      }
    });
    mo.observe(d.body, { childList: true, subtree: true });
  })();

  (function () {
    if (d.getElementById('iso-gift-css')) return;
    var I = ' !important', mc = '#isodash-mini-cart ';
    var st = d.createElement('style'); st.id = 'iso-gift-css';
    st.textContent = [
      /* v496.3: cursor:pointer raus — die Zeile ist seit v496 kein Knopf mehr,
         die Hand versprach eine Aktion, die es hier nicht gibt. */
      mc + '.mc-item--gift{border-color:#0f6e56' + I + ';border-width:1.5px' + I + ';background:rgba(29,158,117,.07)' + I + ';padding:12px' + I + '}',
      mc + '.mc-item--gift:hover{background:rgba(29,158,117,.12)' + I + '}',
      mc + '.mc-gift-toc{display:inline-flex' + I + ';align-items:center' + I + ';gap:3px' + I + ';background:none' + I + ';border:none' + I + ';padding:0' + I + ';margin:3px 0 6px' + I + ';font-family:inherit' + I + ';font-size:12px' + I + ';font-weight:600' + I + ';color:#0f6e56' + I + ';text-decoration:underline' + I + ';text-underline-offset:2px' + I + ';cursor:pointer' + I + '}',
      mc + '.mc-item--gift .mc-thumb{width:56px' + I + ';height:56px' + I + '}',
      mc + '.mc-item--gift .mc-item-main{grid-template-columns:56px 1fr' + I + ';gap:11px' + I + '}',
      mc + '.mc-gift-flag{display:flex' + I + ';align-items:center' + I + ';gap:5px' + I + ';background:#0f6e56' + I + ';color:#fff' + I + ';font-size:13px' + I + ';font-weight:700' + I + ';letter-spacing:.03em' + I + '' + I + ';padding:6px 10px' + I + ';border-radius:8px' + I + ';margin:0 0 9px' + I + ';line-height:1.2' + I + '}',
      mc + '.mc-item--gift .mc-name{font-size:13.5px' + I + ';font-weight:700' + I + '}',
      mc + '.mc-gift-desc{font-size:11.5px' + I + ';color:var(--ds-text-muted,#666)' + I + ';margin:2px 0 5px' + I + ';line-height:1.3' + I + '}',
      mc + '.mc-price--gift{display:flex' + I + ';align-items:baseline' + I + ';justify-content:flex-end' + I + ';gap:8px' + I + ';text-align:right' + I + '}',
      mc + '.mc-gift-was{color:var(--ds-text-muted,#9aa0a6)' + I + ';text-decoration:line-through' + I + ';font-weight:400' + I + ';font-size:15px' + I + '}',
      mc + '.mc-gift-free{color:#0f6e56' + I + ';font-weight:800' + I + ';font-size:17px' + I + ';letter-spacing:-.01em' + I + '}',
      mc + '.iso-mg-offer{margin:12px 0 2px' + I + ';padding:10px 12px' + I + ';border:2px solid #D6001C' + I + ';border-radius:13px' + I + ';background:#fff' + I + '}',
      mc + '.iso-mg-ttl{font-size:13.5px' + I + ';font-weight:700' + I + ';color:var(--ds-text,#111)' + I + ';line-height:1.25' + I + '}',
      mc + '.iso-mg-sub{font-size:11.5px' + I + ';color:var(--ds-text-muted,#666)' + I + ';margin:2px 0 8px' + I + ';line-height:1.3' + I + '}',
      mc + '.iso-mg-bridge{color:#D6001C' + I + ';font-weight:600' + I + '}',
      mc + '.iso-mg-foot{display:flex' + I + ';align-items:center' + I + ';gap:10px' + I + '}',
      mc + '.iso-mg-img{width:34px' + I + ';height:34px' + I + ';border-radius:6px' + I + ';object-fit:cover' + I + ';flex:none' + I + ';box-shadow:0 0 0 1px rgba(0,0,0,.06)' + I + '}',
      mc + '.iso-mg-price{flex:1' + I + ';min-width:0' + I + ';font-size:13px' + I + ';line-height:1.15' + I + ';display:flex' + I + ';flex-direction:column' + I + '}',
      mc + '.iso-mg-price s{color:var(--ds-text-muted,#9aa0a6)' + I + ';font-weight:400' + I + ';margin:0' + I + '}',
      mc + '.iso-mg-price b{color:#D6001C' + I + ';font-weight:800' + I + ';font-size:16px' + I + '}',
      mc + '.iso-mg-add{flex:none' + I + ';background:#D6001C' + I + ';color:#fff' + I + ';border:0' + I + ';border-radius:10px' + I + ';padding:11px 15px' + I + ';font-size:13px' + I + ';font-weight:700' + I + ';cursor:pointer' + I + ';font-family:inherit' + I + ';white-space:nowrap' + I + '}',
      mc + '.iso-mg-add:disabled{opacity:.6' + I + ';cursor:default' + I + '}',
      '.iso-gift-banner{display:flex;align-items:center;gap:13px;text-align:left;background:rgba(29,158,117,.10);border:1px solid rgba(29,158,117,.30);border-radius:13px;padding:13px;margin:12px 0 4px;line-height:1.25}',
      '.iso-gift-banner:hover{background:rgba(29,158,117,.16)}',
      '.iso-gift-banner-img{width:52px;height:52px;flex:none;border-radius:9px;object-fit:cover;background:#fff}',
      '.iso-gift-banner-main{flex:1;min-width:0;display:flex;flex-direction:column;gap:3px}',
      '.iso-gift-banner-ttl{font-size:14px;font-weight:700;color:#0f3d30;line-height:1.25}',
      '.iso-gift-banner-row{display:flex;align-items:flex-end;gap:11px}',
      '.iso-gift-banner-sub{font-size:12px;color:#4a6b5e;line-height:1.35}',
      '.iso-gift-banner-toc{color:#0f6e56;font-weight:600;text-decoration:underline;text-underline-offset:2px;cursor:pointer;white-space:nowrap}',
      '.iso-gift-banner-price{flex:none;display:flex;flex-direction:column;align-items:flex-end;text-align:right;line-height:1.2}',
      '.iso-gift-banner-price s{color:#9aa0a6;font-weight:400;font-size:14px}',
      '.iso-gift-banner-free{display:flex;align-items:center;gap:3px;font-size:14px;font-weight:700;color:#0f6e56}',
      '.iso-gift-banner-ic{font-weight:700;font-size:14px}'
    ].join('');
    (d.head || d.documentElement).appendChild(st);
  })();

  w.IsoGift = {
    isGiftItem: isGift,
    offerHTML: offerHTML,
    openToc: openToc,
    isActive: isActive,
    config: { GIFT_VID: GIFT_VID, MG_VID: MG_VID, THRESHOLD: THRESHOLD, GIFT_VALUE_CENTS: GIFT_VALUE_CENTS, GIFT_TITLE: GIFT_TITLE, GIFT_DESC: GIFT_DESC }
  };
})(window, document);
